import type { GraphQLClient, RequestOptions } from 'graphql-request';
import gql from 'graphql-tag';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
type GraphQLClientRequestHeaders = RequestOptions['requestHeaders'];
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateTime: { input: string; output: string; }
  JSONObject: { input: Record<string, unknown>; output: Record<string, unknown>; }
  Upload: { input: string; output: string; }
};

/** Address types [one of 'delivery','invoice' or 'home'] */
export enum AddressType {
  /** Delivery address */
  delivery = 'delivery',
  /** Home address */
  home = 'home',
  /** Invoice address */
  invoice = 'invoice'
}

/** Supported attribute classes. Objects from this enum can have attributes. */
export enum AttributeClass {
  contact = 'contact',
  customer = 'customer',
  product = 'product'
}

export type AttributeDescriptionSearchInput = {
  class: Scalars['String']['input'];
  /** An array of attributes groups you want to return. */
  group?: InputMaybe<Array<Scalars['String']['input']>>;
  /**
   * Only show attributes that are either hidden or not hidden.
   *     Ommmit this argument to ignore this field
   */
  isHidden?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Only show attributes that are either public or not public.
   *     Ommmit this argument to ignore this field
   */
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Only show attributes that are either searchable or not searchable.
   *     Ommmit this argument to ignore this field
   */
  isSearchable?: InputMaybe<Scalars['Boolean']['input']>;
  /** An array of attributes names you want to return. */
  name?: InputMaybe<Array<Scalars['String']['input']>>;
  offset?: Scalars['Int']['input'];
  page?: Scalars['Int']['input'];
  /** An array of attributes types you want to return. */
  type?: InputMaybe<Array<AttributeType>>;
};

export type AttributeFilterInput = {
  /** An array of attributes groups you want to return. */
  group?: InputMaybe<Array<Scalars['String']['input']>>;
  /**
   * Only show attributes that are either hidden or not hidden.
   *     Ommmit this argument to ignore this field
   */
  isHidden?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Only show attributes that are either public or not public.
   *     Ommmit this argument to ignore this field
   */
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  /**
   * Only show attributes that are either searchable or not searchable.
   *     Ommmit this argument to ignore this field
   */
  isSearchable?: InputMaybe<Scalars['Boolean']['input']>;
  /** An array of attributes names you want to return. */
  name?: InputMaybe<Array<Scalars['String']['input']>>;
  offset?: Scalars['Int']['input'];
  page?: Scalars['Int']['input'];
  /** An array of attributes types you want to return. */
  type?: InputMaybe<Array<AttributeType>>;
};

/** All attribute types */
export enum AttributeType {
  color = 'color',
  date = 'date',
  datetime = 'datetime',
  decimal = 'decimal',
  enum = 'enum',
  enumlist = 'enumlist',
  integer = 'integer',
  list = 'list',
  object = 'object',
  text = 'text'
}

export type AttributeValueObjectSearchInput = {
  /** Object class for which the search applies to. */
  class: AttributeClass;
  /** Decimal value for the attribute, required when attribute type equals decimal. */
  decimalValue?: InputMaybe<Scalars['Float']['input']>;
  /** Enumeration value for the attribute, required when type equals enum or enumlist. Values in this field can be multivalue. */
  enumValue?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Integer value for the attribute, required when attribute type equals numeric or object. */
  intValue?: InputMaybe<Scalars['Int']['input']>;
  /** Only search attributes that are either hidden or not hidden. Ommmit this argument to ignore this field */
  isHidden?: InputMaybe<Scalars['Boolean']['input']>;
  /** Only search attributes that are either public or not public. Ommmit this argument to ignore this field */
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  /** Only search attributes that are either searchable or not searchable. Ommmit this argument to ignore this field */
  isSearchable?: InputMaybe<Scalars['Boolean']['input']>;
  /** Attribute name for which the search is applied for. */
  name: Scalars['String']['input'];
  /** Textual value(s) for the attribute, required when attribute type equals text, list or color. This value is suitable for Localization. */
  textValue?: InputMaybe<LocalizedStringArrayInput>;
  /** Attribute type. */
  type: AttributeType;
};

/** Automatic image format optimization based on browser capabilities */
export enum Auto {
  /** Automatically convert image to AVIF format when the browser supports it, offering superior compression compared to WebP and other formats */
  AVIF = 'AVIF',
  /** Automatically convert image to WebP format when the browser supports it, providing better compression than JPEG or PNG while maintaining quality */
  WEBP = 'WEBP'
}

export type Base64FileInput = {
  /** The base64 representation of the file contents. */
  base64: Scalars['String']['input'];
  /** The contentType of the base64 content. */
  contentType: Scalars['String']['input'];
  /** Indication of the fileName to use when converting the base64 to a file. */
  fileName: Scalars['String']['input'];
};

export type BundleAddItemsInput = {
  /** Items for this bundle. */
  items?: InputMaybe<Array<BundleItemInput>>;
};

/** Bundle discount condition */
export enum BundleCondition {
  ALL = 'ALL',
  EP = 'EP'
}

export type BundleItemInput = {
  /** Indicates whether the product is leader for this bundle. */
  isLeader?: InputMaybe<YesNo>;
  /** The bundles primary product identifier */
  productId: Scalars['Int']['input'];
};

export type BundleSearchInput = {
  /** Bundle identifier */
  id: Scalars['Int']['input'];
  /** Tax zone */
  taxZone?: InputMaybe<Scalars['String']['input']>;
};

export type BusinessHoursInput = {
  closingTime?: InputMaybe<Scalars['String']['input']>;
  dayOfWeek: Scalars['Float']['input'];
  lunchBeakEndTime?: InputMaybe<Scalars['String']['input']>;
  lunchBeakStartTime?: InputMaybe<Scalars['String']['input']>;
  openingTime?: InputMaybe<Scalars['String']['input']>;
};

/**
 * HTTP cache control settings for media files.
 *
 *   Controls how browsers and CDNs cache the media content. Default settings provide optimal performance with public caching for 7 days.
 */
export type CacheControlInput = {
  /**
   * Maximum cache duration in seconds.
   *
   *     Specifies how long browsers and CDNs should cache the media file before checking for updates. Defaults to 604800 seconds (7 days).
   */
  maxAge?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Cache visibility and storage policy.
   *
   *     Determines whether the content can be cached by public proxies or only private caches. Defaults to 'public' for optimal CDN performance.
   */
  type?: InputMaybe<CacheControlType>;
};

/** Cache Control Type [no-store, public or none] */
export enum CacheControlType {
  /** Adds 'no-store' to the Cache Control header */
  NO_STORE = 'NO_STORE',
  /** Adds 'public' to the Cache Control header */
  PUBLIC = 'PUBLIC'
}

/**
 * Change the size of the image canvas.
 *
 * Sets the size of the image canvas, without changing the size of the image itself, which has the effect of adding space around the image.
 *
 * This parameter takes multiple values. The first two represent the desired width and height, either as measurements of pixels, separated with a comma, or as a ratio, separated with a colon. The remaining parameters allow the placement of the image within the canvas to be adjusted. On each dimension, placement can be made either with a position coordinate (x or y, which are relative to the top left of the newly-enlarged canvas) or as a percentage offset from the center of the image using offset-x and offset-y. These can be mixed and matched, but only one method can be used for each dimension (i.e., x can be combined with offset-y but x cannot be combined with offset-x).
 *
 * The remaining parameters determine the position of the cropped region.
 *
 * Offset positioning acts to distribute the remaining space according to the specified offset proportions. For example, offset-y10 would place the image so that 10% of the leftover space is above the image and 90% below it.
 *
 * Notes
 * - x and y can be set as a value in pixels (e.g., 40 is 40 pixels) or as a percentage suffixed with p (e.g., 50p is 50%).
 * - When x and y are percentages, they are calculated as percentages of the image size, not the canvas size.
 * - offset-x and offset-y are always interpreted as percentages of the canvas size (e.g., 25 is 25%).
 * - If no x, y, offset-x, or offset-y parameters are supplied, the image is positioned in the center of the canvas.
 * - The background color of the canvas will default to transparency for image output formats that support transparency and white for formats that don't. This behavior can be changed by adding the bg-color parameter.
 * - When using canvas and pad at the same time, pad will be ignored.
 * - Any fractional pixel measurements will be rounded to the nearest whole pixel.
 */
export type CanvasInput = {
  /** Height as Pixels or Percentage */
  height?: InputMaybe<Scalars['Int']['input']>;
  /** HeightRatio as Number */
  heightRatio?: InputMaybe<Scalars['Int']['input']>;
  /** X Offset as Percentage */
  offsetX?: InputMaybe<Scalars['Int']['input']>;
  /** Y Offset as Percentage */
  offsetY?: InputMaybe<Scalars['Int']['input']>;
  /** Width as Pixels or Percentage */
  width?: InputMaybe<Scalars['Int']['input']>;
  /** WidthRatio as Number */
  widthRatio?: InputMaybe<Scalars['Int']['input']>;
  /** X as Pixels or Percentage */
  x?: InputMaybe<Scalars['Int']['input']>;
  /** Y as Pixels or Percentage */
  y?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * Input data for creating a new shipping carrier.
 *
 *   Contains all required and optional information needed to establish a new carrier including service details, coverage areas, pricing, and integration settings.
 */
export type CarrierCreateInput = {
  /**
   * Localized descriptions of the carrier service for different languages and markets.
   *
   *     Collection of carrier service descriptions in various languages for international shipping options and multilingual storefronts.
   *
   *     Validation requirements:
   *     - Each description must have a unique 2-character language code (e.g., EN, DE, FR)
   *     - Language codes must be uppercase
   *     - Text values can contain up to 255 characters
   *     - Array must contain unique language codes only
   */
  descriptions: Array<LocalizedStringInput>;
  /**
   * Public URL to the carrier's logo image for branding in shipping interfaces.
   *
   *     URL pointing to the carrier's logo image used for branding in shipping options and customer-facing interfaces.
   *
   *     Validation requirements:
   *     - Must be a valid URL
   *     - Cannot exceed 255 characters
   *     - Recommended: Maximum file size of 200kB
   *     - Recommended: Dimensions of 200x200px
   */
  logo?: InputMaybe<Scalars['String']['input']>;
  /**
   * Unique name identifying the shipping carrier within your organization.
   *
   *     Official name of the shipping company or service provider used for display in shipping options and logistics management.
   *
   *     Validation requirements:
   *     - Must be unique within the organization
   *     - Cannot exceed 64 characters
   *     - Cannot be empty or contain only whitespace
   */
  name: Scalars['String']['input'];
  /**
   * Base shipping cost for this carrier (deprecated).
   *
   *     Fixed shipping cost associated with this carrier. This field is deprecated in favor of business rule builder for more flexible and complex pricing logic.
   *
   *     Validation requirements:
   *     - Must be a positive decimal value
   *     - Supports up to 5 decimal places
   */
  shippingCost: Scalars['Float']['input'];
  /**
   * URL template for package tracking and shipment monitoring.
   *
   *     URL template used to generate tracking links for packages shipped with this carrier. May include placeholders for tracking numbers and other shipment details.
   *
   *     Validation requirements:
   *     - Must be a valid HTTPS URL
   *     - Cannot exceed 255 characters
   *     - Must include protocol and host
   *     - Query parameters are allowed
   */
  trackAndTraceURL?: InputMaybe<Scalars['String']['input']>;
  /**
   * Type of shipping service offered by this carrier.
   *
   *     Defines the delivery method and service characteristics provided by this carrier. Determines how customers receive their orders and affects shipping calculations.
   */
  type: CarrierType;
  /**
   * Identifiers of warehouses where this carrier provides shipping services.
   *
   *     Array of warehouse IDs that this carrier can service for shipping operations. Used to determine shipping availability and calculate shipping options based on fulfillment location.
   *
   *     Validation requirements:
   *     - All warehouse IDs must be positive integers
   *     - Array must contain unique values only
   *     - Warehouse IDs will be validated against the warehouse service
   */
  warehouseIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};

/** Available fields for sorting carrier search results */
export enum CarrierSortField {
  /** Sort by creation date */
  CREATED_AT = 'CREATED_AT',
  /** Sort by carrier unique identifier */
  ID = 'ID',
  /** Sort by last modification date */
  LAST_MODIFIED_AT = 'LAST_MODIFIED_AT',
  /** Sort by carrier name alphabetically */
  NAME = 'NAME'
}

/**
 * Sorting criteria for carrier result ordering.
 *
 *   Specifies a field and direction for sorting carrier search results. Used to control the order in which carriers are returned from search operations.
 */
export type CarrierSortInput = {
  /**
   * Field to sort carriers by.
   *
   *     Specifies which carrier property to use for sorting results. Available fields include ID, name, creation date, and last modification date.
   */
  field: CarrierSortField;
  /**
   * Sort direction for the specified field.
   *
   *     Determines whether results are sorted in ascending or descending order. Ascending order sorts from lowest to highest values, while descending sorts from highest to lowest.
   */
  order?: SortOrder;
};

/** Classification of shipping service delivery methods */
export enum CarrierType {
  /** Home or business delivery service where orders are delivered directly to the customer's specified address */
  DELIVERY = 'DELIVERY',
  /** Customer pickup service where orders are collected from designated pickup points or carrier locations */
  PICKUP = 'PICKUP'
}

/**
 * Input data for updating an existing shipping carrier.
 *
 *   Contains optional fields for modifying carrier information including service details, coverage areas, pricing, and integration settings. Only provided fields will be updated, others remain unchanged.
 */
export type CarrierUpdateInput = {
  /**
   * Localized descriptions of the carrier service for different languages and markets.
   *
   *     Collection of carrier service descriptions in various languages for international shipping options and multilingual storefronts.
   *
   *     Validation requirements:
   *     - Each description must have a unique 2-character language code (e.g., EN, DE, FR)
   *     - Language codes must be uppercase
   *     - Text values can contain up to 255 characters
   *     - Array must contain unique language codes only
   */
  descriptions?: InputMaybe<Array<LocalizedStringInput>>;
  /**
   * Public URL to the carrier's logo image for branding in shipping interfaces.
   *
   *     URL pointing to the carrier's logo image used for branding in shipping options and customer-facing interfaces.
   *
   *     Validation requirements:
   *     - Must be a valid URL
   *     - Cannot exceed 255 characters
   *     - Recommended: Maximum file size of 200kB
   *     - Recommended: Dimensions of 200x200px
   */
  logo?: InputMaybe<Scalars['String']['input']>;
  /**
   * Unique name identifying the shipping carrier within your organization.
   *
   *     Official name of the shipping company or service provider used for display in shipping options and logistics management.
   *
   *     Validation requirements:
   *     - Must be unique within the organization
   *     - Cannot exceed 64 characters
   *     - Cannot be empty or contain only whitespace
   */
  name?: InputMaybe<Scalars['String']['input']>;
  /**
   * Base shipping cost for this carrier (deprecated).
   *
   *     Fixed shipping cost associated with this carrier. This field is deprecated in favor of business rule builder for more flexible and complex pricing logic.
   *
   *     Validation requirements:
   *     - Must be a positive decimal value
   *     - Supports up to 5 decimal places
   */
  shippingCost?: InputMaybe<Scalars['Float']['input']>;
  /**
   * URL template for package tracking and shipment monitoring.
   *
   *     URL template used to generate tracking links for packages shipped with this carrier. May include placeholders for tracking numbers and other shipment details.
   *
   *     Validation requirements:
   *     - Must be a valid HTTPS URL
   *     - Cannot exceed 255 characters
   *     - Must include protocol and host
   *     - Query parameters are allowed
   */
  trackAndTraceURL?: InputMaybe<Scalars['String']['input']>;
  /**
   * Type of shipping service offered by this carrier.
   *
   *     Defines the delivery method and service characteristics provided by this carrier. Determines how customers receive their orders and affects shipping calculations.
   */
  type?: InputMaybe<CarrierType>;
  /**
   * Identifiers of warehouses where this carrier provides shipping services.
   *
   *     Array of warehouse IDs that this carrier can service for shipping operations. Used to determine shipping availability and calculate shipping options based on fulfillment location.
   *
   *     Validation requirements:
   *     - All warehouse IDs must be positive integers
   *     - Array must contain unique values only
   *     - Warehouse IDs will be validated against the warehouse service
   */
  warehouseIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};

/**
 * Search criteria for filtering and paginating carriers.
 *
 *   Provides comprehensive filtering options for carrier searches including pagination, date ranges, service types, warehouse coverage, and sorting capabilities. All filters are optional and can be combined for precise results.
 */
export type CarriersSearchInput = {
  /**
   * Filter carriers by creation date range.
   *
   *     Allows filtering carriers based on when they were created in the system.
   *
   *     Validation requirements:
   *     - Supports both greater than and less than date comparisons
   *     - Dates must be in ISO 8601 format (e.g., 2024-01-15T10:30:00.000Z)
   */
  createdAt?: InputMaybe<DateSearchInput>;
  /**
   * Filter by specific carrier identifiers.
   *
   *     Allows filtering carriers by their unique IDs. Supports multiple IDs for batch retrieval.
   *
   *     Validation requirements:
   *     - Each ID must be a positive integer
   *     - Array must contain unique values only
   */
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  /**
   * Filter carriers by last modification date range.
   *
   *     Allows filtering carriers based on when they were last updated in the system.
   *
   *     Validation requirements:
   *     - Supports both greater than and less than date comparisons
   *     - Dates must be in ISO 8601 format (e.g., 2024-01-15T10:30:00.000Z)
   */
  lastModifiedAt?: InputMaybe<DateSearchInput>;
  /**
   * Filter by specific carrier names.
   *
   *     Allows filtering carriers by their exact names. Supports multiple names for batch filtering.
   *
   *     Validation requirements:
   *     - Names are case-sensitive and must match exactly
   *     - Each name cannot exceed 64 characters
   */
  names?: InputMaybe<Array<Scalars['String']['input']>>;
  /**
   * Number of items per page.
   *
   *     Specifies how many carriers to return per page. Used in combination with page to control result pagination.
   *
   *     Validation requirements:
   *     - Must be a positive integer between 1 and 100
   */
  offset?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Page number for pagination results.
   *
   *     Specifies which page of results to retrieve. Used in combination with offset to control result pagination.
   *
   *     Validation requirements:
   *     - Must be a positive integer starting from 1
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Sorting criteria for result ordering.
   *
   *     Allows specifying multiple sorting fields with custom ordering directions. Results are sorted in the order specified, with each sort input containing a field and direction.
   *
   *     Validation requirements:
   *     - Each sort input must be unique
   *     - Field must be a valid CarrierSortField enum value
   *     - Order must be either ASC or DESC
   */
  sortInputs?: InputMaybe<Array<CarrierSortInput>>;
  /**
   * Filter by carrier service types.
   *
   *     Allows filtering carriers by their service delivery methods. Supports multiple types for comprehensive filtering.
   *
   *     Validation requirements:
   *     - Each type must be unique in the array
   *     - Only valid CarrierType enum values are accepted
   */
  types?: InputMaybe<Array<CarrierType>>;
  /**
   * Filter carriers by warehouse service coverage.
   *
   *     Allows filtering carriers that provide services to specific warehouses. Supports multiple warehouse IDs for comprehensive coverage filtering.
   *
   *     Validation requirements:
   *     - Each ID must be a positive integer
   *     - Array must contain unique values only
   */
  warehouseIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type CartAddBundleInput = {
  /** Bundle ID of the cart item. */
  bundleId: Scalars['Int']['input'];
  /** Cart identifier for this cart item. */
  cartId: Scalars['String']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  /** Quantity value for this cart item. */
  quantity?: InputMaybe<Scalars['Int']['input']>;
};

export type CartAddItemInput = {
  /** Cart identifier for this cart item. */
  cartId: Scalars['String']['input'];
  /** Adds child items to this cart item, this field is used when adding configurable clusters to the Cart. */
  childItems?: InputMaybe<Array<CartChildItemInput>>;
  notes?: InputMaybe<Scalars['String']['input']>;
  /** Cart item unit price. Defaults to calculated price. Only use for external pricing. */
  price?: InputMaybe<Scalars['Float']['input']>;
  /** Product ID of the cart item. */
  productId: Scalars['Int']['input'];
  /** Quantity value for this cart item. */
  quantity?: InputMaybe<Scalars['Int']['input']>;
};

/** Address types for Carts */
export enum CartAddressType {
  delivery = 'delivery',
  invoice = 'invoice'
}

export type CartChildItemInput = {
  /** Cart item unit price. Defaults to calculated price. Only use for external pricing. */
  price?: InputMaybe<Scalars['Float']['input']>;
  /** Product ID of the child item. */
  productId: Scalars['Int']['input'];
};

export type CartDeleteItemInput = {
  /** Cart identifier. */
  cartId: Scalars['String']['input'];
  /** Cart item identifier. */
  itemId: Scalars['Int']['input'];
};

export type CartPaymentDataInput = {
  /** The selected paymethod for this cart. Defaults to REKENING. */
  method?: InputMaybe<Scalars['String']['input']>;
};

export type CartPostageDataInput = {
  /** Is partial delivery allowed for this cart. */
  partialDeliveryAllowed?: InputMaybe<YesNo>;
  /** Postage cost excluding VAT based on external postage calculation. If value is set, postage priceMode is set to 'EXTERNAL' for this cart. */
  postage?: InputMaybe<Scalars['Float']['input']>;
  /** The preferred delivery date for this order as requested by the user. */
  requestDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** The selected shipping method for this cart. Defaults to VERZENDEN. */
  shippingMethod?: InputMaybe<Scalars['String']['input']>;
};

export type CartProcessInput = {
  /** Cart identifier. */
  cartId: Scalars['String']['input'];
  /** Language of the order. Defaults to user's primary language */
  language?: InputMaybe<Scalars['String']['input']>;
  /** Order status for this cart. */
  orderStatus: Scalars['String']['input'];
};

export type CartSetUserInput = {
  /** Cart identifier. */
  cartId: Scalars['String']['input'];
  /** User identifier for this cart. */
  userId: Scalars['Int']['input'];
};

export type CartUpdateAddressInput = {
  /** Cart identifier. */
  cartId: Scalars['String']['input'];
  /** City. */
  city: Scalars['String']['input'];
  /** Address code. */
  code?: InputMaybe<Scalars['String']['input']>;
  /** Company name. */
  company?: InputMaybe<Scalars['String']['input']>;
  /** Country. */
  country?: InputMaybe<Scalars['String']['input']>;
  /** Email address. */
  email?: InputMaybe<Scalars['String']['input']>;
  /** First name. */
  firstName: Scalars['String']['input'];
  /** Gender. */
  gender?: InputMaybe<Gender>;
  /** Marks wether this address an ICP address. */
  icp?: InputMaybe<YesNo>;
  /** Last name. */
  lastName: Scalars['String']['input'];
  /** Middle name. */
  middleName?: InputMaybe<Scalars['String']['input']>;
  /** Mobile phone number. */
  mobile?: InputMaybe<Scalars['String']['input']>;
  /** Customer's address notes. */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** House number. */
  number?: InputMaybe<Scalars['String']['input']>;
  /** House number extension. */
  numberExtension?: InputMaybe<Scalars['String']['input']>;
  /** Phone number. */
  phone?: InputMaybe<Scalars['String']['input']>;
  /** Postal code. */
  postalCode: Scalars['String']['input'];
  /** Region. */
  region?: InputMaybe<Scalars['String']['input']>;
  /** Street. */
  street: Scalars['String']['input'];
  /** Address type. */
  type: CartAddressType;
  /** Url. */
  url?: InputMaybe<Scalars['String']['input']>;
};

export type CartUpdateInput = {
  /** The selected carrier for this cart. */
  carrier?: InputMaybe<Scalars['String']['input']>;
  /** Cart identifier. */
  cartId: Scalars['String']['input'];
  /** Additional information field that can be stored with a cart and order. */
  extra3?: InputMaybe<Scalars['String']['input']>;
  /** Additional information field that can be stored with a cart and order. */
  extra4?: InputMaybe<Scalars['String']['input']>;
  /** Customer's notes for this cart. */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** Payment data for this cart. */
  paymentData?: InputMaybe<CartPaymentDataInput>;
  /** Postage data for this cart. */
  postageData?: InputMaybe<CartPostageDataInput>;
  /** Customer's reference for this cart. */
  reference?: InputMaybe<Scalars['String']['input']>;
};

export type CartUpdateItemInput = {
  /** Cart identifier for this cart item. */
  cartId: Scalars['String']['input'];
  /** Cart item identifier. */
  itemId: Scalars['Int']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  /** Cart item unit price. Defaults to calculated price. Only use for external pricing. */
  price?: InputMaybe<Scalars['Float']['input']>;
  /** Quantity value for this cart item. */
  quantity?: InputMaybe<Scalars['Int']['input']>;
};

export type CartUpdateItemsInput = {
  /** Cart item identifier. */
  itemId: Scalars['Int']['input'];
  notes?: InputMaybe<Scalars['String']['input']>;
  /** Cart item unit price. Defaults to calculated price. Only use for external pricing. */
  price?: InputMaybe<Scalars['Float']['input']>;
  /** Quantity value for this cart item. */
  quantity?: InputMaybe<Scalars['Int']['input']>;
};

export type CategorySearchInput = {
  /** Find categories by one or more categoryIds */
  categoryId?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** The language to use when searching categories by name or slug. When omitted the categories default language is used */
  language?: InputMaybe<Scalars['String']['input']>;
  /** Find categories by name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The amount of categories return per page */
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** The page number to return */
  page?: InputMaybe<Scalars['Int']['input']>;
  /** Find categories by one or more parentCategoryIds */
  parentCategoryId?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Find categories by one or more slugs */
  slug?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Available sortable fields One of: [name, dateCreated, entityDateChanged] */
  sortField?: InputMaybe<CategorySortableFields>;
  /** Sort ordering ['desc' or 'asc'] */
  sortOrder?: SortOrder;
};

/** Fields available for sorting categories */
export enum CategorySortableFields {
  dateChanged = 'dateChanged',
  dateCreated = 'dateCreated',
  name = 'name'
}

/** Ways to dsplay a cluster's drilldown selection. */
export enum ClusterDrillDownDisplayTypes {
  color = 'color',
  dropdown = 'dropdown',
  image = 'image',
  radio = 'radio'
}

export type CompanyAddressCreateInput = {
  /** Address city */
  city: Scalars['String']['input'];
  /** Address code */
  code?: InputMaybe<Scalars['String']['input']>;
  /** User company the address applies to */
  company?: InputMaybe<Scalars['String']['input']>;
  /** Address company primary identifier */
  companyId: Scalars['Int']['input'];
  /** Address country */
  country: Scalars['String']['input'];
  /** Address email [valid email format required] */
  email?: InputMaybe<Scalars['String']['input']>;
  /** User first name the address applies to */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** User gender the address applies to */
  gender?: InputMaybe<Gender>;
  /** ICP address field defines whether tax should be applied to an order if the address is selected as a delivery address. Used when shipping b2b order abroad */
  icp?: InputMaybe<YesNo>;
  /** Indicates whether the address is default for its type */
  isDefault?: InputMaybe<YesNo>;
  /** User last name the address applies to */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** User middle name the address applies to */
  middleName?: InputMaybe<Scalars['String']['input']>;
  /** Address mobile number [min: 6, max: 30] */
  mobile?: InputMaybe<Scalars['String']['input']>;
  /** Address delivery notes */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** User street number */
  number?: InputMaybe<Scalars['String']['input']>;
  /** User street number extension */
  numberExtension?: InputMaybe<Scalars['String']['input']>;
  /** Address fixed phone number [min: 6, max: 30] */
  phone?: InputMaybe<Scalars['String']['input']>;
  /** Address postal code */
  postalCode: Scalars['String']['input'];
  /** Address region */
  region?: InputMaybe<Scalars['String']['input']>;
  /** User street address */
  street: Scalars['String']['input'];
  /** Address type [one of 'home', 'delivery' or 'invoice'] */
  type: AddressType;
};

export type CompanyAddressDeleteInput = {
  /** Company primary identifier */
  companyId: Scalars['Int']['input'];
  /** Address primary identifier */
  id: Scalars['Int']['input'];
};

export type CompanyAddressUpdateInput = {
  /** Address city */
  city?: InputMaybe<Scalars['String']['input']>;
  /** Address code */
  code?: InputMaybe<Scalars['String']['input']>;
  /** User company the address applies to */
  company?: InputMaybe<Scalars['String']['input']>;
  /** Address company primary identifier */
  companyId: Scalars['Int']['input'];
  /** Address country */
  country?: InputMaybe<Scalars['String']['input']>;
  /** Address email [valid email format required] */
  email?: InputMaybe<Scalars['String']['input']>;
  /** User first name the address applies to */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** User gender the address applies to */
  gender?: InputMaybe<Gender>;
  /** ICP address field defines whether tax should be applied to an order if the address is selected as a delivery address. Used when shipping b2b order abroad */
  icp?: InputMaybe<YesNo>;
  /** Address primary identifier */
  id: Scalars['Int']['input'];
  /** Indicates whether the address is default for its type */
  isDefault?: InputMaybe<YesNo>;
  /** User last name the address applies to */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** User middle name the address applies to */
  middleName?: InputMaybe<Scalars['String']['input']>;
  /** Address mobile number [min: 6, max: 30] */
  mobile?: InputMaybe<Scalars['String']['input']>;
  /** Address delivery notes */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** User street number */
  number?: InputMaybe<Scalars['String']['input']>;
  /** User street number extension */
  numberExtension?: InputMaybe<Scalars['String']['input']>;
  /** Address fixed phone number [min: 6, max: 30] */
  phone?: InputMaybe<Scalars['String']['input']>;
  /** Address postal code */
  postalCode?: InputMaybe<Scalars['String']['input']>;
  /** Address region */
  region?: InputMaybe<Scalars['String']['input']>;
  /** User street address */
  street?: InputMaybe<Scalars['String']['input']>;
};

export type CompanySearchArguments = {
  /** List of unique company ids */
  companyIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Search by date changed */
  lastModifiedDate?: InputMaybe<DateSearchInput>;
  /** When true, only companies managed by the viewer will be listed */
  managedCompaniesOnly?: InputMaybe<Scalars['Boolean']['input']>;
  /** Company's name */
  name?: InputMaybe<Scalars['String']['input']>;
  offset?: Scalars['Int']['input'];
  page?: Scalars['Int']['input'];
  /** List of company sort filters */
  sort?: InputMaybe<Array<CompanySortInput>>;
  usergroupId?: InputMaybe<Scalars['Int']['input']>;
};

export type CompanySortInput = {
  /** Available sortable fields */
  field: CompanySortableFields;
  /** Sort ordering ['desc' or 'asc'] */
  order?: SortOrder;
};

/** Company sortable fields */
export enum CompanySortableFields {
  lastModifiedDate = 'lastModifiedDate',
  name = 'name'
}

export type ContactSearchArguments = {
  /** Search by Customer's attributes */
  attribute?: InputMaybe<UserManagementAttributeSearchInput>;
  /** List of unique contact ids */
  contactIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Contact's email */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Contact's first name */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** Contact's gender */
  gender?: InputMaybe<Gender>;
  /** Search by date changed */
  lastModifiedDate?: InputMaybe<DateSearchInput>;
  /** Contact's last name */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** Contact's middle name */
  middleName?: InputMaybe<Scalars['String']['input']>;
  offset?: Scalars['Int']['input'];
  page?: Scalars['Int']['input'];
  /** List of contact sort filters */
  sort?: InputMaybe<Array<ContactSortInput>>;
};

export type ContactSortInput = {
  /** Available contact sortable fields */
  field: ContactSortableFields;
  /** Sort contact ordering ['desc' or 'asc'] */
  order?: SortOrder;
};

/** Contact sortable fields */
export enum ContactSortableFields {
  firstName = 'firstName',
  lastModifiedDate = 'lastModifiedDate',
  lastName = 'lastName'
}

export type CreateAuthenticationInput = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  password?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  uid?: InputMaybe<Scalars['String']['input']>;
};

export type CreateBundleInput = {
  /** Items for this bundle. */
  addBundleItems?: InputMaybe<Array<BundleItemInput>>;
  /** The discount condition for this bundle. Discount can be applied for Extra Products (EP) or All Products (ALL). */
  condition?: InputMaybe<BundleCondition>;
  /** The description for this bundle. */
  description: Scalars['String']['input'];
  /** The discount percentage this bundle. */
  discount?: InputMaybe<Scalars['Float']['input']>;
  /** The name for this bundle. */
  name: Scalars['String']['input'];
  /** The bundle prices. */
  price?: InputMaybe<Scalars['Float']['input']>;
  /** The bundle tax zone. */
  taxZone?: InputMaybe<Scalars['String']['input']>;
};

export type CreateCategoryInput = {
  defaultLanguage: Scalars['String']['input'];
  /**
   * The long description for this category,
   *     this field can contain html formatting,
   *     this field can be translated is case of multilingual catalog.
   */
  description: Array<LocalizedStringInput>;
  /** [SEO] Metadata canonical urls in different languages. */
  metadataCanonicalUrl?: InputMaybe<Array<LocalizedStringInput>>;
  /** [SEO] Metadata description in different languages. */
  metadataDescription?: InputMaybe<Array<LocalizedStringInput>>;
  /** [SEO] Metadata keywords in different languages. */
  metadataKeywords?: InputMaybe<Array<LocalizedStringInput>>;
  /** [SEO] Metadata title in different languages. */
  metadataTitle?: InputMaybe<Array<LocalizedStringInput>>;
  /**
   * Localized category name as it is available in
   *     the supported language defaults to the category's default language.
   */
  name: Array<LocalizedStringInput>;
  /** The category's parent Category when available */
  parent?: InputMaybe<Scalars['Int']['input']>;
  /**
   * The long description for this category,
   *     this field can contain html formatting,
   *     this field can be translated is case of multilingual catalog.
   */
  shortDescription: Array<LocalizedStringInput>;
};

export type CreateCompanyInput = {
  cocNumber?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  /** The id of the usergroup the company should be created in. */
  parentId?: InputMaybe<Scalars['Int']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  taxNumber?: InputMaybe<Scalars['String']['input']>;
};

export type CreateContactInput = {
  /** Contacts's custom attribute values. This field is used to set value on attributes for the selected contact. Attributes that are used here (selected by name) must already be defined in Propeller. */
  attributes?: InputMaybe<Array<UserManagementAttributeValueInput>>;
  dateOfBirth?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Gender>;
  homepage?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mailingList?: InputMaybe<YesNo>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  mobile?: InputMaybe<Scalars['String']['input']>;
  /** The id of the company the contact should be created in. */
  parentId?: InputMaybe<Scalars['Int']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  /** The primary language of the contact. */
  primaryLanguage?: InputMaybe<Scalars['String']['input']>;
};

export type CreateInventoryInput = {
  /** Inventory cost price */
  costPrice?: InputMaybe<Scalars['Float']['input']>;
  /** Inventory location */
  location?: InputMaybe<Scalars['String']['input']>;
  /** Inventory estimated next delivery date in ISO8601 format */
  nextDeliveryDate?: InputMaybe<Scalars['String']['input']>;
  /** Inventory notes */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** Inventory product identifier */
  productId: Scalars['Int']['input'];
  /** Inventory quantity */
  quantity: Scalars['Int']['input'];
  /**
   * Inventory supplier. Defaults:
   *       - 'INTERN' for local inventory type
   *       - '[inherited from product supplier]' for supplier inventory type
   */
  supplier?: InputMaybe<Scalars['String']['input']>;
  /** Inventory type to create */
  type: InventoryType;
  /** Inventory warehouse identifier */
  warehouseId?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateOrUpdateOrderItemInput = {
  /** OrderItem create payload */
  create?: InputMaybe<OrderItemCreateInput>;
  /** OrderItem update payload */
  update?: InputMaybe<OrderItemUpdateInput>;
};

/**
 * Payment creation data including transaction details and payment method information.
 *
 * Contains all necessary information to create a payment record including amounts, payment method, and optional transaction data. All monetary amounts must be expressed in the smallest currency unit (cents) for precision.
 */
export type CreatePaymentInput = {
  /**
   * Optional transaction to create alongside the payment for immediate processing.
   *
   * When provided, creates an associated transaction record with the payment for immediate processing and tracking. Enables atomic creation of payment and initial transaction in a single operation.
   */
  addTransaction?: InputMaybe<CreateTransactionInput>;
  /**
   * Payment amount in smallest currency unit (cents) for precise financial calculations.
   *
   * The total amount to be paid expressed in the smallest denomination of the currency (e.g., cents for USD, pence for GBP). Must be a positive integer for precise financial calculations.
   */
  amount: Scalars['Int']['input'];
  /**
   * Anonymous user session identifier for guest checkout payments.
   *
   * References the guest user session for payments made without authentication. Used for guest checkout tracking and order management. Must be a positive integer when provided.
   */
  anonymousId?: InputMaybe<Scalars['Int']['input']>;
  /**
   * ISO 4217 three-letter currency code for international financial transactions.
   *
   * Three-letter currency code (e.g., USD, EUR, GBP) following ISO 4217 standard. Used for currency conversion and financial reporting. Must be exactly 3 uppercase letters.
   */
  currency: Scalars['String']['input'];
  /**
   * Payment method code used by the payment service provider for transaction processing.
   *
   * Specific payment method code used by the Payment Service Provider for processing this transaction (e.g., 'credit_card', 'paypal', 'bank_transfer'). Maximum length of 100 characters.
   */
  method: Scalars['String']['input'];
  /**
   * Order identifier that this payment is intended to fulfill.
   *
   * References the specific order that this payment is intended to fulfill. Used for order-payment relationship tracking and fulfillment processing. Must be a positive integer.
   */
  orderId: Scalars['Int']['input'];
  /**
   * External payment identifier provided by the payment service provider for tracking.
   *
   * Unique payment reference provided by the Payment Service Provider (PSP) for tracking and reconciliation. Used for payment status updates and transaction matching. Maximum length of 255 characters.
   */
  paymentId?: InputMaybe<Scalars['String']['input']>;
  /**
   * Initial payment processing status for the new payment record.
   *
   * Sets the starting status for the payment lifecycle. Determines the initial state and available actions for the payment processing workflow.
   */
  status: PaymentStatuses;
  /**
   * Authenticated user identifier for payment attribution and history tracking.
   *
   * Links the payment to a specific authenticated user for user-specific payment history and account management. Must be a positive integer when provided.
   */
  userId?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateProductInput = {
  /** The id of the category the product should be created in. */
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  /** Product cost price */
  costPrice?: InputMaybe<Scalars['Float']['input']>;
  /** The descriptions of the product and it's translations in different languages. */
  description?: InputMaybe<Array<LocalizedStringInput>>;
  /** The EAN code of the product. */
  eanCode?: InputMaybe<Scalars['String']['input']>;
  /** The language of the product. */
  language: Scalars['String']['input'];
  /** The manufacturer of the product. */
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  /** The manufacturer (OEM) code of the product. */
  manufacturerCode?: InputMaybe<Scalars['String']['input']>;
  /** [SEO] Metadata canonical urls in different languages. */
  metadataCanonicalUrl?: InputMaybe<Array<LocalizedStringInput>>;
  /** [SEO] Metadata description in different languages. */
  metadataDescription?: InputMaybe<Array<LocalizedStringInput>>;
  /** [SEO] Metadata keywords in different languages. */
  metadataKeywords?: InputMaybe<Array<LocalizedStringInput>>;
  /** [SEO] Metadata title in different languages. */
  metadataTitle?: InputMaybe<Array<LocalizedStringInput>>;
  /** Product minimum quantity. Defaults to 1. */
  minimumQuantity?: InputMaybe<Scalars['Int']['input']>;
  /** The names of the product and it's translations in different languages. */
  name?: InputMaybe<Array<LocalizedStringInput>>;
  /** Notes of the product and it's translations in different languages. */
  notes?: InputMaybe<Array<LocalizedStringInput>>;
  /** Original price of the product */
  originalPrice?: InputMaybe<Scalars['Float']['input']>;
  /** The default package type for this product. */
  package?: InputMaybe<Scalars['String']['input']>;
  /** The package type descriptions of the product and it's translations in different languages. */
  packageDescription?: InputMaybe<Array<LocalizedStringInput>>;
  /** The order of the product in search results when sorting by priority. */
  priority?: InputMaybe<Scalars['Int']['input']>;
  /** The short descriptions of the product and it's translations in different languages. */
  shortDescription?: InputMaybe<Array<LocalizedStringInput>>;
  /**
   * The short name product.
   *       Commonly used for connections with third parties that
   *       have a size limitation on the product name field.
   */
  shortName?: InputMaybe<Scalars['String']['input']>;
  /** The sku of the product. */
  sku?: InputMaybe<Scalars['String']['input']>;
  /** The status of the product. */
  status?: InputMaybe<ProductStatus>;
  /** Product suggested price */
  suggestedPrice?: InputMaybe<Scalars['Float']['input']>;
  /** The supplier of the product. */
  supplier?: InputMaybe<Scalars['String']['input']>;
  /** The supplier code of the product. */
  supplierCode?: InputMaybe<Scalars['String']['input']>;
  /** The tax code of the product. Defaults to H. */
  taxCode?: InputMaybe<TaxCode>;
  /** Product unit. Defaults to 1. */
  unit?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateSparePartInput = {
  /** Spare PartsMachine name */
  name?: InputMaybe<Array<LocalizedStringInput>>;
  quantity: Scalars['Int']['input'];
  sku: Scalars['String']['input'];
};

export type CreateSparePartsMachineInput = {
  /** Machine description */
  description?: InputMaybe<Array<LocalizedStringInput>>;
  externalReference: ExternalReferenceInput;
  /** Level 1 SubMachines input */
  machines?: InputMaybe<Array<CreateSparePartsMachineInput>>;
  /** Spare PartsMachine name */
  name: Array<LocalizedStringInput>;
  /** Spare parts for this machine */
  parts?: InputMaybe<Array<CreateSparePartInput>>;
};

export type CreateTaxInput = {
  /** Tax code */
  code?: InputMaybe<Scalars['String']['input']>;
  /** Tax export code */
  exportCode?: InputMaybe<Scalars['String']['input']>;
  /** Tax percentage expressed as ratio */
  ratio?: InputMaybe<Scalars['Float']['input']>;
  /** Shop identifier for the tax to apply to... If not provided the default will be inferred from the channel */
  shopId?: InputMaybe<Scalars['Int']['input']>;
  /** Tax zone */
  zone?: Scalars['String']['input'];
};

/**
 * Transaction creation data including operation type, amount, and processing details.
 *
 * Contains all necessary information to create a transaction record including transaction type, amounts, currency, and processing status. All monetary amounts must be expressed in the smallest currency unit (cents) for precision.
 */
export type CreateTransactionInput = {
  /**
   * Transaction amount in smallest currency unit (cents) for precise financial calculations.
   *
   * The transaction amount expressed in the smallest denomination of the currency (e.g., cents for USD, pence for GBP). Must be a positive integer for precise financial calculations.
   */
  amount: Scalars['Int']['input'];
  /**
   * ISO 4217 three-letter currency code for international financial transactions.
   *
   * Three-letter currency code (e.g., USD, EUR, GBP) following ISO 4217 standard. Used for currency conversion and financial reporting. Must be exactly 3 uppercase letters.
   */
  currency: Scalars['String']['input'];
  /**
   * Human-readable description of the transaction purpose or details.
   *
   * Optional descriptive text explaining the transaction purpose or providing additional context for record keeping and audit trails. Maximum length of 500 characters.
   */
  description?: InputMaybe<Scalars['String']['input']>;
  /**
   * External payment identifier provided by the payment service provider for correlation.
   *
   * External payment identifier provided by the Payment Service Provider for correlation with parent payment. Used to link transactions to their originating payments in external systems. Maximum length of 255 characters.
   */
  paymentId?: InputMaybe<Scalars['String']['input']>;
  /**
   * Name of the payment service provider processing the transaction.
   *
   * Identifies the external payment service provider handling the transaction processing. Used for provider-specific logic and reporting. Maximum length of 100 characters.
   */
  provider?: InputMaybe<Scalars['String']['input']>;
  /**
   * Initial processing status for the new transaction.
   *
   * Sets the starting status for the transaction processing workflow. Determines the initial state and available actions for the transaction lifecycle management.
   */
  status: TransactionStatuses;
  /**
   * Timestamp when the transaction was processed by the payment service provider.
   *
   * ISO 8601 formatted timestamp indicating when the transaction was processed by the external payment service provider. Used for transaction sequencing and audit trails.
   */
  timestamp?: InputMaybe<Scalars['DateTime']['input']>;
  /**
   * External transaction identifier provided by the payment service provider for tracking.
   *
   * Unique transaction reference provided by the Payment Service Provider (PSP) for tracking and reconciliation. Used for transaction status updates and matching with external systems. Maximum length of 255 characters.
   */
  transactionId: Scalars['String']['input'];
  /**
   * Type of transaction operation to be performed.
   *
   * Specifies the specific payment operation to execute (authorization, capture, refund, etc.). Each type has distinct business logic and financial implications for the payment workflow.
   */
  type: TransactionTypes;
};

export type CreateUserInput = {
  cocNumber?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Gender>;
  homepage?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mailingList?: InputMaybe<YesNo>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  mobile?: InputMaybe<Scalars['String']['input']>;
  /** The id of the usergroup the user should be created in. */
  parentId?: InputMaybe<Scalars['Int']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  /** The primary language of the user. */
  primaryLanguage?: InputMaybe<Scalars['String']['input']>;
  taxNumber?: InputMaybe<Scalars['String']['input']>;
};

export type CreateUsergroupInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  /** The id of the usergroup the company should be created in. */
  parentId?: InputMaybe<Scalars['Int']['input']>;
};

export type CreateWarehouseAddressInput = {
  /** Address city */
  city: Scalars['String']['input'];
  /** Address code */
  code?: InputMaybe<Scalars['String']['input']>;
  /** User company the address applies to */
  company?: InputMaybe<Scalars['String']['input']>;
  /** Address country */
  country: Scalars['String']['input'];
  /** Address email [valid email format required] */
  email?: InputMaybe<Scalars['String']['input']>;
  /** User first name the address applies to */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** User gender the address applies to */
  gender?: InputMaybe<Gender>;
  /** User last name the address applies to */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** User middle name the address applies to */
  middleName?: InputMaybe<Scalars['String']['input']>;
  /** Address mobile number [min: 6, max: 30] */
  mobile?: InputMaybe<Scalars['String']['input']>;
  /** Address delivery notes */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** User street number */
  number?: InputMaybe<Scalars['String']['input']>;
  /** User street number extension */
  numberExtension?: InputMaybe<Scalars['String']['input']>;
  /** Address fixed phone number [min: 6, max: 30] */
  phone?: InputMaybe<Scalars['String']['input']>;
  /** Address postal code */
  postalCode: Scalars['String']['input'];
  /** Address region */
  region?: InputMaybe<Scalars['String']['input']>;
  /** User street address */
  street: Scalars['String']['input'];
};

export type CreateWarehouseInput = {
  /**
   * Warehouse business hours per week day
   *
   *     Example:
   *         [{
   *           dayOfWeek: 0
   *           openingTime: "08:00"
   *           closingTime: "20:00"
   *           lunchBeakStartTime: "12:00"
   *           lunchBeakEndTime: "12:30"
   *         },
   *         {
   *           dayOfWeek: 1
   *           openingTime: "08:00"
   *           closingTime: "20:00"
   *           lunchBeakStartTime: "12:00"
   *           lunchBeakEndTime: "12:30"
   *         },
   *         {
   *           dayOfWeek: 2
   *           openingTime: "08:00"
   *           closingTime: "20:00"
   *           lunchBeakStartTime: "12:00"
   *           lunchBeakEndTime: "12:30"
   *         },
   *         {
   *           dayOfWeek: 3
   *           openingTime: "08:00"
   *           closingTime: "20:00"
   *           lunchBeakStartTime: "12:00"
   *           lunchBeakEndTime: "12:30"
   *         },
   *         {
   *           dayOfWeek: 4
   *           openingTime: "08:00"
   *           closingTime: "20:00"
   *           lunchBeakStartTime: "12:00"
   *           lunchBeakEndTime: "12:30"
   *         },
   *         {
   *           dayOfWeek: 5
   *           openingTime: "08:00"
   *           closingTime: "20:00"
   *           lunchBeakStartTime: "12:00"
   *           lunchBeakEndTime: "12:30"
   *         },
   *         {
   *           dayOfWeek: 6
   *           openingTime: "08:00"
   *           closingTime: "20:00"
   *           lunchBeakStartTime: "12:00"
   *           lunchBeakEndTime: "12:30"
   *         }]
   */
  businessHours: Array<BusinessHoursInput>;
  /** Add a address related to the specified warehouse */
  createWarehouseAddress?: InputMaybe<CreateWarehouseAddressInput>;
  /** Warehouse description */
  description: Scalars['String']['input'];
  /** Warehouse isActive status */
  isActive: Scalars['Boolean']['input'];
  /** Warehouse isPickupLocation status */
  isPickupLocation: Scalars['Boolean']['input'];
  /** Warehouse isStore status */
  isStore: Scalars['Boolean']['input'];
  /** Warehouse name */
  name: Scalars['String']['input'];
  /** Warehouse notes */
  notes: Scalars['String']['input'];
  /** Optional warehouse shopId! Default value will be internally inferred from the appropriate channel */
  shopId?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * Removes pixels from an image.
 *
 * When specifying a crop parameter, the value starts with the desired width and height, either as measurements of pixels, separated with a comma, or as a ratio, separated with a colon (for example, crop=4:3 or crop=640,480 or crop=0.8,0.4).
 *
 * The remaining parameters determine the position of the cropped region. On each dimension, placement can be made either with a position coordinate (x or y, which are relative to the top left of the uncropped image) or as a percentage offset from the center of the image using offset-x and offset-y. These can be mixed and matched, but only one method can be used for each dimension (i.e., x can be combined with offset-y but x cannot be combined with offset-x).
 *
 * Offset positioning acts to distribute the remaining space according to the specified offset proportions. If an image is 2000 pixels wide and is being cropped to 1000 pixels wide, offset-x10 would crop 10% (100 pixels) from the left of the image and 90% (900 pixels) from the right. An offset of 50 centers the crop in the middle of the image.
 *
 * Appending ,smart to the parameter value enables content-aware algorithms to attempt to crop the image to the desired aspect ratio while intelligently focusing on the most important visual content, including the detection of faces.
 *
 * If the specified cropped region is outside the bounds of the image, the transformation will fail with the error "Invalid transformation for requested image: Invalid crop, region out of bounds". Append ,safe to the parameter value to override this. In safe mode, the image gets delivered as an intersection of the origin image and the specified cropped region. This avoids the error, but the resulting image may not be of the specified dimensions.
 */
export type CropInput = {
  /** Height as Pixels or Percentage */
  height?: InputMaybe<Scalars['Int']['input']>;
  /** HeightRatio as Number */
  heightRatio?: InputMaybe<Scalars['Int']['input']>;
  /** X coordinate offset as Percentage */
  offsetX?: InputMaybe<Scalars['Int']['input']>;
  /** Y coordinate offset as Percentage */
  offsetY?: InputMaybe<Scalars['Int']['input']>;
  /** safe */
  safe?: InputMaybe<Scalars['String']['input']>;
  /** smart */
  smart?: InputMaybe<Scalars['String']['input']>;
  /** Width as Pixel or Percentage */
  width?: InputMaybe<Scalars['Int']['input']>;
  /** WidthRatio as Number */
  widthRatio?: InputMaybe<Scalars['Int']['input']>;
  /** X coordinate as Pixels or Percentage */
  x?: InputMaybe<Scalars['Int']['input']>;
  /** Y coordinate as Pixels or Percentage */
  y?: InputMaybe<Scalars['Int']['input']>;
};

export type CrossupsellInput = {
  /** Cross/Up Sell cluster identifier */
  clusterId?: InputMaybe<Scalars['Int']['input']>;
  /** Cross/Up Sell product identifier */
  productId?: InputMaybe<Scalars['Int']['input']>;
  /** Crossupsell subtypes */
  subTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Crossupsell types */
  types?: InputMaybe<Array<CrossupsellTypes>>;
};

/** Available Cross/Up Sell types */
export enum CrossupsellTypes {
  ACCESSORIES = 'ACCESSORIES',
  ALTERNATIVES = 'ALTERNATIVES',
  OPTIONS = 'OPTIONS',
  PARTS = 'PARTS',
  RELATED = 'RELATED'
}

export type CrossupsellTypesInput = {
  /** Crossupsell subtypes */
  subTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Crossupsell types */
  types?: InputMaybe<Array<CrossupsellTypes>>;
};

/** CsvRecordErrorCode */
export enum CsvRecordErrorCode {
  DB_INSERT = 'DB_INSERT',
  UNKNOWN = 'UNKNOWN',
  VALIDATION = 'VALIDATION'
}

export type CustomerAddressCreateInput = {
  /** Address city */
  city: Scalars['String']['input'];
  /** Address code */
  code?: InputMaybe<Scalars['String']['input']>;
  /** User company the address applies to */
  company?: InputMaybe<Scalars['String']['input']>;
  /** Address country */
  country: Scalars['String']['input'];
  /** Address customer primary identifier */
  customerId: Scalars['Int']['input'];
  /** Address email [valid email format required] */
  email?: InputMaybe<Scalars['String']['input']>;
  /** User first name the address applies to */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** User gender the address applies to */
  gender?: InputMaybe<Gender>;
  /** ICP address field defines whether tax should be applied to an order if the address is selected as a delivery address. Used when shipping b2b order abroad */
  icp?: InputMaybe<YesNo>;
  /** Indicates whether the address is default for its type */
  isDefault?: InputMaybe<YesNo>;
  /** User last name the address applies to */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** User middle name the address applies to */
  middleName?: InputMaybe<Scalars['String']['input']>;
  /** Address mobile number [min: 6, max: 30] */
  mobile?: InputMaybe<Scalars['String']['input']>;
  /** Address delivery notes */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** User street number */
  number?: InputMaybe<Scalars['String']['input']>;
  /** User street number extension */
  numberExtension?: InputMaybe<Scalars['String']['input']>;
  /** Address fixed phone number [min: 6, max: 30] */
  phone?: InputMaybe<Scalars['String']['input']>;
  /** Address postal code */
  postalCode: Scalars['String']['input'];
  /** Address region */
  region?: InputMaybe<Scalars['String']['input']>;
  /** User street address */
  street: Scalars['String']['input'];
  /** Address type [one of 'home', 'delivery' or 'invoice'] */
  type: AddressType;
};

export type CustomerAddressDeleteInput = {
  /** Customer primary identifier */
  customerId: Scalars['Int']['input'];
  /** Address primary identifier */
  id: Scalars['Int']['input'];
};

export type CustomerAddressUpdateInput = {
  /** Address city */
  city?: InputMaybe<Scalars['String']['input']>;
  /** Address code */
  code?: InputMaybe<Scalars['String']['input']>;
  /** User company the address applies to */
  company?: InputMaybe<Scalars['String']['input']>;
  /** Address country */
  country?: InputMaybe<Scalars['String']['input']>;
  /** Address customer primary identifier */
  customerId: Scalars['Int']['input'];
  /** Address email [valid email format required] */
  email?: InputMaybe<Scalars['String']['input']>;
  /** User first name the address applies to */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** User gender the address applies to */
  gender?: InputMaybe<Gender>;
  /** ICP address field defines whether tax should be applied to an order if the address is selected as a delivery address. Used when shipping b2b order abroad */
  icp?: InputMaybe<YesNo>;
  /** Address primary identifier */
  id: Scalars['Int']['input'];
  /** Indicates whether the address is default for its type */
  isDefault?: InputMaybe<YesNo>;
  /** User last name the address applies to */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** User middle name the address applies to */
  middleName?: InputMaybe<Scalars['String']['input']>;
  /** Address mobile number [min: 6, max: 30] */
  mobile?: InputMaybe<Scalars['String']['input']>;
  /** Address delivery notes */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** User street number */
  number?: InputMaybe<Scalars['String']['input']>;
  /** User street number extension */
  numberExtension?: InputMaybe<Scalars['String']['input']>;
  /** Address fixed phone number [min: 6, max: 30] */
  phone?: InputMaybe<Scalars['String']['input']>;
  /** Address postal code */
  postalCode?: InputMaybe<Scalars['String']['input']>;
  /** Address region */
  region?: InputMaybe<Scalars['String']['input']>;
  /** User street address */
  street?: InputMaybe<Scalars['String']['input']>;
};

export type CustomerInput = {
  /** Customer's custom attribute values. This field is used to set value on attributes for the selected customer. Attributes that are used here (selected by name) must already be defined in Propeller. */
  attributes?: InputMaybe<Array<UserManagementAttributeValueInput>>;
  customerId?: InputMaybe<Scalars['Int']['input']>;
  dateOfBirth?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Gender>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mailingList?: InputMaybe<YesNo>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  mobile?: InputMaybe<Scalars['String']['input']>;
  /** The id of the usergroup the customer should be created in. */
  parentId?: InputMaybe<Scalars['Int']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  /** The primary language of the customer. */
  primaryLanguage?: InputMaybe<Scalars['String']['input']>;
};

export type CustomerSearchArguments = {
  /** Search by Customer's attributes */
  attribute?: InputMaybe<UserManagementAttributeSearchInput>;
  /** List of unique customer ids */
  customerIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Customer's email */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Customer's first name */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** Customer's gender */
  gender?: InputMaybe<Gender>;
  /** Search by date changed */
  lastModifiedDate?: InputMaybe<DateSearchInput>;
  /** Customer's last name */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** Customer's middle name */
  middleName?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  /** List of customer sort filters */
  sort?: InputMaybe<Array<CustomerSortInput>>;
};

export type CustomerSortInput = {
  /** Available customer sortable fields */
  field: CustomerSortableFields;
  /** Sort customer ordering ['desc' or 'asc'] */
  order?: SortOrder;
};

/** Customer sortable fields */
export enum CustomerSortableFields {
  lastModifiedDate = 'lastModifiedDate',
  name = 'name'
}

export type DateSearchInput = {
  /** Date greater than provided date */
  greaterThan?: InputMaybe<Scalars['String']['input']>;
  /** Date less than provided date */
  lessThan?: InputMaybe<Scalars['String']['input']>;
};

export type DecimalSearchInput = {
  /** greater than or equal */
  greaterThan?: InputMaybe<Scalars['Float']['input']>;
  /** less than or equal */
  lessThan?: InputMaybe<Scalars['Float']['input']>;
};

export type DeleteWarehouseAddressInput = {
  /** Address primary identifier */
  id: Scalars['Int']['input'];
};

/** Discount type */
export enum DiscountType {
  amount = 'amount',
  percentage = 'percentage'
}

export type DocumentCsvInput = {
  /** CSV file */
  file: Scalars['Upload']['input'];
  /** A list of MediaDocuments CSV field mappings */
  mappings?: InputMaybe<Array<DocumentCsvMapping>>;
};

export type DocumentCsvMapping = {
  /** The name of the column in the CSV file */
  csvHeader: Scalars['String']['input'];
  /** The name of the field in Propeller eCommerce Platform */
  fieldName: DocumentFieldName;
};

/** Fields available for document CSV mapping. */
export enum DocumentFieldName {
  /** [Required][String] The alt descriptions of this MediaDocument per language */
  ALT_VALUE = 'ALT_VALUE',
  /** [Optional][Integer] This MediaDocument's linked Category */
  CATEGORY_ID = 'CATEGORY_ID',
  /** [Optional][String] This MediaDocument's linked Cluster */
  CLUSTER_ID = 'CLUSTER_ID',
  /** [Required][String] The descriptions of this MediaDocument per language */
  DESCRIPTION_VALUE = 'DESCRIPTION_VALUE',
  /** [Required][String] MediaDocument file name */
  DOCUMENT_FILE_NAME = 'DOCUMENT_FILE_NAME',
  /** [Required][String] MediaDocument file url */
  DOCUMENT_FILE_URI = 'DOCUMENT_FILE_URI',
  /** [Optional][String] This MediaDocument's unique identifier */
  ID = 'ID',
  /** [Required][String] Language of the MediaDocument [Default: EN] */
  LANGUAGE = 'LANGUAGE',
  /** [Optional][Integer] MediaDocument display priority [Lower value has higher priority] - [Default: 1000] */
  PRIORITY = 'PRIORITY',
  /** [Optional][String] This MediaDocument's linked Product. */
  PRODUCT_ID = 'PRODUCT_ID',
  /** [Optional][String] This MediaDocument's linked SpareParts Machine */
  SPAREPARTS_MACHINE_ID = 'SPAREPARTS_MACHINE_ID',
  /** [Required][String[]] The tags of this MediaDocument per language */
  TAGS_VALUES = 'TAGS_VALUES'
}

export type EmailEventInput = {
  /** Attachments to add to the email */
  attachments?: InputMaybe<Array<Base64FileInput>>;
  /** The content of the email, use when the content can not be derived from other inputs */
  content?: InputMaybe<Scalars['String']['input']>;
  /** The sender of the email, use when the sender can not be derived from other inputs */
  from?: InputMaybe<EmailSendContactInput>;
  /** The language of the generated email */
  language?: InputMaybe<Scalars['String']['input']>;
  /** The id of the Propeller letter to use when type is 'campaign' */
  letterId?: InputMaybe<Scalars['String']['input']>;
  /** The id of the order to use when triggering an event of type orderconfirm */
  orderId?: InputMaybe<Scalars['Int']['input']>;
  /** The id of the site to use when sending the email, required when the site can not be derived from other inputs */
  siteId?: InputMaybe<Scalars['Int']['input']>;
  /** The subject of the email, use when the subject can not be derived from other inputs */
  subject?: InputMaybe<Scalars['String']['input']>;
  /** The recipient(s) of the email, use when the recipient(s) can not be derived from other inputs */
  to?: InputMaybe<Array<EmailSendContactInput>>;
  /** The type of email event to trigger */
  type: EmailEventType;
  /** The id of the user to send to email to. Can be used to replace to, when the user can't be derived from other inputs */
  userId?: InputMaybe<Scalars['Int']['input']>;
  /** Variables that can be used in the email template */
  variables?: InputMaybe<Scalars['JSONObject']['input']>;
};

/** Type of e-mail events that can be triggered */
export enum EmailEventType {
  campaign = 'campaign',
  custom = 'custom',
  error = 'error',
  orderconfirm = 'orderconfirm',
  quotation = 'quotation',
  registration = 'registration',
  system = 'system',
  transactional = 'transactional'
}

export type EmailSendContactInput = {
  /** The email address of the contact */
  email: Scalars['String']['input'];
  /** The name of the contact */
  name?: InputMaybe<Scalars['String']['input']>;
};

export type EmailSendEventInput = {
  /** The attachment(s) of the email */
  attachments?: InputMaybe<Array<Base64FileInput>>;
  /** The bcc recipient(s) of the email */
  bcc?: InputMaybe<Array<EmailSendContactInput>>;
  /** The campaingId of the email */
  campaignId?: InputMaybe<Scalars['String']['input']>;
  /** The cc recipient(s) of the email */
  cc?: InputMaybe<Array<EmailSendContactInput>>;
  /** The content of the email */
  content: Scalars['String']['input'];
  /** The sender of the email */
  from: EmailSendContactInput;
  /** The messageId of the email */
  messageId?: InputMaybe<Scalars['String']['input']>;
  /** The subject of the email */
  subject: Scalars['String']['input'];
  /** The recipient(s) of the email */
  to: Array<EmailSendContactInput>;
  /** The utmTags of the email */
  utmTags?: InputMaybe<Scalars['String']['input']>;
  /** Variables that can be used in the email template */
  variables?: InputMaybe<Scalars['JSONObject']['input']>;
};

export type ExchangeRefreshTokenInput = {
  refreshToken: Scalars['String']['input'];
};

export type ExternalAddressCreateInput = {
  /** Address city */
  city: Scalars['String']['input'];
  /** Address code */
  code?: InputMaybe<Scalars['String']['input']>;
  /** User company the address applies to */
  company?: InputMaybe<Scalars['String']['input']>;
  /** Address country */
  country: Scalars['String']['input'];
  /** Address email [valid email format required] */
  email?: InputMaybe<Scalars['String']['input']>;
  /** User first name the address applies to */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** User gender the address applies to */
  gender?: InputMaybe<Gender>;
  /** ICP address field defines whether tax should be applied to an order if the address is selected as a delivery address. Used when shipping b2b order abroad */
  icp?: InputMaybe<YesNo>;
  /** User last name the address applies to */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** User middle name the address applies to */
  middleName?: InputMaybe<Scalars['String']['input']>;
  /** Address mobile number [min: 6, max: 30] */
  mobile?: InputMaybe<Scalars['String']['input']>;
  /** Address delivery notes */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** User street number */
  number?: InputMaybe<Scalars['String']['input']>;
  /** User street number extension */
  numberExtension?: InputMaybe<Scalars['String']['input']>;
  /** Address fixed phone number [min: 6, max: 30] */
  phone?: InputMaybe<Scalars['String']['input']>;
  /** Address postal code */
  postalCode: Scalars['String']['input'];
  /** Address region */
  region?: InputMaybe<Scalars['String']['input']>;
  /** User street address */
  street: Scalars['String']['input'];
};

export type ExternalAddressDeleteInput = {
  /** Address primary identifier */
  id: Scalars['Int']['input'];
};

export type ExternalAddressUpdateInput = {
  /** Address city */
  city?: InputMaybe<Scalars['String']['input']>;
  /** Address code */
  code?: InputMaybe<Scalars['String']['input']>;
  /** User company the address applies to */
  company?: InputMaybe<Scalars['String']['input']>;
  /** Address country */
  country?: InputMaybe<Scalars['String']['input']>;
  /** Address email [valid email format required] */
  email?: InputMaybe<Scalars['String']['input']>;
  /** User first name the address applies to */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** User gender the address applies to */
  gender?: InputMaybe<Gender>;
  /** ICP address field defines whether tax should be applied to an order if the address is selected as a delivery address. Used when shipping b2b order abroad */
  icp?: InputMaybe<YesNo>;
  /** Address primary identifier */
  id: Scalars['Int']['input'];
  /** User last name the address applies to */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** User middle name the address applies to */
  middleName?: InputMaybe<Scalars['String']['input']>;
  /** Address mobile number [min: 6, max: 30] */
  mobile?: InputMaybe<Scalars['String']['input']>;
  /** Address delivery notes */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** User street number */
  number?: InputMaybe<Scalars['String']['input']>;
  /** User street number extension */
  numberExtension?: InputMaybe<Scalars['String']['input']>;
  /** Address fixed phone number [min: 6, max: 30] */
  phone?: InputMaybe<Scalars['String']['input']>;
  /** Address postal code */
  postalCode?: InputMaybe<Scalars['String']['input']>;
  /** Address region */
  region?: InputMaybe<Scalars['String']['input']>;
  /** User street address */
  street?: InputMaybe<Scalars['String']['input']>;
};

export type ExternalReferenceInput = {
  source: Scalars['String']['input'];
  sourceId: Scalars['String']['input'];
};

export type FavoriteListsBaseSearchInput = {
  /** Favorite List is default */
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  /** Favorite List name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Favorite List offset */
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Favorite List page */
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type FavoriteListsCreateInput = {
  /** Favorite List cluster IDs list */
  clusterIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** List of cluster sources */
  clusterSources?: InputMaybe<Array<SourceInput>>;
  /** Favorite List company ID */
  companyId?: InputMaybe<Scalars['Int']['input']>;
  /** A company source */
  companySource?: InputMaybe<SourceInput>;
  /** Favorite List contact ID */
  contactId?: InputMaybe<Scalars['Int']['input']>;
  /** A contact source */
  contactSource?: InputMaybe<SourceInput>;
  /** Favorite List customer ID */
  customerId?: InputMaybe<Scalars['Int']['input']>;
  /** A customer source */
  customerSource?: InputMaybe<SourceInput>;
  /** Favorite List is default */
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  /** Favorite List name */
  name: Scalars['String']['input'];
  /** Favorite List product IDs list */
  productIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** List of product sources */
  productSources?: InputMaybe<Array<SourceInput>>;
};

export type FavoriteListsItemsInput = {
  /** Favorite List cluster IDs list */
  clusterIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** List of cluster sources */
  clusterSources?: InputMaybe<Array<SourceInput>>;
  /** Favorite List product IDs list */
  productIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** List of product sources */
  productSources?: InputMaybe<Array<SourceInput>>;
};

export type FavoriteListsSearchInput = {
  /** List of cluster ids */
  clusterIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** List of cluster sources */
  clusterSources?: InputMaybe<Array<SourceInput>>;
  /** Favorite List company ID */
  companyId?: InputMaybe<Scalars['Int']['input']>;
  /** A company source */
  companySource?: InputMaybe<SourceInput>;
  /** Favorite List contact ID */
  contactId?: InputMaybe<Scalars['Int']['input']>;
  /** A contact source */
  contactSource?: InputMaybe<SourceInput>;
  /** Search by date created */
  createdAt?: InputMaybe<DateSearchInput>;
  /** Favorite List customer ID */
  customerId?: InputMaybe<Scalars['Int']['input']>;
  /** A customer source */
  customerSource?: InputMaybe<SourceInput>;
  /** Favorite List is default */
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  /** Search by date changed */
  lastModifiedAt?: InputMaybe<DateSearchInput>;
  /** Favorite List name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Favorite List offset */
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Favorite List page */
  page?: InputMaybe<Scalars['Int']['input']>;
  /** List of product ids */
  productIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** List of product sources */
  productSources?: InputMaybe<Array<SourceInput>>;
};

export type FavoriteListsUpdateInput = {
  /** Favorite List cluster IDs list */
  clusterIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** List of cluster sources */
  clusterSources?: InputMaybe<Array<SourceInput>>;
  /** Favorite List is default */
  isDefault?: InputMaybe<Scalars['Boolean']['input']>;
  /** Favorite List name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Favorite List product IDs list */
  productIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** List of product sources */
  productSources?: InputMaybe<Array<SourceInput>>;
};

/** Control flags for enabling or disabling specific image transformation features */
export enum FeaturesEnableDisable {
  /** Controls whether images can be enlarged beyond their original dimensions. When disabled, prevents upscaling to maintain image quality. When enabled, allows enlargement which may reduce quality but provides flexibility for responsive design. */
  UPSCALE = 'UPSCALE'
}

export type FilterAvailableAttributeInput = {
  id?: InputMaybe<Array<Scalars['String']['input']>>;
  isPublic?: InputMaybe<Scalars['Boolean']['input']>;
  isSearchable?: InputMaybe<Scalars['Boolean']['input']>;
  searchId?: InputMaybe<Array<Scalars['String']['input']>>;
  type?: InputMaybe<Array<AttributeType>>;
};

/** Controls how images are resized and positioned within specified dimensions while maintaining aspect ratio. Only effective when both width and height are specified. */
export enum Fit {
  /** Scales the image to fit entirely within the specified dimensions, preserving aspect ratio. May result in letterboxing or pillarboxing if aspect ratios don't match. */
  BOUNDS = 'BOUNDS',
  /** Scales the image to completely fill the specified dimensions, preserving aspect ratio. May crop parts of the image if aspect ratios don't match. */
  COVER = 'COVER',
  /** Resizes and crops the image from the center to exactly match the specified dimensions, potentially removing content from edges. */
  CROP = 'CROP'
}

/** Output format for the transformed image, determining compression method, quality, and browser compatibility */
export enum Format {
  /** Automatically selects the optimal format based on browser capabilities, image content, and transformation requirements */
  AUTO = 'AUTO',
  /** AV1 Image File Format - next-generation format with superior compression and quality, supported by modern browsers */
  AVIF = 'AVIF',
  /** Baseline JPEG format optimized for broad compatibility and sequential loading */
  BJPG = 'BJPG',
  /** Graphics Interchange Format supporting animation and transparency, ideal for simple graphics and animations */
  GIF = 'GIF',
  /** Standard JPEG format with lossy compression, best for photographs and complex images */
  JPG = 'JPG',
  /** JPEG XL format offering better compression than JPEG with both lossy and lossless modes */
  JXL = 'JXL',
  /** MP4 video format (H.264) for converting animated images to video */
  MP4 = 'MP4',
  /** Progressive JPEG that loads in multiple passes, improving perceived loading speed */
  PJPG = 'PJPG',
  /** Progressive JPEG XL that loads incrementally for better user experience */
  PJXL = 'PJXL',
  /** Portable Network Graphics with lossless compression, ideal for images with transparency or sharp edges */
  PNG = 'PNG',
  /** 8-bit PNG with 256-color palette and transparency, smaller file size than full PNG */
  PNG8 = 'PNG8',
  /** WebP format providing excellent compression for both lossy and lossless images */
  WEBP = 'WEBP',
  /** WebP lossless format maintaining perfect image quality with better compression than PNG */
  WEBPLL = 'WEBPLL',
  /** WebP lossy format offering better compression than JPEG while maintaining quality */
  WEBPLY = 'WEBPLY'
}

/** A persons gender */
export enum Gender {
  /** Female */
  F = 'F',
  /** Male */
  M = 'M',
  /** Unknown */
  U = 'U'
}

/** Input for bulk importing images from a CSV file with field mapping configuration */
export type ImageCsvInput = {
  /**
   * CSV file containing image data for bulk import.
   *
   *     Must be a valid CSV file with headers that match the configured field mappings. Each row represents one image to be created with the specified metadata and file references.
   */
  file: Scalars['Upload']['input'];
  /**
   * Configuration mapping CSV columns to image entity fields.
   *
   *     Defines how CSV column headers correspond to image fields. If not provided, the system will attempt to auto-map based on standard column names. Each mapping must be unique and valid.
   */
  mappings?: InputMaybe<Array<ImageCsvMapping>>;
};

/** Mapping configuration between CSV column headers and image entity fields */
export type ImageCsvMapping = {
  /**
   * Name of the column header in the CSV file.
   *
   *     Must exactly match the column header in the uploaded CSV file. Used to identify which CSV column contains the data for the corresponding image field.
   */
  csvHeader: Scalars['String']['input'];
  /**
   * Target image field that will receive the CSV column data.
   *
   *     Specifies which image entity field should be populated with the data from the corresponding CSV column. Each field has specific validation requirements and data format expectations.
   */
  fieldName: ImageFieldName;
};

/** Fields available for image CSV mapping. */
export enum ImageFieldName {
  /** [Required][String] The alt descriptions of this MediaImage per language */
  ALT_VALUE = 'ALT_VALUE',
  /** [Optional][Integer] This MediaImage's linked Category */
  CATEGORY_ID = 'CATEGORY_ID',
  /** [Optional][String] This MediaImage's linked Cluster */
  CLUSTER_ID = 'CLUSTER_ID',
  /** [Required][String] The descriptions of this MediaImage per language */
  DESCRIPTION_VALUE = 'DESCRIPTION_VALUE',
  /** [Optional][String] This MediaImage's unique identifier */
  ID = 'ID',
  /** [Required][String] MediaImage file name */
  IMAGE_FILE_NAME = 'IMAGE_FILE_NAME',
  /** [Required][String] MediaImage file url */
  IMAGE_FILE_URI = 'IMAGE_FILE_URI',
  /** [Required][String] Language of the MediaImage [Default: EN] */
  LANGUAGE = 'LANGUAGE',
  /** [Optional][Integer] MediaImage display priority [Lower value has higher priority] - [Default: 1000] */
  PRIORITY = 'PRIORITY',
  /** [Optional][String] This MediaImage's linked Product. */
  PRODUCT_ID = 'PRODUCT_ID',
  /** [Optional][String] This MediaImage's linked SpareParts Machine */
  SPAREPARTS_MACHINE_ID = 'SPAREPARTS_MACHINE_ID',
  /** [Required][String[]] The tags of this MediaImage per language */
  TAGS_VALUES = 'TAGS_VALUES'
}

/** The metadata parameters controls whether to include metadata in the output image */
export enum ImageMetadata {
  /** Preserve copyright notice, creator, credit line, licensor, and web statement of rights fields. */
  COPYRIGHT = 'COPYRIGHT'
}

export type ImageTransformationInput = {
  /** Friendly name for your image transformation */
  name: Scalars['String']['input'];
  /** Image transformation options */
  transformation: TransformationInput;
};

export type InventoryCsvInput = {
  /** CSV file */
  file: Scalars['Upload']['input'];
  /** A list of inventories CSV field mappings */
  mappings?: InputMaybe<Array<InventoryCsvMapping>>;
};

export type InventoryCsvMapping = {
  /** The name of the column in the CSV file */
  csvHeader: Scalars['String']['input'];
  /** The name of the field in Propeller eCommerce Platform */
  fieldName: InventoryFieldName;
};

export enum InventoryFieldName {
  /** [Optional][Integer] Company identifier related to the inventory */
  COMPANY_ID = 'COMPANY_ID',
  /** [Optional][String] Language associated with the company */
  COMPANY_LANGUAGE = 'COMPANY_LANGUAGE',
  /** [Optional][String] Source identifier for the company */
  COMPANY_SOURCE_ID = 'COMPANY_SOURCE_ID',
  /** [Optional][String] Source name for the company */
  COMPANY_SOURCE_NAME = 'COMPANY_SOURCE_NAME',
  /** [Optional][Decimal] Inventory cost price */
  COST_PRICE = 'COST_PRICE',
  /** [Required][Enum] Inventory type to create, must be one of the following: [local, supplier] */
  INVENTORY_TYPE = 'INVENTORY_TYPE',
  /** [Optional][String] Language associated with the inventory, required only when lookup key is sourceId */
  LANGUAGE = 'LANGUAGE',
  /** [Optional][String] Inventory location */
  LOCATION = 'LOCATION',
  /** [Required][String] Key used for inventory lookup, must be one of the following: [id, sku, supplierCode, sourceId] */
  LOOKUP_KEY = 'LOOKUP_KEY',
  /** [Optional][DateTime] Inventory estimated next delivery date in ISO8601 format in ISO 8601 format 'YYYY-MM-DDThh:mm:ss.sssZ' (e.g., 2024-10-31T09:55:00.000Z) */
  NEXT_DELIVERY_DATE = 'NEXT_DELIVERY_DATE',
  /** [Optional][String] Inventory notes */
  NOTES = 'NOTES',
  /** [Required][Integer] Inventory product identifier, required only when lookup key is id */
  PRODUCT_ID = 'PRODUCT_ID',
  /** [Required][Integer] Inventory quantity */
  QUANTITY = 'QUANTITY',
  /** [Optional][String] Stock Keeping Unit identifier for the inventory, required only when lookup key is sku */
  SKU = 'SKU',
  /** [Optional][String] Identifier for the inventory source, required only when lookup key is sourceId */
  SOURCE_ID = 'SOURCE_ID',
  /** [Optional][String] Name of the inventory source, required only when lookup key is sourceId */
  SOURCE_NAME = 'SOURCE_NAME',
  /**
   * [Optional][String] Inventory supplier. Defaults:
   *       - 'INTERN' for local inventory type
   *       - '[inherited from product supplier]' for supplier inventory type, required only when lookup key is supplierCode
   */
  SUPPLIER = 'SUPPLIER',
  /** [Optional][String] Code identifying the supplier of the inventory, required only when lookup key is supplierCode */
  SUPPLIER_CODE = 'SUPPLIER_CODE',
  /** [Optional][Integer] Usergroup identifier related to the inventory */
  USERGROUP_ID = 'USERGROUP_ID',
  /** [Optional][String] Language associated with the user group */
  USERGROUP_LANGUAGE = 'USERGROUP_LANGUAGE',
  /** [Optional][String] Source identifier for the usergroup */
  USERGROUP_SOURCE_ID = 'USERGROUP_SOURCE_ID',
  /** [Optional][String] Source name for the usergroup */
  USERGROUP_SOURCE_NAME = 'USERGROUP_SOURCE_NAME',
  /** [Optional][Integer] Inventory warehouse identifier */
  WAREHOUSE_ID = 'WAREHOUSE_ID'
}

/** Available inventory types */
export enum InventoryType {
  local = 'local',
  supplier = 'supplier'
}

/**
 * When converting animated GIFs to the MP4 format and when used in conjunction with the profile parameter, the level parameter specifies a set of constraints indicating a degree of required decoder performance for a profile.
 *
 *   NOTE: If either level or profile parameters are missing, profile=baseline&level=3.0 will be used as the default.
 */
export enum Level {
  /** Level: 1.0 */
  LEVEL_1_0 = 'LEVEL_1_0',
  /** Level: 1.1 */
  LEVEL_1_1 = 'LEVEL_1_1',
  /** Level: 1.2 */
  LEVEL_1_2 = 'LEVEL_1_2',
  /** Level: 2.0 */
  LEVEL_2_0 = 'LEVEL_2_0',
  /** Level: 2.1 */
  LEVEL_2_1 = 'LEVEL_2_1',
  /** Level: 2.2 */
  LEVEL_2_2 = 'LEVEL_2_2',
  /** Level: 3.0 (Default) */
  LEVEL_3_0 = 'LEVEL_3_0',
  /** Level: 3.1 */
  LEVEL_3_1 = 'LEVEL_3_1',
  /** Level: 3.2 */
  LEVEL_3_2 = 'LEVEL_3_2',
  /** Level: 4.0 */
  LEVEL_4_0 = 'LEVEL_4_0',
  /** Level: 4.1 */
  LEVEL_4_1 = 'LEVEL_4_1',
  /** Level: 4.2 */
  LEVEL_4_2 = 'LEVEL_4_2',
  /** Level: 5.0 */
  LEVEL_5_0 = 'LEVEL_5_0',
  /** Level: 5.1 */
  LEVEL_5_1 = 'LEVEL_5_1',
  /** Level: 5.2 */
  LEVEL_5_2 = 'LEVEL_5_2',
  /** Level: 6.0 */
  LEVEL_6_0 = 'LEVEL_6_0',
  /** Level: 6.1 */
  LEVEL_6_1 = 'LEVEL_6_1',
  /** Level: 6.2 */
  LEVEL_6_2 = 'LEVEL_6_2'
}

export type LocalizedStringArrayInput = {
  /** Language is set as 2 character country code. */
  language: Scalars['String']['input'];
  values?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** A String representation of a type Field that is suitable for Localization */
export type LocalizedStringInput = {
  /** Localized field language code */
  language: Scalars['String']['input'];
  /** Localized field value */
  value: Scalars['String']['input'];
};

export type LoginInput = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
  provider?: InputMaybe<Scalars['String']['input']>;
};

export type MediaAttachmentInput = {
  /**
   * Alternative text descriptions for accessibility and SEO purposes.
   *
   *     Provides brief, descriptive text that explains the media content for screen readers and when the media cannot be displayed. Each entry supports different languages.
   */
  alt: Array<MediaLocalizedStringInput>;
  /** Unique company identifier that the attachment relates to. [Cannot use it together with customerId] */
  companyId?: InputMaybe<Scalars['Int']['input']>;
  /** Unique customer identifier that the attachment relates to. [Cannot use it together with companyId] */
  customerId?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Detailed descriptions of the media content.
   *
   *     Provides comprehensive information about what the media shows or contains. Used for search indexing and user information. Each entry supports different languages.
   */
  description: Array<MediaLocalizedStringInput>;
  /** Unique order identifier that the attachment relates to. [Cannot use it together with sparePartsMachineId] */
  orderId?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Display order priority for the media item.
   *
   *     Lower numeric values indicate higher priority and will be displayed first. Used for controlling the order of media items in galleries and listings.
   */
  priority?: InputMaybe<Scalars['Int']['input']>;
  /** Associates the media item with a specific spare parts machine */
  sparePartsMachineId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * Searchable tags for categorizing and filtering media content.
   *
   *     Keywords that help organize and discover media items. Used for search functionality and content organization. Each entry supports different languages with multiple tag values.
   */
  tags: Array<MediaLocalizedStringArrayInput>;
  /** Upload File input reference */
  uploadAttachments: Array<UploadFileInput>;
};

/** Search and filter criteria specifically for private attachment files */
export type MediaAttachmentSearchInput = {
  /**
   * Filter attachments owned by a specific company.
   *
   *     Retrieves attachments that belong to the specified company. Cannot be used simultaneously with customerId as attachments have a single owner type.
   */
  companyId?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Filter attachments owned by a specific customer.
   *
   *     Retrieves attachments that belong to the specified customer. Cannot be used simultaneously with companyId as attachments have a single owner type.
   */
  customerId?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Search within media item descriptions.
   *
   *     Performs text search against the description field in the specified language. Supports partial matching and is case-insensitive.
   */
  description?: InputMaybe<MediaLocalizedStringInput>;
  /**
   * Number of items per page.
   *
   *     Controls how many media items are returned in each page of results. Maximum recommended value is 50 for performance.
   */
  offset?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Filter attachments associated with a specific order.
   *
   *     Retrieves attachments linked to the specified order ID. Cannot be used simultaneously with sparePartsMachineId as attachments are associated with either orders or machines, not both.
   */
  orderId?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Page number for pagination.
   *
   *     Specifies which page of results to return. Pages start at 1.
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Sort order for search results.
   *
   *     Controls whether results are returned in ascending or descending order. Sorting is typically applied to the priority field or creation date.
   */
  sort?: InputMaybe<Sort>;
  /** Filter media items associated with a specific spare parts machine */
  sparePartsMachineId?: InputMaybe<Scalars['String']['input']>;
  /**
   * Search within media item tags.
   *
   *     Finds media items that have tags matching the specified value in the given language. Useful for content categorization and discovery.
   */
  tag?: InputMaybe<MediaLocalizedStringInput>;
};

/** File upload using base64 encoded content for direct data transmission */
export type MediaBase64FileInput = {
  /**
   * Base64 encoded representation of the file content.
   *
   *     The complete file data encoded in base64 format. Maximum size is approximately 10MB (13,981,017 characters). This method is useful for small files or when direct file upload is not available.
   */
  base64: Scalars['String']['input'];
  /**
   * Filename to use when creating the file from base64 data.
   *
   *     Must include the file extension and be between 5-255 characters. This name will be used for storage and affects how the file is processed and referenced.
   */
  fileName: Scalars['String']['input'];
};

export type MediaDocumentInput = {
  /**
   * Alternative text descriptions for accessibility and SEO purposes.
   *
   *     Provides brief, descriptive text that explains the media content for screen readers and when the media cannot be displayed. Each entry supports different languages.
   */
  alt: Array<MediaLocalizedStringInput>;
  /** Associates the media item with a specific product category */
  categoryId?: InputMaybe<Scalars['ID']['input']>;
  /** Associates the media item with a specific cluster */
  clusterId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * Detailed descriptions of the media content.
   *
   *     Provides comprehensive information about what the media shows or contains. Used for search indexing and user information. Each entry supports different languages.
   */
  description: Array<MediaLocalizedStringInput>;
  /**
   * Display order priority for the media item.
   *
   *     Lower numeric values indicate higher priority and will be displayed first. Used for controlling the order of media items in galleries and listings.
   */
  priority?: InputMaybe<Scalars['Int']['input']>;
  /** Associates the media item with a specific product */
  productId?: InputMaybe<Scalars['ID']['input']>;
  /** Associates the media item with a specific spare parts machine */
  sparePartsMachineId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * Searchable tags for categorizing and filtering media content.
   *
   *     Keywords that help organize and discover media items. Used for search functionality and content organization. Each entry supports different languages with multiple tag values.
   */
  tags: Array<MediaLocalizedStringArrayInput>;
  /** Upload File input reference */
  uploadDocuments: Array<UploadFileInput>;
};

/** Search criteria for documents associated with a specific product, excluding entity association fields */
export type MediaDocumentProductSearchInput = {
  /**
   * Search within media item descriptions.
   *
   *     Performs text search against the description field in the specified language. Supports partial matching and is case-insensitive.
   */
  description?: InputMaybe<MediaLocalizedStringInput>;
  /**
   * Number of items per page.
   *
   *     Controls how many media items are returned in each page of results. Maximum recommended value is 50 for performance.
   */
  offset?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Page number for pagination.
   *
   *     Specifies which page of results to return. Pages start at 1.
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Sort order for search results.
   *
   *     Controls whether results are returned in ascending or descending order. Sorting is typically applied to the priority field or creation date.
   */
  sort?: InputMaybe<Sort>;
  /**
   * Search within media item tags.
   *
   *     Finds media items that have tags matching the specified value in the given language. Useful for content categorization and discovery.
   */
  tag?: InputMaybe<MediaLocalizedStringInput>;
};

/** Search and filter criteria specifically for document media items */
export type MediaDocumentSearchInput = {
  /** Filter media items associated with a specific product category */
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  /** Filter media items associated with a specific cluster */
  clusterId?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Search within media item descriptions.
   *
   *     Performs text search against the description field in the specified language. Supports partial matching and is case-insensitive.
   */
  description?: InputMaybe<MediaLocalizedStringInput>;
  /**
   * Number of items per page.
   *
   *     Controls how many media items are returned in each page of results. Maximum recommended value is 50 for performance.
   */
  offset?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Page number for pagination.
   *
   *     Specifies which page of results to return. Pages start at 1.
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /** Filter media items associated with a specific product */
  productId?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Sort order for search results.
   *
   *     Controls whether results are returned in ascending or descending order. Sorting is typically applied to the priority field or creation date.
   */
  sort?: InputMaybe<Sort>;
  /** Filter media items associated with a specific spare parts machine */
  sparePartsMachineId?: InputMaybe<Scalars['String']['input']>;
  /**
   * Search within media item tags.
   *
   *     Finds media items that have tags matching the specified value in the given language. Useful for content categorization and discovery.
   */
  tag?: InputMaybe<MediaLocalizedStringInput>;
};

export type MediaImageInput = {
  /**
   * Alternative text descriptions for accessibility and SEO purposes.
   *
   *     Provides brief, descriptive text that explains the media content for screen readers and when the media cannot be displayed. Each entry supports different languages.
   */
  alt: Array<MediaLocalizedStringInput>;
  /** Associates the media item with a specific product category */
  categoryId?: InputMaybe<Scalars['ID']['input']>;
  /** Associates the media item with a specific cluster */
  clusterId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * Detailed descriptions of the media content.
   *
   *     Provides comprehensive information about what the media shows or contains. Used for search indexing and user information. Each entry supports different languages.
   */
  description: Array<MediaLocalizedStringInput>;
  /**
   * Display order priority for the media item.
   *
   *     Lower numeric values indicate higher priority and will be displayed first. Used for controlling the order of media items in galleries and listings.
   */
  priority?: InputMaybe<Scalars['Int']['input']>;
  /** Associates the media item with a specific product */
  productId?: InputMaybe<Scalars['ID']['input']>;
  /** Associates the media item with a specific spare parts machine */
  sparePartsMachineId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * Searchable tags for categorizing and filtering media content.
   *
   *     Keywords that help organize and discover media items. Used for search functionality and content organization. Each entry supports different languages with multiple tag values.
   */
  tags: Array<MediaLocalizedStringArrayInput>;
  /** Upload File input reference */
  uploadImages: Array<UploadFileInput>;
};

/** Search criteria for images associated with a specific product, excluding entity association fields */
export type MediaImageProductSearchInput = {
  /**
   * Search within media item descriptions.
   *
   *     Performs text search against the description field in the specified language. Supports partial matching and is case-insensitive.
   */
  description?: InputMaybe<MediaLocalizedStringInput>;
  /**
   * Number of items per page.
   *
   *     Controls how many media items are returned in each page of results. Maximum recommended value is 50 for performance.
   */
  offset?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Page number for pagination.
   *
   *     Specifies which page of results to return. Pages start at 1.
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Sort order for search results.
   *
   *     Controls whether results are returned in ascending or descending order. Sorting is typically applied to the priority field or creation date.
   */
  sort?: InputMaybe<Sort>;
  /**
   * Search within media item tags.
   *
   *     Finds media items that have tags matching the specified value in the given language. Useful for content categorization and discovery.
   */
  tag?: InputMaybe<MediaLocalizedStringInput>;
};

/** Search and filter criteria specifically for image media items */
export type MediaImageSearchInput = {
  /** Filter media items associated with a specific product category */
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  /** Filter media items associated with a specific cluster */
  clusterId?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Search within media item descriptions.
   *
   *     Performs text search against the description field in the specified language. Supports partial matching and is case-insensitive.
   */
  description?: InputMaybe<MediaLocalizedStringInput>;
  /**
   * Number of items per page.
   *
   *     Controls how many media items are returned in each page of results. Maximum recommended value is 50 for performance.
   */
  offset?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Page number for pagination.
   *
   *     Specifies which page of results to return. Pages start at 1.
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /** Filter media items associated with a specific product */
  productId?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Sort order for search results.
   *
   *     Controls whether results are returned in ascending or descending order. Sorting is typically applied to the priority field or creation date.
   */
  sort?: InputMaybe<Sort>;
  /** Filter media items associated with a specific spare parts machine */
  sparePartsMachineId?: InputMaybe<Scalars['String']['input']>;
  /**
   * Search within media item tags.
   *
   *     Finds media items that have tags matching the specified value in the given language. Useful for content categorization and discovery.
   */
  tag?: InputMaybe<MediaLocalizedStringInput>;
};

/** Localized array of string values with language specification for tags and multi-value fields */
export type MediaLocalizedStringArrayInput = {
  /**
   * Language code for the localized content.
   *
   *     Must be a valid 2-character language code (e.g., 'EN', 'DE', 'FR'). Used to identify the language of the associated string array values for proper localization and display.
   */
  language: Scalars['String']['input'];
  /**
   * Array of text values in the specified language.
   *
   *     Multiple string values for the specified language, commonly used for tags, keywords, or categories. Each value should be meaningful and relevant to the associated media content.
   */
  values?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Localized string value with language specification for internationalization support */
export type MediaLocalizedStringInput = {
  /**
   * Language code for the localized content.
   *
   *     Must be a valid 2-character language code (e.g., 'EN', 'DE', 'FR'). Used to identify the language of the associated text value for proper localization and display.
   */
  language: Scalars['String']['input'];
  /**
   * Text content in the specified language.
   *
   *     The actual text value for the specified language. Must be between 3-255 characters and contain meaningful content for the associated field.
   */
  value: Scalars['String']['input'];
};

export type MediaVideoInput = {
  /**
   * Alternative text descriptions for accessibility and SEO purposes.
   *
   *     Provides brief, descriptive text that explains the media content for screen readers and when the media cannot be displayed. Each entry supports different languages.
   */
  alt: Array<MediaLocalizedStringInput>;
  /** Associates the media item with a specific product category */
  categoryId?: InputMaybe<Scalars['ID']['input']>;
  /** Associates the media item with a specific cluster */
  clusterId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * Detailed descriptions of the media content.
   *
   *     Provides comprehensive information about what the media shows or contains. Used for search indexing and user information. Each entry supports different languages.
   */
  description: Array<MediaLocalizedStringInput>;
  /**
   * Display order priority for the media item.
   *
   *     Lower numeric values indicate higher priority and will be displayed first. Used for controlling the order of media items in galleries and listings.
   */
  priority?: InputMaybe<Scalars['Int']['input']>;
  /** Associates the media item with a specific product */
  productId?: InputMaybe<Scalars['ID']['input']>;
  /** Associates the media item with a specific spare parts machine */
  sparePartsMachineId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * Searchable tags for categorizing and filtering media content.
   *
   *     Keywords that help organize and discover media items. Used for search functionality and content organization. Each entry supports different languages with multiple tag values.
   */
  tags: Array<MediaLocalizedStringArrayInput>;
  /** Store Video input reference */
  videos: Array<UploadVideoInput>;
};

/** Search criteria for videos associated with a specific product, excluding entity association fields */
export type MediaVideoProductSearchInput = {
  /**
   * Search within media item descriptions.
   *
   *     Performs text search against the description field in the specified language. Supports partial matching and is case-insensitive.
   */
  description?: InputMaybe<MediaLocalizedStringInput>;
  /**
   * Number of items per page.
   *
   *     Controls how many media items are returned in each page of results. Maximum recommended value is 50 for performance.
   */
  offset?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Page number for pagination.
   *
   *     Specifies which page of results to return. Pages start at 1.
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Sort order for search results.
   *
   *     Controls whether results are returned in ascending or descending order. Sorting is typically applied to the priority field or creation date.
   */
  sort?: InputMaybe<Sort>;
  /**
   * Search within media item tags.
   *
   *     Finds media items that have tags matching the specified value in the given language. Useful for content categorization and discovery.
   */
  tag?: InputMaybe<MediaLocalizedStringInput>;
};

/** Search and filter criteria specifically for video media items */
export type MediaVideoSearchInput = {
  /** Filter media items associated with a specific product category */
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  /** Filter media items associated with a specific cluster */
  clusterId?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Search within media item descriptions.
   *
   *     Performs text search against the description field in the specified language. Supports partial matching and is case-insensitive.
   */
  description?: InputMaybe<MediaLocalizedStringInput>;
  /**
   * Number of items per page.
   *
   *     Controls how many media items are returned in each page of results. Maximum recommended value is 50 for performance.
   */
  offset?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Page number for pagination.
   *
   *     Specifies which page of results to return. Pages start at 1.
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /** Filter media items associated with a specific product */
  productId?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Sort order for search results.
   *
   *     Controls whether results are returned in ascending or descending order. Sorting is typically applied to the priority field or creation date.
   */
  sort?: InputMaybe<Sort>;
  /** Filter media items associated with a specific spare parts machine */
  sparePartsMachineId?: InputMaybe<Scalars['String']['input']>;
  /**
   * Search within media item tags.
   *
   *     Finds media items that have tags matching the specified value in the given language. Useful for content categorization and discovery.
   */
  tag?: InputMaybe<MediaLocalizedStringInput>;
};

export type ObjectMediaSearchInput = {
  /**
   * Search within media item descriptions.
   *
   *     Performs text search against the description field in the specified language. Supports partial matching and is case-insensitive.
   */
  description?: InputMaybe<MediaLocalizedStringInput>;
  /**
   * Number of items per page.
   *
   *     Controls how many media items are returned in each page of results. Maximum recommended value is 50 for performance.
   */
  offset?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Page number for pagination.
   *
   *     Specifies which page of results to return. Pages start at 1.
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Sort order for search results.
   *
   *     Controls whether results are returned in ascending or descending order. Sorting is typically applied to the priority field or creation date.
   */
  sort?: InputMaybe<Sort>;
  /**
   * Search within media item tags.
   *
   *     Finds media items that have tags matching the specified value in the given language. Useful for content categorization and discovery.
   */
  tag?: InputMaybe<MediaLocalizedStringInput>;
};

/**
 * The optimize parameter automatically applies optimal quality compression to produce an output image with as much visual fidelity as possible, while minimizing the file size.
 *
 *   NOTE:
 *   1. Optimize is currently supported by the following output formats: JPEG, WebP.
 *   2. If the quality parameter is also provided, quality overrides optimize because it is more precise.
 *   3. Because optimize attempts to produce an output image with as much visual quality as possible while minimizing the file size, the operations applied are subject to change.
 */
export enum Optimize {
  /** Minor visual artifacts may be visible. This produces the smallest file. */
  HIGH = 'HIGH',
  /** Output image quality will be similar to the input image quality. */
  LOW = 'LOW',
  /** More optimization is allowed. We attempt to preserve the visual quality of the input image. */
  MEDIUM = 'MEDIUM'
}

export type OrderCreateInput = {
  /** User ID of the Account Manager of the order */
  accountManagerId?: InputMaybe<Scalars['Int']['input']>;
  /** Accounting ID of the Order */
  accountingId?: InputMaybe<Scalars['String']['input']>;
  /** Active actioncode that was applied to this Order  */
  actionCode?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the Cart the Order belongs to */
  cartId?: InputMaybe<Scalars['String']['input']>;
  /** Channel ID the Order belongs to */
  channelId?: InputMaybe<Scalars['Int']['input']>;
  /** ID of the Company of the Order */
  companyId?: InputMaybe<Scalars['Int']['input']>;
  /** A company source */
  companySource?: InputMaybe<SourceInput>;
  /** Order currency - ISO 4217 currency code => https://www.xe.com/iso4217.php */
  currency: Scalars['String']['input'];
  /** Currency conversion ratio compared the the Order's Shop's base currency */
  currencyRatio?: InputMaybe<Scalars['Float']['input']>;
  /** Company name of the Debtor [USED FOR ORDER SEARCH ONLY] */
  debtorCompany?: InputMaybe<Scalars['String']['input']>;
  /** First name of the Debtor [USED FOR ORDER SEARCH ONLY] */
  debtorFirstName?: InputMaybe<Scalars['String']['input']>;
  /** Debtor ID of the  User, Contact or Customer  */
  debtorId?: InputMaybe<Scalars['String']['input']>;
  /** Last name of the Debtor [USED FOR ORDER SEARCH ONLY] */
  debtorLastName?: InputMaybe<Scalars['String']['input']>;
  /** Email address used for communication about this Order */
  email: Scalars['String']['input'];
  /** Order export message */
  exportMessage?: InputMaybe<Scalars['String']['input']>;
  /** Order export status of this order */
  exportStatus?: InputMaybe<OrderExportStatus>;
  /** The date and time the order was exported */
  exportedAt?: InputMaybe<Scalars['String']['input']>;
  /** ID of the Order in an external system */
  externalId?: InputMaybe<Scalars['String']['input']>;
  /**
   * extra3: Open text field to add meta data on an Order.
   *     The field will not be visible to Propeller admins, but can be used to be displayed on front-ends or be used in integrations.
   */
  extra3?: InputMaybe<Scalars['String']['input']>;
  /**
   * extra4: Open text field to add meta data on an Order.
   *     The field will not be visible to Propeller admins, but can be used to be displayed on front-ends or be used in integrations.
   */
  extra4?: InputMaybe<Scalars['String']['input']>;
  /** ID of the User, Contact or Customer that should receive the invoice for this Order */
  invoiceUserId?: InputMaybe<Scalars['Int']['input']>;
  /** The OrderItem to create with the Order as a single bulk request */
  items?: Array<OrderItemCreateInput>;
  /** Order language - ISO 639-1 language code => https://localizely.com/iso-639-1-list/ */
  language: Scalars['String']['input'];
  /** Original order id */
  originalOrderId?: InputMaybe<Scalars['Int']['input']>;
  /** Order's payment data */
  paymentData: OrderPaymentInput;
  /** Order's postage data */
  postageData: OrderPostageInput;
  /** Company name of the Recipient [USED FOR ORDER SEARCH ONLY] */
  recipientCompany?: InputMaybe<Scalars['String']['input']>;
  /** First name of the Recipient [USED FOR ORDER SEARCH ONLY] */
  recipientFirstName?: InputMaybe<Scalars['String']['input']>;
  /** Last name of the Recipient [USED FOR ORDER SEARCH ONLY] */
  recipientLastName?: InputMaybe<Scalars['String']['input']>;
  /** Reference by the customer */
  reference?: InputMaybe<Scalars['String']['input']>;
  /** Remarks by the customer */
  remarks?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the shop the Order belongs to */
  shopId: Scalars['Int']['input'];
  /** Source of the Order i.e. webshop, internal, external or api */
  source?: InputMaybe<Scalars['String']['input']>;
  /** Status of the Order */
  status: Scalars['String']['input'];
  /** Order's totals, tax and global discount */
  total: OrderTotalInput;
  /** Type of the Order */
  type: OrderType;
  /** ID of the User, Contact or Customer of the Order */
  userId: Scalars['Int']['input'];
  /** Date and time until the order is valid */
  validUntil?: InputMaybe<Scalars['String']['input']>;
  /** Value points collected with this Order */
  valuePoints?: InputMaybe<Scalars['Int']['input']>;
};

/** Order discount types */
export enum OrderDiscountType {
  /** Absolute discount */
  A = 'A',
  /** No discount */
  N = 'N',
  /** Percentage discount */
  P = 'P'
}

/** Available order export statuses */
export enum OrderExportStatus {
  /** No export status available */
  EMPTY = 'EMPTY',
  /** Order exported */
  EXPORTED = 'EXPORTED',
  /** Order export failed */
  FAILED = 'FAILED',
  /** Order finished */
  FINISHED = 'FINISHED'
}

/** Class of the order item */
export enum OrderItemClass {
  incentive = 'incentive',
  payment = 'payment',
  postage = 'postage',
  product = 'product',
  surcharge = 'surcharge'
}

export type OrderItemCreateInput = {
  /** The class of the orderItem. Either product, incentive, surcharge, postage, payment */
  class: OrderItemClass;
  /** The cost price of the OrderItem */
  costPrice?: InputMaybe<Scalars['Float']['input']>;
  /** The calculated customerPrice of the OrderItem at the time the order was placed */
  customerPrice?: InputMaybe<Scalars['Float']['input']>;
  /** The discount of the OrderItem */
  discount?: InputMaybe<Scalars['Float']['input']>;
  /** The eanCode of the product of the OrderItem */
  eanCode?: InputMaybe<Scalars['String']['input']>;
  /** Is the OrderItem a bonusItem? */
  isBonus: YesNo;
  /** The manufacturer of the product of the OrderItem */
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  /** The manufacturerCode of the product of the OrderItem */
  manufacturerCode?: InputMaybe<Scalars['String']['input']>;
  /** The minimum quantity of the product of the OrderItem */
  minimumQuantity?: InputMaybe<Scalars['Int']['input']>;
  /** The minimum quantity of the product of the OrderItem */
  minumumQuantity?: InputMaybe<Scalars['Int']['input']>;
  /** The name of the product of the OrderItem */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Remarks by the customer for the OrderItem */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** The original price of the OrderItem, before applying any discounts */
  originalPrice: Scalars['Float']['input'];
  /** The package of the product of the OrderItem */
  package?: InputMaybe<Scalars['String']['input']>;
  /** The package unit of the product of the OrderItem */
  packageUnit?: InputMaybe<Scalars['String']['input']>;
  /** The package unit quantity of the product of the OrderItem */
  packageUnitQuantity?: InputMaybe<Scalars['String']['input']>;
  /** The ID of the parent OrderItem */
  parentOrderItemId?: InputMaybe<Scalars['Int']['input']>;
  /** The UUID of the parent OrderItem, this can be used in bulk operations where the auto-increment ID's are not known */
  parentOrderItemUUID?: InputMaybe<Scalars['String']['input']>;
  /** The calculated price per unit excluding tax */
  price: Scalars['Float']['input'];
  /** The calculated price per unit including tax */
  priceNet?: InputMaybe<Scalars['Float']['input']>;
  /** The total price of the OrderItem excluding tax */
  priceTotal: Scalars['Float']['input'];
  /** The total price of the OrderItem including tax */
  priceTotalNet?: InputMaybe<Scalars['Float']['input']>;
  /** The productId of the OrderItem */
  productId?: InputMaybe<Scalars['Int']['input']>;
  /** A product source */
  productSource?: InputMaybe<SourceInput>;
  /** The purchase minimum quantity of the product of the OrderItem */
  purchaseMinimumQuantity?: InputMaybe<Scalars['Int']['input']>;
  /** The purchase unit of the product of the OrderItem */
  purchaseUnit?: InputMaybe<Scalars['Int']['input']>;
  /** The quantity of the OrderItem */
  quantity: Scalars['Int']['input'];
  /** Requested delivery date for this orderline */
  requestDate?: InputMaybe<Scalars['String']['input']>;
  /** The SKU of the product of the OrderItem */
  sku: Scalars['String']['input'];
  /** The supplier of the product of the OrderItem */
  supplier?: InputMaybe<Scalars['String']['input']>;
  /** The supplierCode of the product of the OrderItem */
  supplierCode?: InputMaybe<Scalars['String']['input']>;
  /** The total tax of the OrderItem */
  tax?: InputMaybe<Scalars['Float']['input']>;
  /** The tax code of the OrderItem */
  taxCode: Taxcode;
  /** The tax percentage of the OrderItem */
  taxPercentage: Scalars['Int']['input'];
  /** The unit of the product of the OrderItem */
  unit?: InputMaybe<Scalars['Int']['input']>;
  /** The UUID for the OrderItem */
  uuid?: InputMaybe<Scalars['String']['input']>;
};

export type OrderItemUpdateInput = {
  /** The costprice of the orderitem */
  costPrice?: InputMaybe<Scalars['Float']['input']>;
  /** The calculated user specific price of the orderitem, before applying any additional discounts */
  customerPrice?: InputMaybe<Scalars['Float']['input']>;
  /** The discount applied to this orderitem */
  discount: Scalars['Float']['input'];
  /** The ID of the orderitem to update. */
  id: Scalars['Int']['input'];
  /** The orderitem notes */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** The original price of the OrderItem, before applying any discounts */
  originalPrice: Scalars['Float']['input'];
  /** The gross price per unit excluding tax */
  price: Scalars['Float']['input'];
  /** The calculated price per unit including tax */
  priceNet?: InputMaybe<Scalars['Float']['input']>;
  /** The total price of the orderitem excluding tax */
  priceTotal: Scalars['Float']['input'];
  /** The total price of the OrderItem including tax */
  priceTotalNet?: InputMaybe<Scalars['Float']['input']>;
  /** The quantity of the orderitem */
  quantity: Scalars['Int']['input'];
  /** Requested delivery date for this orderline */
  requestDate?: InputMaybe<Scalars['String']['input']>;
  /** The amount of tax applied to this orderitem */
  tax: Scalars['Float']['input'];
  /** The tax code of the OrderItem */
  taxCode: Taxcode;
  /** The tax percentage applied to this orderitem */
  taxPercentage: Scalars['Int']['input'];
};

export type OrderPaymentInput = {
  /** The accountingId that belongs to this order */
  accountingId?: InputMaybe<Scalars['String']['input']>;
  /** The transaction cost excluding tax */
  gross: Scalars['Float']['input'];
  /** The paymethod for this Order */
  method: Scalars['String']['input'];
  /** The transaction cost including tax */
  net: Scalars['Float']['input'];
  /** Whether the transaction costs for this order are overruled, if N, the shipping costs will be recalculated on every mutation */
  overruled?: InputMaybe<YesNo>;
  /** The transaction status */
  status?: InputMaybe<Scalars['String']['input']>;
  /** Last time the transaction status was changed */
  statusDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** The transaction cost tax */
  tax: Scalars['Float']['input'];
  /** The transaction costs tax percentage */
  taxPercentage: Scalars['Float']['input'];
};

export type OrderPaymentUpdateInput = {
  /** The accountingId that belongs to this order */
  accountingId?: InputMaybe<Scalars['String']['input']>;
  /** The transaction cost excluding tax */
  gross?: InputMaybe<Scalars['Float']['input']>;
  /** The paymethod for this Order */
  method?: InputMaybe<Scalars['String']['input']>;
  /** The transaction cost including tax */
  net?: InputMaybe<Scalars['Float']['input']>;
  /** Whether the transaction costs for this order are overruled, if N, the shipping costs will be recalculated on every mutation */
  overruled?: InputMaybe<YesNo>;
  /** The transaction status */
  status?: InputMaybe<Scalars['String']['input']>;
  /** Last time the transaction status was changed */
  statusDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** The transaction cost tax */
  tax?: InputMaybe<Scalars['Float']['input']>;
  /** The transaction costs tax percentage */
  taxPercentage?: InputMaybe<Scalars['Float']['input']>;
};

export type OrderPostageInput = {
  /** The selected carrier for this Order */
  carrier?: InputMaybe<Scalars['String']['input']>;
  /** The shipping costs excluding tax */
  gross: Scalars['Float']['input'];
  /** The chosen shipping method */
  method: Scalars['String']['input'];
  /** The shipping costs including tax */
  net: Scalars['Float']['input'];
  /** Whether the shipping costs for this order are overruled, if N, the shipping costs will be recalculated on every mutation */
  overruled?: InputMaybe<YesNo>;
  /** Is partial delivery allowed for this Order */
  partialDeliveryAllowed?: InputMaybe<YesNo>;
  /** ID of the pick up location when the Order's shipping method is PICKUP */
  pickUpLocationId?: InputMaybe<Scalars['Int']['input']>;
  /** The provided delivery date for the Order */
  requestDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** The shipping costs tax */
  tax: Scalars['Float']['input'];
  /** The shipping costs tax percentage */
  taxPercentage: Scalars['Float']['input'];
};

export type OrderPostageUpdateInput = {
  /** The selected carrier for this Order */
  carrier?: InputMaybe<Scalars['String']['input']>;
  /** The shipping costs excluding tax */
  gross?: InputMaybe<Scalars['Float']['input']>;
  /** The chosen shipping method */
  method?: InputMaybe<Scalars['String']['input']>;
  /** The shipping costs including tax */
  net?: InputMaybe<Scalars['Float']['input']>;
  /** Whether the shipping costs for this order are overruled, if N, the shipping costs will be recalculated on every mutation */
  overruled?: InputMaybe<YesNo>;
  /** Is partial delivery allowed for this Order */
  partialDeliveryAllowed?: InputMaybe<YesNo>;
  /** ID of the pick up location when the Order's shipping method is PICKUP */
  pickUpLocationId?: InputMaybe<Scalars['Int']['input']>;
  /** The provided delivery date for the Order */
  requestDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** The shipping costs tax */
  tax?: InputMaybe<Scalars['Float']['input']>;
  /** The shipping costs tax percentage */
  taxPercentage?: InputMaybe<Scalars['Float']['input']>;
};

export type OrderSearchArguments = {
  /** Search by company ids */
  companyIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** List of company sources */
  companySources?: InputMaybe<Array<SourceInput>>;
  /** Search by date created */
  createdAt?: InputMaybe<DateSearchInput>;
  /** Only search for orders with export status */
  exportStatuses?: InputMaybe<Array<OrderExportStatus>>;
  /** Search by export date */
  exportedAt?: InputMaybe<DateSearchInput>;
  /** Search by date changed */
  lastModifiedAt?: InputMaybe<DateSearchInput>;
  /** Pagination offset number */
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Search by original order ids */
  originalOrderIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Pagination page number */
  page?: InputMaybe<Scalars['Int']['input']>;
  /** Search by price range */
  price?: InputMaybe<DecimalSearchInput>;
  /** Inputs to sort by */
  sortInputs?: InputMaybe<Array<OrderSortInput>>;
  /** Only search for orders in these statuses */
  status?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Search term */
  term?: InputMaybe<Scalars['String']['input']>;
  /** List of fields to search in */
  termFields?: InputMaybe<Array<OrderSearchFields>>;
  /** Only search for orders of the types */
  type?: InputMaybe<Array<OrderType>>;
  /** Pass one order more userId's to retrieve order for */
  userId?: InputMaybe<Array<Scalars['Int']['input']>>;
};

/** Available fields to search for in an order */
export enum OrderSearchFields {
  /** Accounting Unique Identifier */
  ACCOUNTING_ID = 'ACCOUNTING_ID',
  /** Debtor Unique Identifier */
  DEBTOR_ID = 'DEBTOR_ID',
  /** External Order Unique Identifier */
  EXTERNAL_ORDER_ID = 'EXTERNAL_ORDER_ID',
  /** Extra field 3 */
  EXTRA3 = 'EXTRA3',
  /** Extra field 4 */
  EXTRA4 = 'EXTRA4',
  ID = 'ID',
  /** Debtor Company [From Invoice Address] */
  INVOICE_ADDRESS_COMPANY = 'INVOICE_ADDRESS_COMPANY',
  /** Debtor First Name [From Invoice Address] */
  INVOICE_ADDRESS_FIRST_NAME = 'INVOICE_ADDRESS_FIRST_NAME',
  /** Debtor Last Name [From Invoice Address] */
  INVOICE_ADDRESS_LAST_NAME = 'INVOICE_ADDRESS_LAST_NAME',
  /** Item EAN Code */
  ITEM_EAN_CODE = 'ITEM_EAN_CODE',
  /** Item Manufacturer */
  ITEM_MANUFACTURER = 'ITEM_MANUFACTURER',
  /** Item Manufacturer Code */
  ITEM_MANUFACTURER_CODE = 'ITEM_MANUFACTURER_CODE',
  /** Item Name */
  ITEM_NAME = 'ITEM_NAME',
  /** Item Notes */
  ITEM_NOTES = 'ITEM_NOTES',
  /** Item SKU */
  ITEM_SKU = 'ITEM_SKU',
  /** Item Supplier */
  ITEM_SUPPLIER = 'ITEM_SUPPLIER',
  /** Item Supplier Code */
  ITEM_SUPPLIER_CODE = 'ITEM_SUPPLIER_CODE',
  /** Recipient Company [From Delivery Address] */
  RECIPIENT_COMPANY = 'RECIPIENT_COMPANY',
  /** Recipient Email [From Delivery Address] */
  RECIPIENT_EMAIL = 'RECIPIENT_EMAIL',
  /** Recipient First Name [From Delivery Address] */
  RECIPIENT_FIRST_NAME = 'RECIPIENT_FIRST_NAME',
  /** Recipient Last Name [From Delivery Address] */
  RECIPIENT_LAST_NAME = 'RECIPIENT_LAST_NAME',
  /** Reference */
  REFERENCE = 'REFERENCE',
  /** Remarks */
  REMARKS = 'REMARKS'
}

export type OrderSetStatusInput = {
  /** Add the order overview as attached PDF to the order confirmation email */
  addPDFAttachment?: InputMaybe<Scalars['Boolean']['input']>;
  /** Delete the cart that created this order if the cart is still available */
  deleteCart?: InputMaybe<Scalars['Boolean']['input']>;
  /** The id of the order to set the status for */
  orderId: Scalars['Int']['input'];
  /** The payment status of the order */
  payStatus?: InputMaybe<Scalars['String']['input']>;
  /** Send the order confirmation email when the status is changed */
  sendOrderConfirmationEmail?: InputMaybe<Scalars['Boolean']['input']>;
  /** The status of the order */
  status?: InputMaybe<Scalars['String']['input']>;
};

export enum OrderSortField {
  COMPANY = 'COMPANY',
  CREATED_AT = 'CREATED_AT',
  ID = 'ID',
  LAST_MODIFIED_AT = 'LAST_MODIFIED_AT',
  STATUS = 'STATUS',
  TOTAL_GROSS = 'TOTAL_GROSS'
}

export type OrderSortInput = {
  /** Field to sort by */
  field: OrderSortField;
  /** Order option to sort by. [Default to `ASC`] */
  order?: SortOrder;
};

export type OrderTotalInput = {
  /** The type of global discount */
  discountType: OrderDiscountType;
  /** The discount value, can be absolute or a percentage depending on the discountType */
  discountValue: Scalars['Float']['input'];
  /** The total of this Order excluding tax */
  gross: Scalars['Float']['input'];
  /** The total of this Order including tax */
  net: Scalars['Float']['input'];
  /** The total amount of tax for this Order */
  tax: Scalars['Float']['input'];
};

export type OrderTotalUpdateInput = {
  /** The type of global discount */
  discountType?: InputMaybe<OrderDiscountType>;
  /** The discount value, can be absolute or a percentage depending on the discountType */
  discountValue?: InputMaybe<Scalars['Float']['input']>;
  /** The total of this Order excluding tax */
  gross?: InputMaybe<Scalars['Float']['input']>;
  /** The total of this Order including tax */
  net?: InputMaybe<Scalars['Float']['input']>;
  /** The total amount of tax for this Order */
  tax?: InputMaybe<Scalars['Float']['input']>;
};

/** Available order types */
export enum OrderType {
  /** Dropshipment order */
  dropshipment = 'dropshipment',
  /** Purchase order */
  purchase = 'purchase',
  /** Quotation order */
  quotation = 'quotation',
  /** Stock order */
  stock = 'stock'
}

export type OrderUpdateAddressInput = {
  /** Address city */
  city?: InputMaybe<Scalars['String']['input']>;
  /** Address code */
  code?: InputMaybe<Scalars['String']['input']>;
  /** User company the address applies to */
  company?: InputMaybe<Scalars['String']['input']>;
  /** Address country */
  country?: InputMaybe<Scalars['String']['input']>;
  /** Address email [valid email format required] */
  email?: InputMaybe<Scalars['String']['input']>;
  /** User first name the address applies to */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** User gender the address applies to */
  gender?: InputMaybe<Gender>;
  /** ICP address field defines whether tax should be applied to an order if the address is selected as a delivery address. Used when shipping b2b order abroad */
  icp?: InputMaybe<YesNo>;
  /** User last name the address applies to */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** User middle name the address applies to */
  middleName?: InputMaybe<Scalars['String']['input']>;
  /** Address mobile number [min: 6, max: 20] */
  mobile?: InputMaybe<Scalars['String']['input']>;
  /** Address delivery notes */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** User street number */
  number?: InputMaybe<Scalars['String']['input']>;
  /** User street number extension */
  numberExtension?: InputMaybe<Scalars['String']['input']>;
  /** Address fixed phone number [min: 6, max: 20] */
  phone?: InputMaybe<Scalars['String']['input']>;
  /** Address postal code */
  postalCode?: InputMaybe<Scalars['String']['input']>;
  /** Address region */
  region?: InputMaybe<Scalars['String']['input']>;
  /** User street address */
  street?: InputMaybe<Scalars['String']['input']>;
};

export type OrderUpdateInput = {
  /** User ID of the Account Manager of the order */
  accountManagerId?: InputMaybe<Scalars['Int']['input']>;
  /** Accounting ID of the Order */
  accountingId?: InputMaybe<Scalars['String']['input']>;
  /** Active actioncode that was applied to this Order  */
  actionCode?: InputMaybe<Scalars['String']['input']>;
  /** Channel ID the Order belongs to */
  channelId?: InputMaybe<Scalars['Int']['input']>;
  /** ID of the Company of the Order */
  companyId?: InputMaybe<Scalars['Int']['input']>;
  /** A company source */
  companySource?: InputMaybe<SourceInput>;
  /** Order currency - ISO 4217 currency code => https://www.xe.com/iso4217.php */
  currency?: InputMaybe<Scalars['String']['input']>;
  /** Currency conversion ratio compared the the Order's Shop's base currency */
  currencyRatio?: InputMaybe<Scalars['Float']['input']>;
  /** Company name of the Debtor [USED FOR ORDER SEARCH ONLY] */
  debtorCompany?: InputMaybe<Scalars['String']['input']>;
  /** First name of the Debtor [USED FOR ORDER SEARCH ONLY] */
  debtorFirstName?: InputMaybe<Scalars['String']['input']>;
  /** Debtor ID of the  User, Contact or Customer  */
  debtorId?: InputMaybe<Scalars['String']['input']>;
  /** Last name of the Debtor [USED FOR ORDER SEARCH ONLY] */
  debtorLastName?: InputMaybe<Scalars['String']['input']>;
  /** Email address used for communication about this Order */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Order export message */
  exportMessage?: InputMaybe<Scalars['String']['input']>;
  /** Order export status of this order */
  exportStatus?: InputMaybe<OrderExportStatus>;
  /** The date and time the order was exported */
  exportedAt?: InputMaybe<Scalars['String']['input']>;
  /** ID of the Order in an external system */
  externalId?: InputMaybe<Scalars['String']['input']>;
  /**
   * extra3: Open text field to add meta data on an Order.
   *     The field will not be visible to Propeller admins, but can be used to be displayed on front-ends or be used in integrations.
   */
  extra3?: InputMaybe<Scalars['String']['input']>;
  /**
   * extra4: Open text field to add meta data on an Order.
   *     The field will not be visible to Propeller admins, but can be used to be displayed on front-ends or be used in integrations.
   */
  extra4?: InputMaybe<Scalars['String']['input']>;
  /** ID of the User, Contact or Customer that should receive the invoice for this Order */
  invoiceUserId?: InputMaybe<Scalars['Int']['input']>;
  /** The OrderItem to create or update with the Order as a single bulk request */
  items?: InputMaybe<Array<CreateOrUpdateOrderItemInput>>;
  /** Order language - ISO 639-1 language code => https://localizely.com/iso-639-1-list/ */
  language?: InputMaybe<Scalars['String']['input']>;
  /** Original order id */
  originalOrderId?: InputMaybe<Scalars['Int']['input']>;
  /** Order's payment data */
  paymentData?: InputMaybe<OrderPaymentUpdateInput>;
  /** Order's postage data */
  postageData?: InputMaybe<OrderPostageUpdateInput>;
  /** Company name of the Recipient [USED FOR ORDER SEARCH ONLY] */
  recipientCompany?: InputMaybe<Scalars['String']['input']>;
  /** First name of the Recipient [USED FOR ORDER SEARCH ONLY] */
  recipientFirstName?: InputMaybe<Scalars['String']['input']>;
  /** Last name of the Recipient [USED FOR ORDER SEARCH ONLY] */
  recipientLastName?: InputMaybe<Scalars['String']['input']>;
  /** Reference by the customer */
  reference?: InputMaybe<Scalars['String']['input']>;
  /** Remarks by the customer */
  remarks?: InputMaybe<Scalars['String']['input']>;
  /** Source of the Order i.e. webshop, internal, external or api */
  source?: InputMaybe<Scalars['String']['input']>;
  /** Status of the Order */
  status?: InputMaybe<Scalars['String']['input']>;
  /** Order's totals, tax and global discount */
  total?: InputMaybe<OrderTotalUpdateInput>;
  /** Type of the Order */
  type?: InputMaybe<OrderType>;
  /** ID of the User, Contact or Customer of the Order */
  userId?: InputMaybe<Scalars['Int']['input']>;
  /** Date and time until the order is valid */
  validUntil?: InputMaybe<Scalars['String']['input']>;
  /** Value points collected with this Order */
  valuePoints?: InputMaybe<Scalars['Int']['input']>;
};

export type OrderlistCompaniesInput = {
  /** List of company ids */
  companyIds?: Array<Scalars['Int']['input']>;
  /** List of company sources */
  companySources?: InputMaybe<Array<Source>>;
};

export type OrderlistCreateInput = {
  /** List of cluster ids */
  clusterIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** List of cluster sources */
  clusterSources?: InputMaybe<Array<Source>>;
  /** List of company ids */
  companyIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** List of company sources */
  companySources?: InputMaybe<Array<Source>>;
  /** Orderlist descriptions per language */
  descriptions?: InputMaybe<Array<LocalizedStringInput>>;
  /** List of product ids */
  productIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** List of product sources */
  productSources?: InputMaybe<Array<Source>>;
  /** Orderlist type! One of: [POSITIVE, NEGATIVE] */
  type: OrderlistType;
  /** List of user ids */
  userIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** List of user sources */
  userSources?: InputMaybe<Array<Source>>;
};

export type OrderlistItemsInput = {
  /** List of cluster ids */
  clusterIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** List of cluster sources */
  clusterSources?: InputMaybe<Array<Source>>;
  /** List of product ids */
  productIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** List of product sources */
  productSources?: InputMaybe<Array<Source>>;
};

export type OrderlistSearchInput = {
  /** List of cluster ids */
  clusterIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** List of cluster sources */
  clusterSources?: InputMaybe<Array<Source>>;
  /** List of company ids */
  companyIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** List of company sources */
  companySources?: InputMaybe<Array<Source>>;
  /** Search by date created */
  createdAt?: InputMaybe<DateSearchInput>;
  /** List of Orderlist primary identifiers */
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Search by date changed */
  lastModifiedAt?: InputMaybe<DateSearchInput>;
  /** Pagination offset number. [Default to `12`] */
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Pagination page number. [Default to `1`] */
  page?: InputMaybe<Scalars['Int']['input']>;
  /** List of product ids */
  productIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** List of product sources */
  productSources?: InputMaybe<Array<Source>>;
  /** Inputs to sort by */
  sortInputs?: InputMaybe<Array<OrderlistSortInput>>;
  /** Orderlist type. One of: [POSITIVE, NEGATIVE] */
  type?: InputMaybe<OrderlistType>;
  /** List of user ids */
  userIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** List of user sources */
  userSources?: InputMaybe<Array<Source>>;
};

export enum OrderlistSortField {
  CREATED_AT = 'CREATED_AT',
  DESCRIPTIONS = 'DESCRIPTIONS',
  ID = 'ID',
  LAST_MODIFIED_AT = 'LAST_MODIFIED_AT'
}

export type OrderlistSortInput = {
  /** Field to sort by */
  field: OrderlistSortField;
  /** Order option to sort by. [Default to `ASC`] */
  order?: SortOrder;
};

export enum OrderlistType {
  NEGATIVE = 'NEGATIVE',
  POSITIVE = 'POSITIVE'
}

export type OrderlistUpdateInput = {
  /** List of cluster ids */
  clusterIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** List of cluster sources */
  clusterSources?: InputMaybe<Array<Source>>;
  /** List of company ids */
  companyIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** List of company sources */
  companySources?: InputMaybe<Array<Source>>;
  /** Orderlist descriptions per language */
  descriptions?: InputMaybe<Array<LocalizedStringInput>>;
  /** List of product ids */
  productIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** List of product sources */
  productSources?: InputMaybe<Array<Source>>;
  /** Orderlist type! One of: [POSITIVE, NEGATIVE] */
  type?: InputMaybe<OrderlistType>;
  /** List of user ids */
  userIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** List of user sources */
  userSources?: InputMaybe<Array<Source>>;
};

export type OrderlistUsersInput = {
  /** List of user ids */
  userIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** List of user sources */
  userSources?: InputMaybe<Array<Source>>;
};

/**
 * The orient parameter controls the cardinal orientation of the image.
 *
 *   NOTE:
 *   - By default, if the source image contains orientation information stored within its metadata, that orientation will be applied to the image data and the orientation override removed from metadata.
 *  - The numerical values are the same as EXIF rotation numbers.
 */
export enum Orient {
  /** Orient the image left. */
  EIGHT = 'EIGHT',
  /** Flip the image horizontally, then orient the image left (also rv or vr). */
  FIVE = 'FIVE',
  /** Flip the image vertically. */
  FOUR = 'FOUR',
  /** Flip the image horizontally. */
  HORIZONTAL_FLIP = 'HORIZONTAL_FLIP',
  /** Flip the image both horizontally and vertically (also vh). */
  HV_FLIP = 'HV_FLIP',
  /** Orient the image left. */
  LEFT = 'LEFT',
  /** Default - don't do anything... */
  ONE = 'ONE',
  /** Orient the image right. */
  RIGHT = 'RIGHT',
  /** Flip the image horizontally, then orient the image right (also lv or vl). */
  SEVEN = 'SEVEN',
  /** Orient the image right. */
  SIX = 'SIX',
  /** Flip the image horizontally and vertically. */
  THREE = 'THREE',
  /** Flip the image horizontally. */
  TWO = 'TWO',
  /** Flip the image horizontally. */
  VERTICAL_FLIP = 'VERTICAL_FLIP'
}

/**
 * Add pixels to the edge of an image.
 *
 * Notes
 * - By default padding applies a background color of white. See bg-color to change that.
 * - If the source image contains a transparent background and the output image also contains transparency, the padding will be made up of transparent pixels.
 * - When using pad and canvas at the same time, pad will be ignored.
 * - Values can be specified using CSS style shorthand values. (see CSS Margin or CSS Padding for more examples).
 * - CSS shorthand allows for all edges to be specified in one property.
 * - Any fractional pixel measurements will be rounded to the nearest whole pixel.
 */
export type PadInput = {
  /** Bottom - Pixels or Percentage - Default=0 */
  bottom?: InputMaybe<Scalars['Int']['input']>;
  /** Left - Pixels or Percentage - Default=0 */
  left?: InputMaybe<Scalars['Int']['input']>;
  /** Right - Pixels or Percentage - Default=0 */
  right?: InputMaybe<Scalars['Int']['input']>;
  /** Top - Pixels or Percentage - Default=0 */
  top?: InputMaybe<Scalars['Int']['input']>;
};

export type PasswordRecoveryLinkInput = {
  /** The email address of the user to generate the recovery link for */
  email: Scalars['String']['input'];
  language?: InputMaybe<Scalars['String']['input']>;
  /** The page the user will be redirected to after the user changed his/her password. */
  redirectUrl?: InputMaybe<Scalars['String']['input']>;
};

export type PasswordResetLinkEmailInput = {
  /** Attachments to add to the email */
  attachments?: InputMaybe<Array<Base64FileInput>>;
  /** The content of the email, use when the content can not be derived from other inputs */
  content?: InputMaybe<Scalars['String']['input']>;
  /** The email address of the user to generate the recovery link for */
  email: Scalars['String']['input'];
  /** The sender of the email, use when the sender can not be derived from other inputs */
  from?: InputMaybe<EmailSendContactInput>;
  language?: InputMaybe<Scalars['String']['input']>;
  /** The id of the Propeller letter to use when type is 'campaign' */
  letterId?: InputMaybe<Scalars['String']['input']>;
  /** Text to display that will lead to link when clicked */
  linkText?: InputMaybe<Scalars['String']['input']>;
  /** The id of the order to use when triggering an event of type orderconfirm */
  orderId?: InputMaybe<Scalars['Int']['input']>;
  /** The page the user will be redirected to after the user changed their password. */
  redirectUrl?: InputMaybe<Scalars['String']['input']>;
  /** The id of the site to use when sending the email, required when the site can not be derived from other inputs */
  siteId?: InputMaybe<Scalars['Int']['input']>;
  /** The subject of the email, use when the subject can not be derived from other inputs */
  subject?: InputMaybe<Scalars['String']['input']>;
  /** The type of email event to trigger */
  type: EmailEventType;
  /** The id of the user to send to email to. Can be used to replace to, when the user can't be derived from other inputs */
  userId?: InputMaybe<Scalars['Int']['input']>;
  /** Variables that can be used in the email template */
  variables?: InputMaybe<Scalars['JSONObject']['input']>;
};

/**
 * Input for creating a new payment method.
 *
 *   Contains all necessary information to establish a new payment method including localized names, external system integration codes, and branding elements. Used for setting up new payment options in checkout flows.
 */
export type PayMethodCreateInput = {
  /**
   * External system identifier in SCREAMING_SNAKE_CASE format.
   *
   *     Unique code used to identify this payment method in external payment processors and gateways. Must follow SCREAMING_SNAKE_CASE convention and be unique across all payment methods. Maximum 64 characters.
   */
  externalCode: Scalars['String']['input'];
  /**
   * Payment method logo URL for checkout display.
   *
   *     Optional URL pointing to the payment method's logo or icon for visual identification in checkout interfaces. Must be a valid URL format with maximum 255 characters.
   */
  logo?: InputMaybe<Scalars['String']['input']>;
  /**
   * Localized payment method names for different languages.
   *
   *     Collection of payment method names in various languages for international checkout experiences. Each language must be unique and follow ISO 639-1 format. At least one localized name is required.
   */
  names?: Array<LocalizedStringInput>;
};

/**
 * Search criteria for filtering payment methods with comprehensive options.
 *
 *   Provides flexible search capabilities for payment method discovery including date range filtering, identifier-based searches, and custom sorting. Supports pagination for large payment method catalogs.
 */
export type PayMethodSearchInput = {
  /**
   * Filter by payment method creation date range.
   *
   *     Allows filtering payment methods based on when they were originally created in the system. Useful for finding recently added payment methods.
   */
  createdAt?: InputMaybe<DateSearchInput>;
  /**
   * Filter by external system codes.
   *
   *     Returns payment methods matching any of the specified external codes used for payment processor integration. Each code must follow SCREAMING_SNAKE_CASE format (pattern: ^([A-Z]*_?[A-Z]*)*$), have maximum length of 64 characters, and be unique within the array.
   */
  externalCodes?: InputMaybe<Array<Scalars['String']['input']>>;
  /**
   * Filter by specific payment method identifiers.
   *
   *     Returns only payment methods whose IDs match the provided list. Each ID must be a positive integer (minimum value: 1) and unique within the array. Useful for retrieving specific payment methods or bulk operations.
   */
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  /**
   * Filter by payment method last modification date range.
   *
   *     Allows filtering payment methods based on when they were last updated. Useful for finding recently modified payment methods or tracking changes.
   */
  lastModifiedAt?: InputMaybe<DateSearchInput>;
  /**
   * Number of items per page.
   *
   *     Controls how many payment methods are returned in each page. Must be a positive integer (minimum value: 1). Default is 12 payment methods per page.
   */
  offset?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Page number for pagination.
   *
   *     Specifies which page of results to return. Must be a positive integer (minimum value: 1). Default is page 1.
   */
  page?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Sorting configuration for result ordering.
   *
   *     Defines how the payment method results should be sorted, supporting multiple sort criteria with different directions (ascending/descending). Each sort input must be unique within the array.
   */
  sortInputs?: InputMaybe<Array<PayMethodSortInput>>;
};

/** Available fields for sorting payment method results */
export enum PayMethodSortField {
  /** Sort by creation timestamp */
  CREATED_AT = 'CREATED_AT',
  /** Sort by external system integration code */
  EXTERNAL_CODE = 'EXTERNAL_CODE',
  /** Sort by payment method unique identifier */
  ID = 'ID',
  /** Sort by last modification timestamp */
  LAST_MODIFIED_AT = 'LAST_MODIFIED_AT'
}

/**
 * Sorting configuration for payment method results.
 *
 *   Defines a single sort criterion with field and direction for ordering payment method query results.
 */
export type PayMethodSortInput = {
  /**
   * Field to sort payment methods by.
   *
   *     Specifies which payment method property to use for sorting the results.
   */
  field: PayMethodSortField;
  /**
   * Sort order direction.
   *
   *     Specifies whether to sort in ascending or descending order. Defaults to ascending order.
   */
  order?: SortOrder;
};

/**
 * Input for updating an existing payment method with partial data.
 *
 *   Allows partial updates of payment method properties including localized names, external integration codes, and branding elements. Only provided fields will be updated, others remain unchanged.
 *
 *   Validation constraints:
 *   - Names array must contain unique languages if provided (minimum 1 item)
 *   - External code must follow SCREAMING_SNAKE_CASE format and be unique (maximum 64 characters)
 *   - Logo URL must be valid if provided (maximum 255 characters)
 */
export type PayMethodUpdateInput = {
  /**
   * External system identifier in SCREAMING_SNAKE_CASE format.
   *
   *     Unique code used to identify this payment method in external payment processors and gateways. Must follow SCREAMING_SNAKE_CASE convention and be unique across all payment methods. Maximum 64 characters.
   */
  externalCode?: InputMaybe<Scalars['String']['input']>;
  /**
   * Payment method logo URL for checkout display.
   *
   *     Optional URL pointing to the payment method's logo or icon for visual identification in checkout interfaces. Must be a valid URL format with maximum 255 characters.
   */
  logo?: InputMaybe<Scalars['String']['input']>;
  /**
   * Localized payment method names for different languages.
   *
   *     Collection of payment method names in various languages for international checkout experiences. Each language must be unique and follow ISO 639-1 format. At least one localized name is required.
   */
  names?: InputMaybe<Array<LocalizedStringInput>>;
};

/** Payment processing status indicating the current stage of payment lifecycle and available business actions */
export enum PaymentStatuses {
  /** Payment authorized but funds not yet captured - authorization can be captured or cancelled */
  AUTHORIZED = 'AUTHORIZED',
  /** Payment cancelled before completion - no funds were processed */
  CANCELLED = 'CANCELLED',
  /** Payment disputed and charged back by customer's financial institution - funds forcibly reversed */
  CHARGEBACK = 'CHARGEBACK',
  /** Payment authorization expired without capture - funds are no longer reserved */
  EXPIRED = 'EXPIRED',
  /** Payment processing failed due to insufficient funds, declined card, or other payment issues */
  FAILED = 'FAILED',
  /** Payment created but not yet processed by payment service provider - awaiting initial processing */
  OPEN = 'OPEN',
  /** Payment successfully completed and funds captured - order can be fulfilled */
  PAID = 'PAID',
  /** Payment submitted to payment service provider and awaiting processing response */
  PENDING = 'PENDING',
  /** Payment refunded partially or fully to customer - funds returned to original payment method */
  REFUNDED = 'REFUNDED'
}

/**
 * Search and pagination parameters for retrieving payment records.
 *
 * Controls the pagination behavior and response expansion options for payment queries. Provides efficient data retrieval with configurable page sizes and optional related data inclusion.
 */
export type PaymentsSearchInput = {
  /**
   * Number of items per page for controlling response size.
   *
   * Controls the size of each page in the paginated response to manage data volume and performance. Minimum value is 1, maximum value is 100. Defaults to 12 if not specified.
   */
  offset?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Page number for pagination navigation starting from 1.
   *
   * Specifies which page of results to retrieve when the total number of payments exceeds the offset limit. Minimum value is 1. Defaults to 1 if not specified.
   */
  page?: InputMaybe<Scalars['Int']['input']>;
};

/** Permission types */
export enum Permission {
  CHANGEPERMISSIONS = 'CHANGEPERMISSIONS',
  CREATEOBJECT_WRITEDATA = 'CREATEOBJECT_WRITEDATA',
  DELETE = 'DELETE',
  DETESUBFOLDERSANDFILES = 'DETESUBFOLDERSANDFILES',
  LISTFOLDER_READDATA = 'LISTFOLDER_READDATA',
  READATTRIBUTES = 'READATTRIBUTES',
  READPERMISSIONS = 'READPERMISSIONS',
  TAKEOWNERSHIP = 'TAKEOWNERSHIP',
  WRITEATTRIBUTES = 'WRITEATTRIBUTES'
}

export type PriceFilterInput = {
  /** Price from filter */
  from: Scalars['Float']['input'];
  /** Price to filter */
  to: Scalars['Float']['input'];
};

/** Indicates where the price is calculated. PLATFORM - Price was calculated based on product price/postage rules set in Propeller. EXTERNAL - price is set externally */
export enum PriceMode {
  EXTERNAL = 'EXTERNAL',
  PLATFORM = 'PLATFORM'
}

/** Available product classes */
export enum ProductClass {
  cluster = 'cluster',
  product = 'product'
}

/** Product price types */
export enum ProductPriceType {
  bulk1 = 'bulk1',
  bulk2 = 'bulk2',
  bulk3 = 'bulk3',
  bulk4 = 'bulk4',
  default = 'default',
  discount = 'discount',
  productDiscount = 'productDiscount'
}

/** All available product statuses */
export enum ProductStatus {
  A = 'A',
  N = 'N',
  P = 'P',
  R = 'R',
  S = 'S',
  T = 'T'
}

export type RangeFilterInput = {
  /** Range filter exclude */
  exclude?: Scalars['Boolean']['input'];
  /** Price from filter */
  from: Scalars['Float']['input'];
  /** Range filter search identifier */
  searchId: Scalars['String']['input'];
  /** Price to filter */
  to: Scalars['Float']['input'];
  /** Range filter type */
  type?: InputMaybe<AttributeType>;
};

export type RegisterContactInput = {
  /** Contacts's custom attribute values. This field is used to set value on attributes for the selected contact. Attributes that are used here (selected by name) must already be defined in Propeller. */
  attributes?: InputMaybe<Array<UserManagementAttributeValueInput>>;
  dateOfBirth?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Gender>;
  homepage?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mailingList?: InputMaybe<YesNo>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  mobile?: InputMaybe<Scalars['String']['input']>;
  /** The id of the company the contact should be created in. */
  parentId?: InputMaybe<Scalars['Int']['input']>;
  /** Optionally create a prefilled password. When omitted the contact can set a new password using password reset(link) */
  password?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  /** The primary language of the contact. */
  primaryLanguage?: InputMaybe<Scalars['String']['input']>;
};

export type RegisterCustomerInput = {
  /** Customer's custom attribute values. This field is used to set value on attributes for the selected customer. Attributes that are used here (selected by name) must already be defined in Propeller. */
  attributes?: InputMaybe<Array<UserManagementAttributeValueInput>>;
  dateOfBirth?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Gender>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mailingList?: InputMaybe<YesNo>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  mobile?: InputMaybe<Scalars['String']['input']>;
  /** The id of the usergroup the customer should be created in. */
  parentId?: InputMaybe<Scalars['Int']['input']>;
  /** Optionally create a prefilled password. When omitted the customer can set a new password using password reset(link) */
  password?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  /** The primary language of the customer. */
  primaryLanguage?: InputMaybe<Scalars['String']['input']>;
};

export type RegisterUserInput = {
  autoLogin?: InputMaybe<Scalars['Boolean']['input']>;
  cocNumber?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  createAccount?: InputMaybe<Scalars['Boolean']['input']>;
  dateOfBirth?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Gender>;
  homepage?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mailingList?: InputMaybe<YesNo>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  mobile?: InputMaybe<Scalars['String']['input']>;
  /** The id of the usergroup the user should be created in. */
  parentId?: InputMaybe<Scalars['Int']['input']>;
  /** optionally create a prefilled password. When omitted the user can set a new password using password reset(link) */
  password?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  /** The primary language of the user. */
  primaryLanguage?: InputMaybe<Scalars['String']['input']>;
  taxNumber?: InputMaybe<Scalars['String']['input']>;
};

/**
 * The resize-filter parameter enables control over the resizing filter used to generate a new image with a higher or lower number of pixels.
 *
 *   NOTES:
 *     1. When making an image smaller, use bicubic, which has a natural sharpening effect.
 *     2. When making an image larger, use bilinear, which has a natural smoothing effect.
 *     3. When resizing pixel art, use nearest, which has a natural pixelation effect.
 *     4. When quality is the main concern, use lanczos, which typically renders the best results.
 */
export enum ResizeFilter {
  /** Uses an average of a 4x4 environment of pixels, weighing the innermost pixels higher. */
  BICUBIC = 'BICUBIC',
  /** Uses an average of a 2x2 environment of a pixels. */
  BILINEAR = 'BILINEAR',
  /** Uses the Lanczos filter to increase the ability to detect edges and linear features within an image and uses sinc resampling to provide the best possible reconstruction. */
  LANCZOS2 = 'LANCZOS2',
  /** Lanczos3 uses a better approximation of the sinc resampling function. (Default) */
  LANCZOS3 = 'LANCZOS3',
  /** Uses the value of nearby translated pixel values. */
  NEAREST = 'NEAREST'
}

/**
 * Search criteria for identifying a specific payment record.
 *
 * Provides multiple ways to locate a payment using different identifier types. At least one search criterion must be provided. When multiple criteria are specified, they are combined with AND logic for precise matching.
 */
export type SearchByInput = {
  /**
   * Internal system payment identifier for direct record lookup.
   *
   * Unique numeric identifier assigned by the system to identify the payment record. Most efficient search method when the internal ID is known.
   */
  id?: InputMaybe<Scalars['ID']['input']>;
  /**
   * Order identifier for finding payments associated with specific orders.
   *
   * Links payment records to their corresponding orders for order-payment relationship tracking. Used when searching for payments by order context.
   */
  orderId?: InputMaybe<Scalars['Float']['input']>;
  /**
   * External payment service provider identifier for PSP correlation.
   *
   * Unique payment reference provided by the Payment Service Provider for tracking and reconciliation. Maximum length of 255 characters. Used when correlating with external payment systems.
   */
  paymentId?: InputMaybe<Scalars['String']['input']>;
};

export type SearchFieldsInput = {
  /** Search boost value */
  boost: Scalars['Int']['input'];
  /** List of available sortable fields */
  fieldNames: Array<Searchablefields>;
};

export type SearchSparePartsMachineInput = {
  offset?: Scalars['Int']['input'];
  page?: Scalars['Int']['input'];
};

/** All field that can be searched and boosted with the regular term input. */
export enum Searchablefields {
  description = 'description',
  eanCode = 'eanCode',
  keywords = 'keywords',
  keywordsCustom = 'keywordsCustom',
  manufacturer = 'manufacturer',
  manufacturerCode = 'manufacturerCode',
  name = 'name',
  shortDescription = 'shortDescription',
  sku = 'sku',
  supplier = 'supplier',
  supplierCode = 'supplierCode'
}

/**
 * Sharpness of the output image.
 *
 * The sharpen parameter increases the definition of the edges of objects in an image.
 *
 * Notes
 * - The sharpen parameter is an implementation of an unsharp mask.
 */
export type SharpenInput = {
  /** Sharpen amount value */
  amount?: InputMaybe<Scalars['Float']['input']>;
  /** Sharpen radius value */
  radius?: InputMaybe<Scalars['Int']['input']>;
  /** Sharpen threshold value */
  threshold?: InputMaybe<Scalars['Int']['input']>;
};

/** Sort order for search results */
export enum Sort {
  /** Sort results in ascending order */
  ASC = 'ASC',
  /** Sort results in descending order */
  DESC = 'DESC'
}

export type SortInput = {
  /** Available sortable fields */
  field: SortableFields;
  /** Sort ordering ['desc' or 'asc'] */
  order?: InputMaybe<SortOrder>;
};

/** Order options for sorting */
export enum SortOrder {
  /** Ascending order */
  ASC = 'ASC',
  /** Descending order */
  DESC = 'DESC',
  /**
   * Ascending order
   * @deprecated Use ASC instead
   */
  asc = 'asc',
  /**
   * Descending order
   * @deprecated Use DESC instead
   */
  desc = 'desc'
}

/** Fields available for sorting */
export enum SortableFields {
  categoryOrder = 'categoryOrder',
  dateChanged = 'dateChanged',
  dateCreated = 'dateCreated',
  name = 'name',
  price = 'price',
  priority = 'priority',
  relevance = 'relevance',
  shortName = 'shortName',
  sku = 'sku',
  supplierCode = 'supplierCode'
}

export type Source = {
  /** Source ID */
  id: Scalars['String']['input'];
  /** Name of the source */
  name: Scalars['String']['input'];
};

export type SourceInput = {
  /** Source ID */
  id: Scalars['String']['input'];
  /** Name of the source */
  name: Scalars['String']['input'];
};

/** File upload from local filesystem using GraphQL multipart request specification */
export type StandardFileUploadInput = {
  /**
   * File reference from local filesystem.
   *
   *     Uses the GraphQL Upload form-data specification for multipart file uploads. The file is uploaded directly from the client's filesystem to the server for processing and storage.
   */
  file: Scalars['Upload']['input'];
  /**
   * Custom filename for storing the uploaded file.
   *
   *     If not provided, the original filename from the upload will be used. Must include the file extension and be between 5-255 characters. This name affects how the file is stored and referenced.
   */
  fileName?: InputMaybe<Scalars['String']['input']>;
};

/** All supported tax codes */
export enum TaxCode {
  H = 'H',
  L = 'L',
  N = 'N'
}

export type TaxSearchInput = {
  offset?: Scalars['Int']['input'];
  page?: Scalars['Int']['input'];
  /** Only search for taxes for shop */
  shopId?: InputMaybe<Scalars['Int']['input']>;
  /** Only search for taxes for zone */
  zone?: InputMaybe<Scalars['String']['input']>;
};

/** All supported taxcodes */
export enum Taxcode {
  /** High tax rate */
  H = 'H',
  /** Low tax rate */
  L = 'L',
  /** No tax rate */
  N = 'N'
}

export type TenderAddItemInput = {
  /**
   * Adds child items to this tender item. This field is used when adding configurable clusters to the Tender.
   *   Provide an array of children options/ products of the parent item.
   */
  childItems?: InputMaybe<Array<TenderChildItemInput>>;
  /** Delivery date */
  deliveryDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Item name. Defaults to product name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Notes, remarks, etc. */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** Item price. Defaults to calculated sales price */
  price?: InputMaybe<Scalars['Float']['input']>;
  /** Product ID */
  productId: Scalars['Int']['input'];
  /** Item quantity */
  quantity: Scalars['Int']['input'];
  /** Item supplier. Defaults to product supplier */
  supplier?: InputMaybe<Scalars['String']['input']>;
};

export type TenderAddItemsInput = {
  /** If set to true and an existing item for the same product is found, a new tender item will be created. Existing items are updated by default */
  forceAdd?: InputMaybe<Scalars['Boolean']['input']>;
  /** Tender items */
  products: Array<TenderAddItemInput>;
  /** Tender unique ID */
  tenderId: Scalars['String']['input'];
  /** If set to false, budget validation will be skipped. Defaults to true */
  validateBudget?: InputMaybe<Scalars['Boolean']['input']>;
  /** If set to false, the items will not be validated against customer order lists. Defaults to true */
  validateOrderList?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Address types for Tenders */
export enum TenderAddressType {
  delivery = 'delivery',
  invoice = 'invoice'
}

export type TenderChildItemInput = {
  /** Delivery date */
  deliveryDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Item name. Defaults to product name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Notes, remarks, etc. */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** Item price. Defaults to calculated sales price */
  price?: InputMaybe<Scalars['Float']['input']>;
  /** Product ID */
  productId: Scalars['Int']['input'];
};

export type TenderDeleteItemInput = {
  /** Tender item ID */
  itemId: Scalars['Int']['input'];
  /** Tender unique ID */
  tenderId: Scalars['String']['input'];
};

export type TenderDiscountInput = {
  /** Tender unique ID */
  tenderId: Scalars['String']['input'];
  /** Order discount type */
  type: DiscountType;
  /** Discount amount/ percentage, depending on discount type */
  value: Scalars['Float']['input'];
};

/** Order item types */
export enum TenderOrderItemType {
  incentive = 'incentive',
  product = 'product',
  surcharge = 'surcharge'
}

/** Order types */
export enum TenderOrderType {
  dropshipment = 'dropshipment',
  purchase = 'purchase',
  quotation = 'quotation',
  stock = 'stock'
}

export type TenderPaymentInput = {
  /** Accounting ID for this tender/order */
  accountingId?: InputMaybe<Scalars['String']['input']>;
  /** The costs associated with the selected paymethod on this tender/order. VAT excluding. If omitted, payment costs are automatically calculated */
  amountGross?: InputMaybe<Scalars['Float']['input']>;
  /** Payment method for this tender/order */
  method?: InputMaybe<Scalars['String']['input']>;
  /** Payment status for this tender/order */
  status?: InputMaybe<Scalars['String']['input']>;
  /** Tender unique ID */
  tenderId: Scalars['String']['input'];
  /** Payment transaction ID for this tender/order */
  transactionId?: InputMaybe<Scalars['String']['input']>;
};

export type TenderPostageInput = {
  /** The carrier for this tender/order */
  carrier?: InputMaybe<Scalars['String']['input']>;
  /** This order can be shipped in parts when items different delivery dates */
  partialDeliveryAllowed?: InputMaybe<Scalars['Boolean']['input']>;
  /** Pick up location ID */
  pickUpLocationId?: InputMaybe<Scalars['Int']['input']>;
  /** Shipping costs, VAT excluding. If omitted, shipping costs are automatically calculated */
  postageGross?: InputMaybe<Scalars['Float']['input']>;
  /** The preferred delivery date for this order as requested by the user */
  requestDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** The shipping method for this tender/order */
  shippingMethod?: InputMaybe<Scalars['String']['input']>;
  /** Tender unique ID */
  tenderId: Scalars['String']['input'];
  /** Track & Trace code */
  trackTrace?: InputMaybe<Scalars['String']['input']>;
};

export type TenderStart = {
  /** The channel id for the tender created */
  channelId?: InputMaybe<Scalars['Int']['input']>;
  /** The currency for the tender created. Defaults to EUR */
  currency?: InputMaybe<Scalars['String']['input']>;
  /** The id of the user editing the order. Defaults to userId */
  ownerId?: InputMaybe<Scalars['Int']['input']>;
  /** The site id for the tender created */
  siteId?: InputMaybe<Scalars['Int']['input']>;
  /** The type for the tender created. Defaults to dropshipment */
  type?: InputMaybe<TenderOrderType>;
  /** The user ID for the tender created */
  userId: Scalars['Int']['input'];
};

export type TenderUpdateAddressInput = {
  /** City */
  city: Scalars['String']['input'];
  /** Address code */
  code?: InputMaybe<Scalars['String']['input']>;
  /** Address company */
  company?: InputMaybe<Scalars['String']['input']>;
  /** Country code */
  country: Scalars['String']['input'];
  /** Address contact email */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Address contact fax number */
  fax?: InputMaybe<Scalars['String']['input']>;
  /** Address contact first name */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** Address contact gender */
  gender?: InputMaybe<Gender>;
  /** ICP is Yes when taxes do not apply for shipping to the given address/ country. Defaults to No */
  icp?: InputMaybe<YesNo>;
  /** Address contact last name */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** Address contact middle name */
  middleName?: InputMaybe<Scalars['String']['input']>;
  /** Address contact mobile phone number */
  mobile?: InputMaybe<Scalars['String']['input']>;
  /** Notes, remarks, etc. */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** Number */
  number?: InputMaybe<Scalars['String']['input']>;
  /** Number extension */
  numberExtension?: InputMaybe<Scalars['String']['input']>;
  /** Address contact phone number */
  phone?: InputMaybe<Scalars['String']['input']>;
  /** Postal code */
  postalCode: Scalars['String']['input'];
  /** Region */
  region?: InputMaybe<Scalars['String']['input']>;
  /** Street */
  street: Scalars['String']['input'];
  /** Tender unique ID */
  tenderId: Scalars['String']['input'];
  /** Address type */
  type: TenderAddressType;
  /** Address contact URL */
  url?: InputMaybe<Scalars['String']['input']>;
};

export type TenderUpdateInput = {
  /** User's reference for this tender */
  reference?: InputMaybe<Scalars['String']['input']>;
  /** User's remarks for this tender */
  remarks?: InputMaybe<Scalars['String']['input']>;
  /** Status of this tender */
  status?: InputMaybe<Scalars['String']['input']>;
  /** Tender unique ID */
  tenderId: Scalars['String']['input'];
};

export type TenderUpdateItemInput = {
  /** Delivery date */
  deliveryDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Tender item ID */
  itemId: Scalars['Int']['input'];
  /** Item name. Defaults to product name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Notes, remarks, etc. */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** Item price. Defaults to calculated sales price */
  price?: InputMaybe<Scalars['Float']['input']>;
  /** Item quantity */
  quantity?: InputMaybe<Scalars['Int']['input']>;
  /** Item supplier. Defaults to product supplier */
  supplier?: InputMaybe<Scalars['String']['input']>;
  /** Tender unique ID */
  tenderId: Scalars['String']['input'];
  /** If set to false, budget validation will be skipped. Defaults to true */
  validateBudget?: InputMaybe<Scalars['Boolean']['input']>;
  /** If set to false, the items will not be validated against customer order lists. Defaults to true */
  validateOrderList?: InputMaybe<Scalars['Boolean']['input']>;
};

export type TextFilterInput = {
  /** Text filter exclude */
  exclude?: Scalars['Boolean']['input'];
  /** Text filter search identifier */
  searchId: Scalars['String']['input'];
  /** Text filter type */
  type?: InputMaybe<AttributeType>;
  /** Text filter value */
  values: Array<Scalars['String']['input']>;
};

/** Transaction processing status indicating the outcome of payment operations and workflow progression */
export enum TransactionStatuses {
  /** Transaction processing failed due to technical or business reasons - operation was not completed */
  FAILED = 'FAILED',
  /** Transaction created but not yet submitted to payment service provider - awaiting processing */
  OPEN = 'OPEN',
  /** Transaction submitted to payment service provider and awaiting response - processing in progress */
  PENDING = 'PENDING',
  /** Transaction completed successfully with desired outcome achieved - operation was successful */
  SUCCESS = 'SUCCESS'
}

/** Transaction operation types representing different payment processing operations with specific business logic */
export enum TransactionTypes {
  /** Reserve funds on customer's payment method without capturing - funds are held but not transferred */
  AUTHORIZATION = 'AUTHORIZATION',
  /** Cancel a previously created authorization - releases reserved funds back to customer */
  CANCEL_AUTHORIZATION = 'CANCEL_AUTHORIZATION',
  /** Forced reversal of payment initiated by customer's bank - dispute resolution mechanism */
  CHARGEBACK = 'CHARGEBACK',
  /** Capture funds from an authorization or process direct payment - transfers money from customer to merchant */
  PAY = 'PAY',
  /** Return funds to customer for a completed payment - reverses a previous payment transaction */
  REFUND = 'REFUND'
}

export type TransformationInput = {
  /**
   * Enable optimization features automatically.
   *
   * Enables optimizations based on content negotiation.
   *
   * The only negotiated optimizations currently available are for AVIF and WebP, both image compression formats with limited browser support.
   *
   * This functionality is also possible using format=auto which adds additional support for JPEGXL output.
   *
   * Notes
   * - Although the AVIF and WebP formats produce images at a higher compression ratio with a lower loss of quality compared to JPEG, they are not supported in all browsers.
   * - When using Firefox version 66 to 71, automatic content negotiation will not occur when navigating to the image. To view WebP or AVIF images generated via auto=avif or auto=webp you must insert your image onto a web page.
   * - format=auto will take precedence if combined with auto.
   */
  auto?: InputMaybe<Auto>;
  /**
   * Set the background color of an image.
   *
   * The bg-color parameter sets the background color of an image to use when applying padding or when replacing transparent pixels.
   *
   * Its value may be one of:
   *
   * - Hex RGB value: Both 3- and 6-digit values are acceptable (e.g. a22 or cf23a5).
   * - Decimal RGB: RGB values between 0 and 255. Comma-delimited (e.g. 255,0,0).
   * - Decimal RGB with alpha|RGBA colors include an additional value for alpha (transparency), which ranges from 0 for fully transparent to 1 for fully opaque.
   *
   * Examples
   * - "c5c5c5"      => Set background color to grey (Hex RGB)
   * - "000"         => Set background color to black (Hex RGB)
   * - "255,0,0"     => Set background color to red (Decimal RGB)
   * - "255,0,0,0.5" => Set background color to red with 50% transparency (Decimal RGBA)
   */
  bgColor?: InputMaybe<Scalars['String']['input']>;
  /**
   * Set the blurriness of the output image.
   *
   * Applies a Gaussian blur filter to the image.
   *
   * Its value is a number of pixels between 0.5 and 1000 or a percentage (of the dimensions of the image) suffixed with p (e.g., 1p for 1%).
   *
   * Examples
   * - "50"   => Apply a Gaussian blur with a radius of 50px
   * - "0.5p" => Apply a Gaussian blur with a radius of 0.5% of the image size
   */
  blur?: InputMaybe<Scalars['Float']['input']>;
  /**
   * Set the brightness of the output image.
   *
   * The brightness parameter increases or decreases the amount of perceived light an image radiates or reflects.
   *
   * Its value may be any number between -100 and 100.
   *
   * Examples
   * - 50  => Increase the brightness by 50
   * - -42 => Decrease the brightness by 42
   */
  brightness?: InputMaybe<Scalars['Int']['input']>;
  /** Increase the size of the canvas around an image. */
  canvas?: InputMaybe<CanvasInput>;
  /**
   * Set the contrast of the output image.
   *
   * The contrast parameter increases or decreases the difference between the darkest and lightest tones in an image.
   *
   * Notes
   * - The default value is 0. This leaves the image unchanged.
   * - A value of -100 will result in a fully grey image.
   *
   * Examples
   * - 50  => Increase the contrast by 50
   */
  contrast?: InputMaybe<Scalars['Int']['input']>;
  /** Remove pixels from an image. */
  crop?: InputMaybe<CropInput>;
  /**
   * Disable functionality that is enabled by default.
   *
   * upscale is already disabled by default. It can be enabled with the enable parameter.
   *
   * Notes
   * - Image upscaling is discouraged because it increases both the file size and delivery time of the image to the end user with no visual improvement. We recommend handling upscaling on the client-side (e.g., using a web browser or native application).
   * - The upscale value must be used with the width, height, or dpr parameters to see any effect in the output image.
   *
   * Examples
   * - "width=2560&disable=upscale" => Attempt to resize the image to 2560px wide but do not exceed the natural width of the source image
   */
  disable?: InputMaybe<FeaturesEnableDisable>;
  /**
   * Serve correctly sized images for devices that expose a device pixel ratio.
   *
   * Device pixel ratio.
   *
   * The dpr parameter provides a means to multiply image dimensions in order to translate logical pixels (also 'CSS pixels') into physical pixels. The device pixel ratio is therefore the ratio between physical pixels and logical pixels.
   *
   * It is usually possible for client-side software to query the host system to determine the DPR of the display the user is viewing. In web browsers, this is available as the Window.devicePixelRatio variable in JavaScript. The iPhone 5 reports a device pixel ratio of 2, because the physical linear resolution is double the logical resolution.
   *
   * - Physical Resolution: 960 x 640
   * - Logical Resolution: 480 x 320
   *
   * Other devices report varying device pixel ratios, including non-integer ones. For example, the Nokia Lumia 1020 reports 1.6667, whereas the Samsung Galaxy S4 reports 3.
   *
   * Its value may be any number between 1 and 10.
   *
   * Examples
   * - width=200&dpr=2 => Resize the width to 400px (200 CSS pixels for screens with a device pixel ratio of 2)
   */
  dpr?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Enable functionality that is disabled by default.
   *
   * Supported values:
   * - upscale => Allow images to be resized such that the output image's dimensions are larger than the source image.
   *
   * Notes
   * - Image upscaling is discouraged because it increases both the file size and delivery time of the image to the end user with no visual improvement. We recommend handling upscaling on the client-side (e.g., using a web browser or native application).
   * - The upscale value must be used with the width, height, or dpr parameters to see any effect in the output image.
   *
   * Examples:
   * - ?width=2560&enable=upscale => Resize the image to 2560px wide, even if the source image is smaller
   */
  enable?: InputMaybe<FeaturesEnableDisable>;
  /**
   * Set how the image will fit within the size bounds provided.
   *
   * The fit parameter controls how the image will be constrained within the provided size (width and height) values, in order to maintain the correct proportions.
   *
   * Allowed values:
   * - bounds => Resize the image to fit entirely within the specified region, making one dimension smaller if needed.
   * - cover	 => Resize the image to entirely cover the specified region, making one dimension larger if needed.
   * - crop	 => Resize and crop the image centrally to exactly fit the specified region.
   *
   * Notes
   * The fit parameter has no effect unless both width and height are specified.
   *
   * Examples
   * - width=150&height=150&fit=bounds	=> Resize the image to fit within the bounds of 150px in width by 150px in height
   * - width=150&height=150&fit=cover	=> Resize the image to entirely cover 150px in width by 150px in height
   * - width=150&height=150&fit=crop	  => Crop the image to 150px in width by 150px in height
   */
  fit?: InputMaybe<Fit>;
  /**
   * Specify the output format to convert the image to.
   *
   * The format parameter enables the source image to be converted (a.k.a., "transcoded") from one encoded format to another. This is useful when the source image has been saved in a sub-optimal file format that hinders performance.
   *
   * Notes
   * - The source image can be any of the following image formats: AVIF, JPEG, JPEGXL, PNG, GIF, WEBP.
   * - JPEG, progressive JPEG, WebP (Lossy), and PNG8 have a sliding quality scale that supports the quality parameter.
   * - GIF and PNG do not have a sliding quality scale. They do not support the quality parameter.
   * - A progressive JPEG pjpg is an image created using the JPEG suite of compression algorithms that will "fade in" successive waves of lines until the entire image has completely arrived. For this reason, progressive JPEG images typically appear to load quicker than the Baseline JPEG jpg format.
   * - WebP support is available in Google Chrome, Mozilla Firefox 65 and later, Safari 14 and later, Opera, and Android Browser.
   * - Lossless compression is currently supported for WebP and JPEGXL only.
   * - GIF to WebP conversion does not support animated GIFs.
   * - MP4 conversion is only available for animated GIF source images.
   * - AVIF and JPEGXL are premium features
   *
   * About the auto value
   *
   * The auto behavior aims to provide the optimal output format based on client capabilities as well as information related to the source image and transform characteristics. In that regard, we may adopt different heuristics to determine the output format for different source images or transforms.
   *
   * When using format=auto, the image format delivered is always compatible with the current browser regardless of the source image format. This means a JPEGXL source image can safely be used in a browser where JPEGXL is not supported, and the resulting image is always viewable. With other format parameters and with auto=webp and auto=avif, there are some cases where the original format may be used.
   *
   * - auto intelligently chooses the best format to deliver to the user prioritizing:
   *   - JPEGXL
   *   - AVIF
   *   - WebP
   *   - Source image format / JPEG
   *
   * - Images default to lossy unless the quality parameter is set to 100.
   * - If no quality parameter is set, the default JPEG quality specified in IO default settings is used.
   * - Allows the use of JPEGXL, AVIF, or WebP as the source image format in cases where that image format is not support in the viewing environment.
   * - Quality mapping uses an SSIM similarity score between formats.
   * - Takes precedence if combined with the auto parameter.
   */
  format?: InputMaybe<Format>;
  /** Extract the first frame from an animated image sequence. */
  frame?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Resize the height of the image.
   *
   * The desired height of the output image.
   *
   * The height parameter enables dynamic height resizing based on pixels and percent values.
   *
   * The {value} can be either a positive integer or a positive number less than 1. If the value is an integer greater than or equal to 1, the value is interpreted as a pixel height. If the height parameter is less than 1, the value is interpreted as a percentage height.
   *
   * Unless a width parameter is present, the height value will cause the width of the image to be scaled in proportion to the requested height. If both width and height are omitted, the input image dimensions are used.
   *
   * value may be one of:
   * - Absolute height: An integer number of pixels.
   * - Relative height: A fraction between 0 and 0.99 (e.g., 0.5) or a percentage between 0 and 100 followed by the letter p (e.g., 50p). In either case, the value indicates the desired height relative to the image's natural height.
   *
   * Notes
   * - The maximum output dimensions are 8,192 x 8,192 pixels.
   * - Because we use a positive number between 0 and 0.99 to return a percentage-based scaled image, in order to return an image that is 100% or more, a p suffix can be appended to the value. For example, height=250p would return an image that is 250% the height of the original. We use p as a simple way to represent percentages.
   * - If the requested height is not a whole number of pixels (e.g., as a result of applying a percentage value for height), it is rounded to the nearest integer.
   *
   * Examples
   *
   * - height=200	          => Resize the height to 200px
   * - height=0.10	          => Resize the height to 10% of the input image
   * - height=150p	          => Resize the height to 150% of the input image
   * - height=200&width=0.50	=> Force resize to a height of 200px and a width that is 50% of the original
   * - height=200&dpr=2	    => Resize the height to 400px (200 CSS pixels for screens with a device pixel ratio of 2)
   * - height=150&width=150&fit=bounds	=> Fit image within a 150 x 150px rectangle
   */
  height?: InputMaybe<Scalars['Float']['input']>;
  /**
   * Specify the level constraints when converting to video.
   *
   * When converting animated GIFs to the MP4 format and when used in conjunction with the profile parameter, the level parameter specifies a set of constraints indicating a degree of required decoder performance for a profile.
   *
   * Notes
   * If either level or profile parameters are missing, profile=baseline&level=3.0 will be used as the default.
   *
   * Examples
   * - format=mp4&profile=main&level=5.2	=> Convert the source animated GIF to MP4 format and select the main profile with a level of 5.2
   */
  level?: InputMaybe<Level>;
  /**
   * Include or exclude metadata from the output image.
   *
   * By default, the image optimizer will remove all metadata embedded in an image. The metadata parameter allows this behavior to be configured.
   *
   * Notes
   * This parameter is only effective when the source and destination format are both jpeg.
   */
  metadata?: InputMaybe<ImageMetadata>;
  /**
   * Automatically apply optimal quality compression.
   *
   * The optimize parameter automatically applies optimal quality compression to produce an output image with as much visual fidelity as possible, while minimizing the file size.
   *
   * Notes
   * - Optimize is currently supported by the following output formats: JPEG, WebP, AVIF.
   * - If the quality parameter is also provided, quality overrides optimize because it is more precise.
   * - Because optimize attempts to produce an output image with as much visual quality as possible while minimizing the file size, the operations applied are subject to change.
   *
   * Examples
   * - optimize=medium	        => Output an image with medium optimization
   * - optimize=high&auto=webp	=> Output a highly optimized JPEG. For browsers that support WebP output a highly optimized WebP image.
   */
  optimize?: InputMaybe<Optimize>;
  /**
   * Change how the image will be orientated.
   *
   * The orient parameter controls the cardinal orientation of the image.
   *
   * Notes
   * - By default, if the source image contains orientation information stored within its metadata, that orientation will be applied to the image data and the orientation override removed from metadata.
   * - The numerical values are the same as EXIF rotation numbers.
   *
   * Examples
   * - orient=r => Orient the image right
   * - orient=2 => Flip vertically
   * - orient=3 => Flip vertically and horizontally
   */
  orient?: InputMaybe<Orient>;
  /**
   * Add pixels to the edge of an image.
   *
   * Notes
   * - By default padding applies a background color of white. See bg-color to change that.
   * - If the source image contains a transparent background and the output image also contains transparency, the padding will be made up of transparent pixels.
   * - When using pad and canvas at the same time, pad will be ignored.
   * - Values can be specified using CSS style shorthand values. (see CSS Margin or CSS Padding for more examples).
   * - CSS shorthand allows for all edges to be specified in one property.
   * - Any fractional pixel measurements will be rounded to the nearest whole pixel.
   *
   * Examples
   * - pad=25,50,75,100 => Pad top edge 25px, right edge 50px, bottom edge 75px and left edge 100px
   * - pad=25,50,75	   => Pad top edge 25px, right and left edge 50px, bottom edge 75px
   * - pad=25,50	       => Pad top and bottom edge 25px, right and left edge 50px
   * - pad=0.25	       => Pad all edges by 25%
   */
  pad?: InputMaybe<PadInput>;
  /**
   * Remove pixels from an image before any other transformations occur.
   *
   * Identical to crop except that precrop is performed before any other transformations.
   */
  precrop?: InputMaybe<CropInput>;
  /**
   * Specify the profile class of application when converting to video.
   *
   * When converting animated GIFs to MP4 format and when used in conjunction with the level parameter, the profile parameter controls which features the video encoder can use based on a target class of application for decoding the specific video bitstream.
   *
   * Notes
   * If either profile or level parameters are missing, profile=baseline&level=3.0 will be used as the default.
   *
   * Examples
   * - format=mp4&profile=high&level=5.0	=> Convert the source animated GIF to MP4 format and select the high profile with a level of 5.0
   */
  profile?: InputMaybe<Scalars['String']['input']>;
  /**
   * Optimize the image to the given compression level for lossy file formatted images.
   *
   * Output image quality for lossy file formats.
   *
   * The quality parameter enables control over the compression level for lossy file-formatted images.
   *
   * Its value may be any integer between 1 and 100, where 1 is a lower quality image and a smaller file and 100 is the highest quality image and larger file. If desired, a second quality level can be specified for use when auto=webp is enabled and a WebP output format has been selected.
   *
   * Notes
   * - The quality parameter can be applied to the following output formats: avif, jpg, pjpg, png8, webp and webply.
   * - If no quality parameter is present for jpg, pjpg, or webp, the output image will be returned at the default value set in the Image Optimizer web interface.
   * - If auto=webp is enabled by the URL or the service settings, the second value will be used as the quality value if the requestor sends the accept: image/webp request header.
   * - When only specifying quality, if the output image file size is larger than the input image, the original image will be delivered.
   * - This does not include a way of specifying auto AVIF quality.
   *
   * Examples
   * - quality=85	                        => Output an image with quality set to 85.
   * - format=pjpg&auto=webp&quality=85,75	=> Convert the image format to a progressive jpg with image quality set to 85. For browsers that support WebP set the image quality to 75.
   */
  quality?: InputMaybe<Scalars['Float']['input']>;
  /**
   * Specify the resize filter used when resizing images.
   *
   * The resizeFilter parameter enables control over the resizing filter used to generate a new image with a higher or lower number of pixels.
   *
   * Notes
   * - When making an image smaller, use bicubic, which has a natural sharpening effect.
   * - When making an image larger, use bilinear, which has a natural smoothing effect.
   * - When resizing pixel art, use nearest, which has a natural pixelation effect.
   * - When quality is the main concern, use lanczos, which typically renders the best results.
   *
   * Examples
   * - resize-filter=bilinear	Deliver an image that has been resized using the bilinear filter.
   */
  resizeFilter?: InputMaybe<ResizeFilter>;
  /**
   * Set the saturation of the output image.
   *
   * Saturation of the output image.
   *
   * The saturation parameter increases or decreases the intensity of the colors in an image.
   *
   * Its value may be any number between -100 and 100.
   *
   * Notes
   * - The default value is 0. This leaves the image unchanged.
   * - Valid values range from -100 to 100
   * - A value of -100 will generate a grayscale image.
   *
   * Examples
   * - saturation=25	  => Increase saturation by 25
   * - saturation=-100	=> Decrease saturation by 100 (rendering the image grayscale)
   */
  saturation?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Set the sharpness of the output image.
   *
   * Sharpness of the output image.
   *
   * The sharpen parameter increases the definition of the edges of objects in an image.
   *
   * Notes
   * The sharpen parameter is an implementation of an unsharp mask.
   *
   * Examples
   * - sharpen=a5,r2,t1 => Increase the sharpness of the image by amount:5, radius:2, and threshold:1
   */
  sharpen?: InputMaybe<SharpenInput>;
  /**
   * Remove pixels from the edge of an image.
   *
   * The trim parameter removes pixels from the edge of an image by pixel or percentage value. This can be useful for removing whitespace and borders that appear on a source image.
   *
   * Notes
   * - Values can be specified using CSS style shorthand values. (See CSS Margin or CSS Padding for more examples).
   * - CSS shorthand allows for all edges to be specified in one property.
   * - Any fractional pixel measurements will be rounded to the nearest whole pixel.
   *
   * Examples
   * - trim=25,50,75,100	=> Trim top edge 25px, right edge 50px, bottom edge 75px and left edge 100px
   * - trim=25,50,75	    => Trim top edge 25px, right and left edge 50px, bottom edge 75px
   * - trim=25,50	      => Trim top and bottom edge 25px, right and left edge 50px
   * - trim=0.25	        => Trim all edges by 25%
   */
  trim?: InputMaybe<TrimInput>;
  /**
   * Resize the width of the image.
   *
   *     The desired width of the output image.
   *
   *     The width parameter enables dynamic width resizing based on pixels and percent values.
   *
   *     The {value} can be either a positive integer or a number less than 1. If the value is an integer greater than or equal to 1, the value is interpreted as a pixel width. If the width parameter is less than 1, the value is interpreted as a percentage width.
   *
   *     Unless a height parameter is present, the width value will cause the height of the image to be scaled in proportion to the requested width. If both width and height are omitted, the input image dimensions are used.
   *
   *     value may be one of:
   *     - Absolute width: An integer between 1 and 8192.
   *     - Relative width: A fraction between 0 and 0.99 (e.g. ,0.5) or a percentage between 0 and 100 followed by the letter p (e.g., 50p). In either case the value indicates the desired width relative to the image's natural width.
   *
   *     Notes
   *     - The maximum output dimensions are 8,192 x 8,192 pixels.
   *     - If the image is animated, the maximum output dimensions apply to the sum of the area of all the frames of the image. For example, a 1024x1024px GIF could have 64 frames before it would exceed the size limit.
   *     - Because we use a positive number less than 1 to return a percentage-based scaled image, in order to return an image that is 100% or more, a p suffix can be appended to the value. For example, width=250p would return an image that is 250% the width of the original. We use p as a simple way to represent percent.
   *     - If the requested width is a fraction of a pixel (e.g., as a result of applying a percentage value for width), it is rounded to the nearest integer.
   *
   *     Examples
   *     - width=200	                      => Resize the width to 200px
   *     - width=0.10	                    => Resize the width to 10% of the input image
   *     - width=150p	                    => Resize the width to 150% of the input image
   *     - width=200&height=0.50	          => Force resize to a width of 200px and a height that is 50% of the original.
   *     - width=150&height=150&fit=bounds	=> Fit image within a 150 x 150px rectangle
   *     - width=200&dpr=2	                => Resize the width to 400px (200 CSS pixels for screens with a device pixel ratio of 2)
   */
  width?: InputMaybe<Scalars['Int']['input']>;
};

/** Container for multiple image transformation operations to be applied sequentially */
export type TransformationsInput = {
  /**
   * List of image transformations to apply.
   *
   *     Transformations are applied in the order specified. Each transformation can include resizing, format conversion, quality adjustments, and various image effects. The output of one transformation becomes the input for the next.
   */
  transformations: Array<ImageTransformationInput>;
};

/**
 * Remove pixels from the edge of an image.
 *
 * The trim parameter removes pixels from the edge of an image by pixel or percentage value. This can be useful for removing whitespace and borders that appear on a source image.
 *
 * Notes
 * - Values can be specified using CSS style shorthand values. (See CSS Margin or CSS Padding for more examples).
 * - CSS shorthand allows for all edges to be specified in one property.
 * - Any fractional pixel measurements will be rounded to the nearest whole pixel.
 */
export type TrimInput = {
  /** Bottom - Pixels or Percentage(decimal 0.0 - 1) - Default=0 */
  bottom?: InputMaybe<Scalars['Int']['input']>;
  /** Left - Pixels or Percentage(decimal 0.0 - 1) - Default=0 */
  left?: InputMaybe<Scalars['Int']['input']>;
  /** Right - Pixels or Percentage(decimal 0.0 - 1) - Default=0 */
  right?: InputMaybe<Scalars['Int']['input']>;
  /** Top - Pixels or Percentage(decimal 0.0 - 1) - Default=0 */
  top?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateBundleInput = {
  /** The discount condition for this bundle. Discount can be applied for Extra Products (EP) or All Products (ALL). */
  condition?: InputMaybe<BundleCondition>;
  /** The description for this bundle. */
  description?: InputMaybe<Scalars['String']['input']>;
  /** The discount percentage this bundle. */
  discount?: InputMaybe<Scalars['Float']['input']>;
  /** The name for this bundle. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** The bundle prices. */
  price?: InputMaybe<Scalars['Float']['input']>;
  /** The bundle tax zone. */
  taxZone?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCategoryInput = {
  defaultLanguage?: InputMaybe<Scalars['String']['input']>;
  /**
   * The long description for this category,
   *     this field can contain html formatting,
   *     this field can be translated is case of multilingual catalog.
   */
  description?: InputMaybe<Array<LocalizedStringInput>>;
  /** [SEO] Metadata canonical urls in different languages. */
  metadataCanonicalUrl?: InputMaybe<Array<LocalizedStringInput>>;
  /** [SEO] Metadata description in different languages. */
  metadataDescription?: InputMaybe<Array<LocalizedStringInput>>;
  /** [SEO] Metadata keywords in different languages. */
  metadataKeywords?: InputMaybe<Array<LocalizedStringInput>>;
  /** [SEO] Metadata title in different languages. */
  metadataTitle?: InputMaybe<Array<LocalizedStringInput>>;
  /**
   * Localized category name as it is available in
   *     the supported language defaults to the category's default language.
   */
  name?: InputMaybe<Array<LocalizedStringInput>>;
  /** The category's parent Category when available */
  parent?: InputMaybe<Scalars['Int']['input']>;
  /**
   * The long description for this category,
   *     this field can contain html formatting,
   *     this field can be translated is case of multilingual catalog.
   */
  shortDescription?: InputMaybe<Array<LocalizedStringInput>>;
};

export type UpdateCompanyInput = {
  cocNumber?: InputMaybe<Scalars['String']['input']>;
  /** The id of the the company. */
  companyId: Scalars['Int']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  notes?: InputMaybe<Scalars['String']['input']>;
  /** The id of the usergroup the company should be created in. */
  parentId?: InputMaybe<Scalars['Int']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  taxNumber?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateContactInput = {
  /** Contacts's custom attribute values. This field is used to set value on attributes for the selected contact. Attributes that are used here (selected by name) must already be defined in Propeller. */
  attributes?: InputMaybe<Array<UserManagementAttributeValueInput>>;
  contactId: Scalars['Int']['input'];
  dateOfBirth?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Gender>;
  homepage?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mailingList?: InputMaybe<YesNo>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  mobile?: InputMaybe<Scalars['String']['input']>;
  /** The id of the company the contact should be created in. */
  parentId?: InputMaybe<Scalars['Int']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  /** The primary language of the contact. */
  primaryLanguage?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateCustomerInput = {
  /** Customer's custom attribute values. This field is used to set value on attributes for the selected customer. Attributes that are used here (selected by name) must already be defined in Propeller. */
  attributes?: InputMaybe<Array<UserManagementAttributeValueInput>>;
  customerId: Scalars['Int']['input'];
  dateOfBirth?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Gender>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mailingList?: InputMaybe<YesNo>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  mobile?: InputMaybe<Scalars['String']['input']>;
  /** The id of the usergroup the customer should be created in. */
  parentId?: InputMaybe<Scalars['Int']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  /** The primary language of the customer. */
  primaryLanguage?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateInventoryInput = {
  /** Inventory cost price */
  costPrice?: InputMaybe<Scalars['Float']['input']>;
  /** Inventory estimated next delivery date in ISO8601 format */
  nextDeliveryDate?: InputMaybe<Scalars['String']['input']>;
  /** Inventory notes */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** Inventory quantity */
  quantity?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateMediaAttachmentInput = {
  /**
   * Alternative text descriptions for accessibility and SEO purposes.
   *
   *     Provides brief, descriptive text that explains the media content for screen readers and when the media cannot be displayed. Each entry supports different languages.
   */
  alt?: InputMaybe<Array<MediaLocalizedStringInput>>;
  /**
   * Detailed descriptions of the media content.
   *
   *     Provides comprehensive information about what the media shows or contains. Used for search indexing and user information. Each entry supports different languages.
   */
  description?: InputMaybe<Array<MediaLocalizedStringInput>>;
  /**
   * Display order priority for the media item.
   *
   *     Lower numeric values indicate higher priority and will be displayed first. Used for controlling the order of media items in galleries and listings.
   */
  priority?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Searchable tags for categorizing and filtering media content.
   *
   *     Keywords that help organize and discover media items. Used for search functionality and content organization. Each entry supports different languages with multiple tag values.
   */
  tags?: InputMaybe<Array<MediaLocalizedStringArrayInput>>;
};

export type UpdateMediaDocumentInput = {
  /**
   * Alternative text descriptions for accessibility and SEO purposes.
   *
   *     Provides brief, descriptive text that explains the media content for screen readers and when the media cannot be displayed. Each entry supports different languages.
   */
  alt?: InputMaybe<Array<MediaLocalizedStringInput>>;
  /** Associates the media item with a specific product category */
  categoryId?: InputMaybe<Scalars['ID']['input']>;
  /** Associates the media item with a specific cluster */
  clusterId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * Detailed descriptions of the media content.
   *
   *     Provides comprehensive information about what the media shows or contains. Used for search indexing and user information. Each entry supports different languages.
   */
  description?: InputMaybe<Array<MediaLocalizedStringInput>>;
  /** MediaDocument unique identified */
  mediaId: Scalars['String']['input'];
  /**
   * Display order priority for the media item.
   *
   *     Lower numeric values indicate higher priority and will be displayed first. Used for controlling the order of media items in galleries and listings.
   */
  priority?: InputMaybe<Scalars['Int']['input']>;
  /** Associates the media item with a specific product */
  productId?: InputMaybe<Scalars['ID']['input']>;
  /** Associates the media item with a specific spare parts machine */
  sparePartsMachineId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * Searchable tags for categorizing and filtering media content.
   *
   *     Keywords that help organize and discover media items. Used for search functionality and content organization. Each entry supports different languages with multiple tag values.
   */
  tags?: InputMaybe<Array<MediaLocalizedStringArrayInput>>;
  /** Upload File input reference */
  uploadDocument?: InputMaybe<UploadFileInput>;
};

/** Input for updating an existing image media item with modified metadata or replacement file */
export type UpdateMediaImageInput = {
  /**
   * Alternative text descriptions for accessibility and SEO purposes.
   *
   *     Provides brief, descriptive text that explains the media content for screen readers and when the media cannot be displayed. Each entry supports different languages.
   */
  alt?: InputMaybe<Array<MediaLocalizedStringInput>>;
  /** Associates the media item with a specific product category */
  categoryId?: InputMaybe<Scalars['ID']['input']>;
  /** Associates the media item with a specific cluster */
  clusterId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * Detailed descriptions of the media content.
   *
   *     Provides comprehensive information about what the media shows or contains. Used for search indexing and user information. Each entry supports different languages.
   */
  description?: InputMaybe<Array<MediaLocalizedStringInput>>;
  /**
   * Unique identifier of the image to update.
   *
   *     Must be a valid media ID representing an existing image in the system. All updates will be applied to this specific image.
   */
  mediaId: Scalars['String']['input'];
  /**
   * Display order priority for the media item.
   *
   *     Lower numeric values indicate higher priority and will be displayed first. Used for controlling the order of media items in galleries and listings.
   */
  priority?: InputMaybe<Scalars['Int']['input']>;
  /** Associates the media item with a specific product */
  productId?: InputMaybe<Scalars['ID']['input']>;
  /** Associates the media item with a specific spare parts machine */
  sparePartsMachineId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * Searchable tags for categorizing and filtering media content.
   *
   *     Keywords that help organize and discover media items. Used for search functionality and content organization. Each entry supports different languages with multiple tag values.
   */
  tags?: InputMaybe<Array<MediaLocalizedStringArrayInput>>;
  /**
   * Optional replacement image file.
   *
   *     When provided, replaces the existing image file while preserving the metadata and associations. The new file will undergo the same processing and validation as during creation.
   */
  uploadImage?: InputMaybe<UploadFileInput>;
};

export type UpdateMediaVideoInput = {
  /**
   * Alternative text descriptions for accessibility and SEO purposes.
   *
   *     Provides brief, descriptive text that explains the media content for screen readers and when the media cannot be displayed. Each entry supports different languages.
   */
  alt?: InputMaybe<Array<MediaLocalizedStringInput>>;
  /** Associates the media item with a specific product category */
  categoryId?: InputMaybe<Scalars['ID']['input']>;
  /** Associates the media item with a specific cluster */
  clusterId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * Detailed descriptions of the media content.
   *
   *     Provides comprehensive information about what the media shows or contains. Used for search indexing and user information. Each entry supports different languages.
   */
  description?: InputMaybe<Array<MediaLocalizedStringInput>>;
  /** MediaVideo unique identified */
  mediaId: Scalars['String']['input'];
  /**
   * Display order priority for the media item.
   *
   *     Lower numeric values indicate higher priority and will be displayed first. Used for controlling the order of media items in galleries and listings.
   */
  priority?: InputMaybe<Scalars['Int']['input']>;
  /** Associates the media item with a specific product */
  productId?: InputMaybe<Scalars['ID']['input']>;
  /** Associates the media item with a specific spare parts machine */
  sparePartsMachineId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * Searchable tags for categorizing and filtering media content.
   *
   *     Keywords that help organize and discover media items. Used for search functionality and content organization. Each entry supports different languages with multiple tag values.
   */
  tags?: InputMaybe<Array<MediaLocalizedStringArrayInput>>;
  /** Upload Video input reference */
  video?: InputMaybe<UploadVideoInput>;
};

/**
 * Payment update data containing fields to be modified.
 *
 * Extends the payment creation input with all fields made optional for partial updates. The order ID cannot be changed after payment creation. Only provided fields will be updated, others remain unchanged.
 */
export type UpdatePaymentInput = {
  /**
   * Optional transaction to create alongside the payment for immediate processing.
   *
   * When provided, creates an associated transaction record with the payment for immediate processing and tracking. Enables atomic creation of payment and initial transaction in a single operation.
   */
  addTransaction?: InputMaybe<CreateTransactionInput>;
  /**
   * Payment amount in smallest currency unit (cents) for precise financial calculations.
   *
   * The total amount to be paid expressed in the smallest denomination of the currency (e.g., cents for USD, pence for GBP). Must be a positive integer for precise financial calculations.
   */
  amount?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Anonymous user session identifier for guest checkout payments.
   *
   * References the guest user session for payments made without authentication. Used for guest checkout tracking and order management. Must be a positive integer when provided.
   */
  anonymousId?: InputMaybe<Scalars['Int']['input']>;
  /**
   * ISO 4217 three-letter currency code for international financial transactions.
   *
   * Three-letter currency code (e.g., USD, EUR, GBP) following ISO 4217 standard. Used for currency conversion and financial reporting. Must be exactly 3 uppercase letters.
   */
  currency?: InputMaybe<Scalars['String']['input']>;
  /**
   * Payment method code used by the payment service provider for transaction processing.
   *
   * Specific payment method code used by the Payment Service Provider for processing this transaction (e.g., 'credit_card', 'paypal', 'bank_transfer'). Maximum length of 100 characters.
   */
  method?: InputMaybe<Scalars['String']['input']>;
  /**
   * External payment identifier provided by the payment service provider for tracking.
   *
   * Unique payment reference provided by the Payment Service Provider (PSP) for tracking and reconciliation. Used for payment status updates and transaction matching. Maximum length of 255 characters.
   */
  paymentId?: InputMaybe<Scalars['String']['input']>;
  /**
   * Initial payment processing status for the new payment record.
   *
   * Sets the starting status for the payment lifecycle. Determines the initial state and available actions for the payment processing workflow.
   */
  status?: InputMaybe<PaymentStatuses>;
  /**
   * Authenticated user identifier for payment attribution and history tracking.
   *
   * Links the payment to a specific authenticated user for user-specific payment history and account management. Must be a positive integer when provided.
   */
  userId?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateProductInput = {
  /** The id of the category the product should be created in. */
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  /** Product cost price */
  costPrice?: InputMaybe<Scalars['Float']['input']>;
  /** The descriptions of the product and it's translations in different languages. */
  description?: InputMaybe<Array<LocalizedStringInput>>;
  /** The EAN code of the product. */
  eanCode?: InputMaybe<Scalars['String']['input']>;
  /** The manufacturer of the product. */
  manufacturer?: InputMaybe<Scalars['String']['input']>;
  /** The manufacturer (OEM) code of the product. */
  manufacturerCode?: InputMaybe<Scalars['String']['input']>;
  /** [SEO] Metadata canonical urls in different languages. */
  metadataCanonicalUrl?: InputMaybe<Array<LocalizedStringInput>>;
  /** [SEO] Metadata description in different languages. */
  metadataDescription?: InputMaybe<Array<LocalizedStringInput>>;
  /** [SEO] Metadata keywords in different languages. */
  metadataKeywords?: InputMaybe<Array<LocalizedStringInput>>;
  /** [SEO] Metadata title in different languages. */
  metadataTitle?: InputMaybe<Array<LocalizedStringInput>>;
  /** Product minimum quantity. Defaults to 1. */
  minimumQuantity?: InputMaybe<Scalars['Int']['input']>;
  /** The names of the product and it's translations in different languages. */
  name?: InputMaybe<Array<LocalizedStringInput>>;
  /** Notes of the product and it's translations in different languages. */
  notes?: InputMaybe<Array<LocalizedStringInput>>;
  /** Original price of the product */
  originalPrice?: InputMaybe<Scalars['Float']['input']>;
  /** The default package type for this product. */
  package?: InputMaybe<Scalars['String']['input']>;
  /** The package type descriptions of the product and it's translations in different languages. */
  packageDescription?: InputMaybe<Array<LocalizedStringInput>>;
  /** The order of the product in search results when sorting by priority. */
  priority?: InputMaybe<Scalars['Int']['input']>;
  /** The id of the product. */
  productId: Scalars['Int']['input'];
  /** The short descriptions of the product and it's translations in different languages. */
  shortDescription?: InputMaybe<Array<LocalizedStringInput>>;
  /**
   * The short name product.
   *       Commonly used for connections with third parties that
   *       have a size limitation on the product name field.
   */
  shortName?: InputMaybe<Scalars['String']['input']>;
  /** The sku of the product. */
  sku?: InputMaybe<Scalars['String']['input']>;
  /** The status of the product. */
  status?: InputMaybe<ProductStatus>;
  /** Product suggested price */
  suggestedPrice?: InputMaybe<Scalars['Float']['input']>;
  /** The supplier of the product. */
  supplier?: InputMaybe<Scalars['String']['input']>;
  /** The supplier code of the product. */
  supplierCode?: InputMaybe<Scalars['String']['input']>;
  /** The tax code of the product. Defaults to H. */
  taxCode?: InputMaybe<TaxCode>;
  /** Product unit. Defaults to 1. */
  unit?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdateTaxInput = {
  /** Tax code */
  code?: InputMaybe<Scalars['String']['input']>;
  /** Tax export code */
  exportCode?: InputMaybe<Scalars['String']['input']>;
  /** Tax percentage expressed as ratio */
  ratio?: InputMaybe<Scalars['Float']['input']>;
  /** Shop identifier for the tax to apply to... If not provided the default will be inferred from the channel */
  shopId?: InputMaybe<Scalars['Int']['input']>;
  /** Tax zone */
  zone?: Scalars['String']['input'];
};

export type UpdateUserInput = {
  cocNumber?: InputMaybe<Scalars['String']['input']>;
  company?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Gender>;
  homepage?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mailingList?: InputMaybe<YesNo>;
  middleName?: InputMaybe<Scalars['String']['input']>;
  mobile?: InputMaybe<Scalars['String']['input']>;
  /** The id of the usergroup the user should be created in. */
  parentId?: InputMaybe<Scalars['Int']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  /** The primary language of the user. */
  primaryLanguage?: InputMaybe<Scalars['String']['input']>;
  taxNumber?: InputMaybe<Scalars['String']['input']>;
  userId: Scalars['Int']['input'];
};

export type UpdateUsergroupInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  /** The id of the usergroup the company should be created in. */
  parentId?: InputMaybe<Scalars['Int']['input']>;
  /** The id of the the usergroup. */
  usergroupId: Scalars['Int']['input'];
};

export type UpdateWarehouseAddressInput = {
  /** Address city */
  city?: InputMaybe<Scalars['String']['input']>;
  /** Address code */
  code?: InputMaybe<Scalars['String']['input']>;
  /** User company the address applies to */
  company?: InputMaybe<Scalars['String']['input']>;
  /** Address country */
  country?: InputMaybe<Scalars['String']['input']>;
  /** Address email [valid email format required] */
  email?: InputMaybe<Scalars['String']['input']>;
  /** User first name the address applies to */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** User gender the address applies to */
  gender?: InputMaybe<Gender>;
  /** Address primary identifier */
  id: Scalars['Int']['input'];
  /** User last name the address applies to */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** User middle name the address applies to */
  middleName?: InputMaybe<Scalars['String']['input']>;
  /** Address mobile number [min: 6, max: 30] */
  mobile?: InputMaybe<Scalars['String']['input']>;
  /** Address delivery notes */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** User street number */
  number?: InputMaybe<Scalars['String']['input']>;
  /** User street number extension */
  numberExtension?: InputMaybe<Scalars['String']['input']>;
  /** Address fixed phone number [min: 6, max: 30] */
  phone?: InputMaybe<Scalars['String']['input']>;
  /** Address postal code */
  postalCode?: InputMaybe<Scalars['String']['input']>;
  /** Address region */
  region?: InputMaybe<Scalars['String']['input']>;
  /** User street address */
  street?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateWarehouseInput = {
  /**
   * Warehouse business hours per week day
   *
   *     Example:
   *         [{
   *           dayOfWeek: 0
   *           openingTime: "08:00"
   *           closingTime: "20:00"
   *           lunchBeakStartTime: "12:00"
   *           lunchBeakEndTime: "12:30"
   *         },
   *         {
   *           dayOfWeek: 1
   *           openingTime: "08:00"
   *           closingTime: "20:00"
   *           lunchBeakStartTime: "12:00"
   *           lunchBeakEndTime: "12:30"
   *         },
   *         {
   *           dayOfWeek: 2
   *           openingTime: "08:00"
   *           closingTime: "20:00"
   *           lunchBeakStartTime: "12:00"
   *           lunchBeakEndTime: "12:30"
   *         },
   *         {
   *           dayOfWeek: 3
   *           openingTime: "08:00"
   *           closingTime: "20:00"
   *           lunchBeakStartTime: "12:00"
   *           lunchBeakEndTime: "12:30"
   *         },
   *         {
   *           dayOfWeek: 4
   *           openingTime: "08:00"
   *           closingTime: "20:00"
   *           lunchBeakStartTime: "12:00"
   *           lunchBeakEndTime: "12:30"
   *         },
   *         {
   *           dayOfWeek: 5
   *           openingTime: "08:00"
   *           closingTime: "20:00"
   *           lunchBeakStartTime: "12:00"
   *           lunchBeakEndTime: "12:30"
   *         },
   *         {
   *           dayOfWeek: 6
   *           openingTime: "08:00"
   *           closingTime: "20:00"
   *           lunchBeakStartTime: "12:00"
   *           lunchBeakEndTime: "12:30"
   *         }]
   */
  businessHours?: InputMaybe<Array<BusinessHoursInput>>;
  /** Warehouse description */
  description?: InputMaybe<Scalars['String']['input']>;
  /** Warehouse isActive status */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Warehouse isPickupLocation status */
  isPickupLocation?: InputMaybe<Scalars['Boolean']['input']>;
  /** Warehouse isStore status */
  isStore?: InputMaybe<Scalars['Boolean']['input']>;
  /** Warehouse name */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Warehouse notes */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** Optional warehouse shopId! Default value will be internally inferred from the appropriate channel */
  shopId?: InputMaybe<Scalars['Int']['input']>;
};

/** Flexible file upload input supporting multiple upload methods and configurations */
export type UploadFileInput = {
  /**
   * Base64 encoded file upload option.
   *
   *     Use this method when uploading files as base64 encoded strings. Suitable for small files or when direct file upload is not available. Maximum size is approximately 10MB.
   */
  base64File?: InputMaybe<MediaBase64FileInput>;
  /**
   * HTTP cache control settings for the uploaded file.
   *
   *     Controls how browsers and CDNs cache the file content. Optional configuration that defaults to optimal caching settings if not specified.
   */
  cacheControl?: InputMaybe<CacheControlInput>;
  /**
   * Direct file upload from filesystem.
   *
   *     Use this method for uploading files directly from the client's filesystem using GraphQL multipart request specification. Most efficient for larger files.
   */
  file?: InputMaybe<StandardFileUploadInput>;
  /**
   * Language code for the uploaded file content.
   *
   *     Specifies the language context for the file, used for localization and content organization. Must be a valid 2-character language code (e.g., 'EN', 'DE', 'FR').
   */
  language?: InputMaybe<Scalars['String']['input']>;
  /**
   * Method of file upload to use.
   *
   *     Determines whether the file should be stored internally or referenced externally. Affects how the file is processed, stored, and accessed.
   */
  uploadType: UploadType;
  /**
   * Upload file from a publicly accessible URL.
   *
   *     Use this method to upload files by providing a URL. The system will download the file from the specified location and store it locally.
   */
  urlFile?: InputMaybe<UrlFileUploadInput>;
};

/** Upload type */
export enum UploadType {
  /** Upload by providing base64 string representation of a file */
  BASE64 = 'BASE64',
  /** Upload by referencing a file */
  FILE = 'FILE',
  /** Upload by providing public url to the file */
  URL = 'URL'
}

/** Video upload specification with language and location information */
export type UploadVideoInput = {
  /**
   * Language code for the video content.
   *
   *     Specifies the language context for the video, used for localization and content organization. Must be a valid 2-character language code (e.g., 'EN', 'DE', 'FR').
   */
  language?: InputMaybe<Scalars['String']['input']>;
  /**
   * URL or URI pointing to the video content.
   *
   *     Can be a direct link to a video file, or a URL from supported video platforms like YouTube or Vimeo. The URL must be publicly accessible and return valid video content.
   */
  uri: Scalars['String']['input'];
};

export type UpsertSparePartsMachineInput = {
  /** Machine description */
  description?: InputMaybe<Array<LocalizedStringInput>>;
  externalReference: ExternalReferenceInput;
  /** Level 1 SubMachines input */
  machines?: InputMaybe<Array<CreateSparePartsMachineInput>>;
  /** Spare PartsMachine name */
  name: Array<LocalizedStringInput>;
  /** Spare parts for this machine */
  parts?: InputMaybe<Array<CreateSparePartInput>>;
};

/** Upload media content by providing a publicly accessible URL */
export type UrlFileUploadInput = {
  /**
   * Filename to use when storing the downloaded file.
   *
   *     Must include the file extension and be between 5-255 characters. This name will be used for storage and may affect how the file is processed.
   */
  fileName: Scalars['String']['input'];
  /**
   * Publicly accessible URL to the media file.
   *
   *     The URL must be accessible without authentication and return the actual file content. The service will download and store the file from this location.
   */
  url: Scalars['String']['input'];
};

export type UserAddressCreateInput = {
  /** Address city */
  city: Scalars['String']['input'];
  /** Address code */
  code?: InputMaybe<Scalars['String']['input']>;
  /** User company the address applies to */
  company?: InputMaybe<Scalars['String']['input']>;
  /** Address country */
  country: Scalars['String']['input'];
  /** Address email [valid email format required] */
  email?: InputMaybe<Scalars['String']['input']>;
  /** User first name the address applies to */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** User gender the address applies to */
  gender?: InputMaybe<Gender>;
  /** ICP address field defines whether tax should be applied to an order if the address is selected as a delivery address. Used when shipping b2b order abroad */
  icp?: InputMaybe<YesNo>;
  /** Indicates whether the address is default for its type */
  isDefault?: InputMaybe<YesNo>;
  /** User last name the address applies to */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** User middle name the address applies to */
  middleName?: InputMaybe<Scalars['String']['input']>;
  /** Address mobile number [min: 6, max: 30] */
  mobile?: InputMaybe<Scalars['String']['input']>;
  /** Address delivery notes */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** User street number */
  number?: InputMaybe<Scalars['String']['input']>;
  /** User street number extension */
  numberExtension?: InputMaybe<Scalars['String']['input']>;
  /** Address fixed phone number [min: 6, max: 30] */
  phone?: InputMaybe<Scalars['String']['input']>;
  /** Address postal code */
  postalCode: Scalars['String']['input'];
  /** Address region */
  region?: InputMaybe<Scalars['String']['input']>;
  /** User street address */
  street: Scalars['String']['input'];
  /** Address type [one of 'home', 'delivery' or 'invoice'] */
  type: AddressType;
  /** Address user primary identifier */
  userId: Scalars['Int']['input'];
};

export type UserAddressDeleteInput = {
  /** Address primary identifier */
  id: Scalars['Int']['input'];
  /** User primary identifier */
  userId: Scalars['Int']['input'];
};

export type UserAddressUpdateInput = {
  /** Address city */
  city?: InputMaybe<Scalars['String']['input']>;
  /** Address code */
  code?: InputMaybe<Scalars['String']['input']>;
  /** User company the address applies to */
  company?: InputMaybe<Scalars['String']['input']>;
  /** Address country */
  country?: InputMaybe<Scalars['String']['input']>;
  /** Address email [valid email format required] */
  email?: InputMaybe<Scalars['String']['input']>;
  /** User first name the address applies to */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** User gender the address applies to */
  gender?: InputMaybe<Gender>;
  /** ICP address field defines whether tax should be applied to an order if the address is selected as a delivery address. Used when shipping b2b order abroad */
  icp?: InputMaybe<YesNo>;
  /** Address primary identifier */
  id: Scalars['Int']['input'];
  /** Indicates whether the address is default for its type */
  isDefault?: InputMaybe<YesNo>;
  /** User last name the address applies to */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** User middle name the address applies to */
  middleName?: InputMaybe<Scalars['String']['input']>;
  /** Address mobile number [min: 6, max: 30] */
  mobile?: InputMaybe<Scalars['String']['input']>;
  /** Address delivery notes */
  notes?: InputMaybe<Scalars['String']['input']>;
  /** User street number */
  number?: InputMaybe<Scalars['String']['input']>;
  /** User street number extension */
  numberExtension?: InputMaybe<Scalars['String']['input']>;
  /** Address fixed phone number [min: 6, max: 30] */
  phone?: InputMaybe<Scalars['String']['input']>;
  /** Address postal code */
  postalCode?: InputMaybe<Scalars['String']['input']>;
  /** Address region */
  region?: InputMaybe<Scalars['String']['input']>;
  /** User street address */
  street?: InputMaybe<Scalars['String']['input']>;
  /** Address user primary identifier */
  userId: Scalars['Int']['input'];
};

export type UserManagementAttributeSearchInput = {
  /** Decimal value for the attribute, required when attribute type equals decimal. */
  decimalValue?: InputMaybe<Scalars['Float']['input']>;
  /** Enumeration value for the attribute, required when type equals enum or enumlist. Values in this field can be multivalue. */
  enumValue?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Integer value for the attribute, required when attribute type equals numeric or object. */
  intValue?: InputMaybe<Scalars['Int']['input']>;
  /** Attribute name for which the value is applied for. */
  name: Scalars['String']['input'];
  /** Textual value(s) for the attribute, required when attribute type equals text, list or color. This value is suitable for Localization. */
  textValue?: InputMaybe<LocalizedStringArrayInput>;
  /** Attribute type. */
  type: AttributeType;
};

export type UserManagementAttributeValueInput = {
  /** Decimal value for the attribute, required when attribute type equals decimal. */
  decimalValue?: InputMaybe<Scalars['Float']['input']>;
  /** Enumeration value for the attribute, required when type equals enum or enumlist. Values in this field can be multivalue. */
  enumValue?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Integer value for the attribute, required when attribute type equals numeric or object. */
  intValue?: InputMaybe<Scalars['Int']['input']>;
  /** Attribute name for which the value is applied for. */
  name: Scalars['String']['input'];
  /** Textual value(s) for the attribute, required when attribute type equals text, list or color. This value is suitable for Localization. */
  textValue?: InputMaybe<LocalizedStringArrayInput>;
  /** Attribute type. */
  type: AttributeType;
};

export type UsergroupSearchArguments = {
  /** Usergroup's name */
  name?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  /** List of usergroup sort filters */
  sort?: InputMaybe<Array<UsergroupSortInput>>;
};

export type UsergroupSortInput = {
  /** Available sortable fields */
  field: UsergroupSortableFields;
  /** Sort ordering ['desc' or 'asc'] */
  order?: SortOrder;
};

/** Usergroup sortable fields */
export enum UsergroupSortableFields {
  name = 'name'
}

export type ValuesetCreateInput = {
  /**
   * Human-readable descriptions explaining the purpose and usage of this value set in multiple languages.
   *
   * Provides context for administrators and developers about what this value set represents and how it should be used throughout the system.
   */
  descriptions?: InputMaybe<Array<LocalizedStringInput>>;
  /**
   * Unique identifier name for the new value set that will be used throughout the system for referencing and configuration purposes.
   *
   * Must be unique across all value sets and follow naming conventions for system identifiers.
   */
  name: Scalars['String']['input'];
  /**
   * Classification determining the management scope and modification permissions for this value set.
   *
   * SYSTEM types are reserved for core system functionality and can only be created by automated processes. CUSTOM types can be created and modified by authorized users for business-specific needs.
   */
  type?: ValuesetType;
};

export type ValuesetItemCreateInput = {
  /**
   * Human-readable labels for this value set item in multiple languages.
   *
   * These descriptions will be displayed to users in dropdown lists, selection interfaces, and other UI components. Providing multiple languages ensures proper internationalization support.
   */
  descriptions?: InputMaybe<Array<LocalizedStringInput>>;
  /**
   * Additional metadata or supplementary information for this value set item.
   *
   * Can be used to store related data such as currency codes, country codes, or other contextual information that enhances the item's functionality. Maximum length is 512 characters.
   */
  extra?: InputMaybe<Scalars['String']['input']>;
  /**
   * The actual data value that this item will represent in the system.
   *
   * Must be unique within the parent value set and will be used as the key for selection and processing. Length must be between 1 and 512 characters.
   */
  value: Scalars['String']['input'];
  /**
   * Identifier of the parent value set that will contain this new item.
   *
   * Must reference an existing value set that the user has permission to modify.
   */
  valuesetId: Scalars['Int']['input'];
};

/** Search criteria and pagination parameters for filtering value set items across multiple value sets */
export type ValuesetItemSearchInput = {
  /** Filter items by their extra metadata values. Provide an array of extra value strings to find items with matching additional data like codes or categories. */
  extras?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter by specific value set item identifiers. Provide an array of numeric IDs to retrieve only those specific items, useful for bulk operations or targeted queries. */
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Number of value set items to return per page. Controls the size of each page in the paginated response to manage data volume and performance. Must be between 1 and 100 items per page. */
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Page number for pagination, starting from 1. Used to navigate through multiple pages of results when the total number of items exceeds the offset limit. Must be a positive integer (minimum: 1). */
  page?: InputMaybe<Scalars['Int']['input']>;
  /** Sorting criteria for organizing search results. Supports multiple sort fields with different orders to achieve complex result organization for dropdown displays. */
  sortInputs?: InputMaybe<Array<ValuesetItemSortInput>>;
  /** Filter items by their actual data values. Provide an array of value strings to find items with matching values, helpful for searching specific options in dropdown lists. */
  values?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Filter items by their parent value set identifiers. Provide an array of value set IDs to retrieve items from specific value sets only, essential for dropdown population. */
  valuesetIds?: InputMaybe<Array<Scalars['Int']['input']>>;
};

/** Available fields for sorting value set item search results to organize dropdown options and configuration data */
export enum ValuesetItemSortField {
  /** Sort by additional metadata field, helpful for organizing items by supplementary information like codes or categories */
  EXTRA = 'EXTRA',
  /** Sort by unique identifier in numerical order, useful for consistent ordering and database optimization */
  ID = 'ID',
  /** Sort alphabetically by item value, ideal for user-friendly dropdown displays and selection interfaces */
  VALUE = 'VALUE'
}

/** Sorting configuration for value set item search results, allowing organization by various fields and sort orders for optimal dropdown display */
export type ValuesetItemSortInput = {
  /** The field to sort value set items by. Choose from ID, VALUE, or EXTRA to organize results according to your specific display needs and user experience requirements. */
  field: ValuesetItemSortField;
  /** Sort order direction. Use ASC for ascending order (A-Z, 1-9) or DESC for descending order (Z-A, 9-1) to match user interface expectations. */
  order?: InputMaybe<ValuesetSortOrder>;
};

/** Partial update data for modifying existing value set item properties. All fields are optional - only provided fields will be updated while others remain unchanged. The parent value set association cannot be changed after creation for data integrity reasons. */
export type ValuesetItemUpdateInput = {
  /**
   * Human-readable labels for this value set item in multiple languages.
   *
   * These descriptions will be displayed to users in dropdown lists, selection interfaces, and other UI components. Providing multiple languages ensures proper internationalization support.
   */
  descriptions?: InputMaybe<Array<LocalizedStringInput>>;
  /**
   * Additional metadata or supplementary information for this value set item.
   *
   * Can be used to store related data such as currency codes, country codes, or other contextual information that enhances the item's functionality. Maximum length is 512 characters.
   */
  extra?: InputMaybe<Scalars['String']['input']>;
  /**
   * The actual data value that this item will represent in the system.
   *
   * Must be unique within the parent value set and will be used as the key for selection and processing. Length must be between 1 and 512 characters.
   */
  value?: InputMaybe<Scalars['String']['input']>;
};

export type ValuesetSearchInput = {
  /** Filter value sets by their creation date range. Useful for finding recently created value sets or tracking configuration changes over time. */
  createdAt?: InputMaybe<DateSearchInput>;
  /** Filter by specific value set identifiers. Provide an array of numeric IDs to retrieve only those specific value sets, useful for bulk operations or targeted queries. */
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Filter value sets by their last modification date range. Helpful for identifying recently updated configurations or tracking maintenance activities. */
  lastModifiedAt?: InputMaybe<DateSearchInput>;
  /** Filter by specific value set names. Provide an array of name strings to retrieve value sets with matching names, helpful for configuration management and system integration. */
  names?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Number of value sets to return per page. Controls the size of each page in the paginated response to manage data volume and performance. Must be between 1 and 100 items per page. */
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** Page number for pagination, starting from 1. Used to navigate through multiple pages of results when the total number of value sets exceeds the offset limit. Must be a positive integer (minimum: 1). */
  page?: InputMaybe<Scalars['Int']['input']>;
  /** Sorting criteria for organizing search results. Supports multiple sort fields with different orders to achieve complex result organization. */
  sortInputs?: InputMaybe<Array<ValuesetSortInput>>;
  /** Filter by value set type classification. SYSTEM types are managed automatically by the system, while CUSTOM types can be modified by authorized users. */
  type?: InputMaybe<ValuesetType>;
};

/** Available fields for sorting value set search results to organize data according to specific criteria */
export enum ValuesetSortField {
  /** Sort by creation timestamp, useful for chronological organization and audit trails */
  CREATED_AT = 'CREATED_AT',
  /** Sort by unique identifier in numerical order, useful for consistent ordering and database optimization */
  ID = 'ID',
  /** Sort by last modification timestamp, helpful for tracking recent changes and update management */
  LAST_MODIFIED_AT = 'LAST_MODIFIED_AT',
  /** Sort alphabetically by value set name, ideal for user-friendly displays and configuration interfaces */
  NAME = 'NAME'
}

/** Sorting configuration for value set search results, allowing organization by various fields and sort orders */
export type ValuesetSortInput = {
  /** The field to sort value sets by. Choose from ID, NAME, CREATED_AT, or LAST_MODIFIED_AT to organize results according to your specific needs. */
  field: ValuesetSortField;
  /** Sort order direction. Use ASC for ascending order (A-Z, 1-9, oldest first) or DESC for descending order (Z-A, 9-1, newest first). */
  order?: InputMaybe<ValuesetSortOrder>;
};

/** Sort order direction for organizing search results in ascending or descending sequence */
export enum ValuesetSortOrder {
  /** Ascending order - sorts from lowest to highest (A-Z, 1-9, oldest to newest) */
  ASC = 'ASC',
  /** Descending order - sorts from highest to lowest (Z-A, 9-1, newest to oldest) */
  DESC = 'DESC'
}

/** Classification of value sets based on their management and usage scope within the system */
export enum ValuesetType {
  /** User-defined value sets that can be created, modified, and deleted by authorized users. Used for business-specific configurations and custom dropdown options. */
  CUSTOM = 'CUSTOM',
  /** System-managed value sets that are automatically maintained and cannot be modified by users. Used for core system functionality and predefined configurations. */
  SYSTEM = 'SYSTEM'
}

/** Partial update data for modifying existing value set properties. All fields are optional - only provided fields will be updated while others remain unchanged. The type field cannot be modified after creation for data integrity reasons. */
export type ValuesetUpdateInput = {
  /**
   * Human-readable descriptions explaining the purpose and usage of this value set in multiple languages.
   *
   * Provides context for administrators and developers about what this value set represents and how it should be used throughout the system.
   */
  descriptions?: InputMaybe<Array<LocalizedStringInput>>;
  /**
   * Unique identifier name for the new value set that will be used throughout the system for referencing and configuration purposes.
   *
   * Must be unique across all value sets and follow naming conventions for system identifiers.
   */
  name?: InputMaybe<Scalars['String']['input']>;
};

export type VerifyTokenInput = {
  token: Scalars['String']['input'];
};

export type VideoCsvInput = {
  /** CSV file */
  file: Scalars['Upload']['input'];
  /** A list of MediaVideos CSV field mappings */
  mappings?: InputMaybe<Array<VideoCsvMapping>>;
};

export type VideoCsvMapping = {
  /** The name of the column in the CSV file */
  csvHeader: Scalars['String']['input'];
  /** The name of the field in Propeller eCommerce Platform */
  fieldName: VideoFieldName;
};

/** Fields available for video CSV mapping. */
export enum VideoFieldName {
  /** [Required][String] The alt descriptions of this MediaVideo per language */
  ALT_VALUE = 'ALT_VALUE',
  /** [Optional][Integer] This MediaVideo's linked Category */
  CATEGORY_ID = 'CATEGORY_ID',
  /** [Optional][String] This MediaVideo's linked Cluster */
  CLUSTER_ID = 'CLUSTER_ID',
  /** [Required][String] The descriptions of this MediaVideo per language */
  DESCRIPTION_VALUE = 'DESCRIPTION_VALUE',
  /** [Optional][String] This MediaVideo's unique identifier */
  ID = 'ID',
  /** [Required][String] Language of the MediaVideo [Default: EN] */
  LANGUAGE = 'LANGUAGE',
  /** [Optional][Integer] MediaVideo display priority [Lower value has higher priority] - [Default: 1000] */
  PRIORITY = 'PRIORITY',
  /** [Optional][String] This MediaVideo's linked Product. */
  PRODUCT_ID = 'PRODUCT_ID',
  /** [Optional][String] This MediaVideo's linked SpareParts Machine */
  SPAREPARTS_MACHINE_ID = 'SPAREPARTS_MACHINE_ID',
  /** [Required][String[]] The tags of this MediaVideo per language */
  TAGS_VALUES = 'TAGS_VALUES',
  /** [Required][String] MediaVideo url */
  VIDEO_URI = 'VIDEO_URI'
}

export type WarehousesSearchInput = {
  /** Search warehouses by ids */
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Warehouse isActive status */
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Warehouse isPickupLocation status */
  isPickupLocation?: InputMaybe<Scalars['Boolean']['input']>;
  /** Warehouse isStore status */
  isStore?: InputMaybe<Scalars['Boolean']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

/** Boolean in Yes/No format */
export enum YesNo {
  N = 'N',
  Y = 'Y'
}

export type Custom_CartFragment_Cart_total_CartTotal = { __typename: 'CartTotal', totalGross: number, totalNet: number };

export type Custom_CartFragment_Cart_postageData_CartPostageData = { __typename: 'CartPostageData', shippingMethod: string, requestDate: string, postage: number, postageNet: number };

export type Custom_CartFragment_Cart_taxLevels_CartTaxLevel = { __typename: 'CartTaxLevel', taxCode: Taxcode, price: number };

export type Custom_CartFragment_Cart_deliveryAddress_CartAddress = { __typename: 'CartAddress', code?: string | null, lastName: string, firstName: string, street: string, number?: string | null, postalCode: string, city: string, country: string, phone?: string | null, email?: string | null };

export type Custom_CartFragment_Cart_items_CartMainItem_product_Product = (
  { __typename: 'Product' }
  & ProductListItemFragment
);

export type Custom_CartFragment_Cart_items_CartMainItem_childItems_CartBaseItem_product_Product = { __typename: 'Product', id: number, sku: string, package: string };

export type Custom_CartFragment_Cart_items_CartMainItem_childItems_CartBaseItem = { __typename: 'CartBaseItem', id: number, productId?: number | null, taxCode: Taxcode, quantity: number, price: number, priceNet: number, totalPrice: number, totalPriceNet: number, product: Custom_CartFragment_Cart_items_CartMainItem_childItems_CartBaseItem_product_Product };

export type Custom_CartFragment_Cart_items_CartMainItem = { __typename: 'CartMainItem', id: number, productId?: number | null, taxCode: Taxcode, quantity: number, price: number, priceNet: number, totalPrice: number, totalPriceNet: number, totalSum: number, totalSumNet: number, sum: number, sumNet: number, notes: string, product?: Custom_CartFragment_Cart_items_CartMainItem_product_Product | null, childItems?: Array<Custom_CartFragment_Cart_items_CartMainItem_childItems_CartBaseItem> | null };

export type Custom_CartFragment = { __typename: 'Cart', cartId: string, userId: number, channelId?: number | null, notes?: string | null, reference?: string | null, orderStatus?: string | null, actionCode?: string | null, total?: Custom_CartFragment_Cart_total_CartTotal | null, postageData?: Custom_CartFragment_Cart_postageData_CartPostageData | null, taxLevels?: Array<Custom_CartFragment_Cart_taxLevels_CartTaxLevel> | null, deliveryAddress: Custom_CartFragment_Cart_deliveryAddress_CartAddress, items?: Array<Custom_CartFragment_Cart_items_CartMainItem> | null };

export type ProductAttributesFragment_Product_attributeValues_AttributeValueResponse_items_AttributeValue_textValue_LocalizedStringArray = { __typename: 'LocalizedStringArray', language: string, values?: Array<string> | null };

export type ProductAttributesFragment_Product_attributeValues_AttributeValueResponse_items_AttributeValue_attributeDescription_AttributeDescription_description_LocalizedString = { __typename: 'LocalizedString', language: string, value?: string | null };

export type ProductAttributesFragment_Product_attributeValues_AttributeValueResponse_items_AttributeValue_attributeDescription_AttributeDescription = { __typename: 'AttributeDescription', name: string, id: number, searchId: string, type: AttributeType, typeParam: string, group: string, description: Array<ProductAttributesFragment_Product_attributeValues_AttributeValueResponse_items_AttributeValue_attributeDescription_AttributeDescription_description_LocalizedString> };

export type ProductAttributesFragment_Product_attributeValues_AttributeValueResponse_items_AttributeValue = { __typename: 'AttributeValue', attributeId: number, enumValue?: Array<string> | null, intValue?: Array<number> | null, decimalValue?: Array<number> | null, dateValue?: string | null, textValue?: Array<ProductAttributesFragment_Product_attributeValues_AttributeValueResponse_items_AttributeValue_textValue_LocalizedStringArray> | null, attributeDescription: ProductAttributesFragment_Product_attributeValues_AttributeValueResponse_items_AttributeValue_attributeDescription_AttributeDescription };

export type ProductAttributesFragment_Product_attributeValues_AttributeValueResponse = { __typename: 'AttributeValueResponse', itemsFound: number, items: Array<ProductAttributesFragment_Product_attributeValues_AttributeValueResponse_items_AttributeValue> };

export type ProductAttributesFragment = { __typename: 'Product', attributeValues: ProductAttributesFragment_Product_attributeValues_AttributeValueResponse };

export type ProductDetailFragment_Product_shortDescription_LocalizedString = { __typename: 'LocalizedString', language: string, value?: string | null };

export type ProductDetailFragment = (
  { __typename: 'Product', shortDescription: Array<ProductDetailFragment_Product_shortDescription_LocalizedString> }
  & ProductListItemFragment
  & ProductAttributesFragment
);

export type ProductImagesFragment_Product_media_ProductMedia_images_PaginatedMediaImageResponse_items_MediaImage_alt_LocalizedString = { __typename: 'LocalizedString', language: string, value?: string | null };

export type ProductImagesFragment_Product_media_ProductMedia_images_PaginatedMediaImageResponse_items_MediaImage_images_LocalizedImage = { __typename: 'LocalizedImage', language: string, originalUrl: string, mimeType: string };

export type ProductImagesFragment_Product_media_ProductMedia_images_PaginatedMediaImageResponse_items_MediaImage = { __typename: 'MediaImage', alt: Array<ProductImagesFragment_Product_media_ProductMedia_images_PaginatedMediaImageResponse_items_MediaImage_alt_LocalizedString>, images?: Array<ProductImagesFragment_Product_media_ProductMedia_images_PaginatedMediaImageResponse_items_MediaImage_images_LocalizedImage> | null };

export type ProductImagesFragment_Product_media_ProductMedia_images_PaginatedMediaImageResponse = { __typename: 'PaginatedMediaImageResponse', items: Array<ProductImagesFragment_Product_media_ProductMedia_images_PaginatedMediaImageResponse_items_MediaImage> };

export type ProductImagesFragment_Product_media_ProductMedia = { __typename: 'ProductMedia', images?: ProductImagesFragment_Product_media_ProductMedia_images_PaginatedMediaImageResponse | null };

export type ProductImagesFragment = { __typename: 'Product', media?: ProductImagesFragment_Product_media_ProductMedia | null };

export type ProductListItemFragment_Product_slug_LocalizedString = { __typename: 'LocalizedString', language: string, value?: string | null };

export type ProductListItemFragment_Product_name_LocalizedString = { __typename: 'LocalizedString', language: string, value?: string | null };

export type ProductListItemFragment_Product_analyticsName_LocalizedString = { __typename: 'LocalizedString', value?: string | null };

export type ProductListItemFragment_Product_analyticsBrandAttribute_AttributeValueResponse_items_AttributeValue_textValue_LocalizedStringArray = { __typename: 'LocalizedStringArray', values?: Array<string> | null };

export type ProductListItemFragment_Product_analyticsBrandAttribute_AttributeValueResponse_items_AttributeValue = { __typename: 'AttributeValue', attributeId: number, textValue?: Array<ProductListItemFragment_Product_analyticsBrandAttribute_AttributeValueResponse_items_AttributeValue_textValue_LocalizedStringArray> | null };

export type ProductListItemFragment_Product_analyticsBrandAttribute_AttributeValueResponse = { __typename: 'AttributeValueResponse', items: Array<ProductListItemFragment_Product_analyticsBrandAttribute_AttributeValueResponse_items_AttributeValue> };

export type ProductListItemFragment_Product_analyticsCategoryPath_Category_analyticsName_LocalizedString = { __typename: 'LocalizedString', value?: string | null };

export type ProductListItemFragment_Product_analyticsCategoryPath_Category = { __typename: 'Category', categoryId: number, analyticsName: Array<ProductListItemFragment_Product_analyticsCategoryPath_Category_analyticsName_LocalizedString> };

export type ProductListItemFragment = (
  { __typename: 'Product', productId: number, categoryId: number, taxCode: TaxCode, status: ProductStatus, priceDisplay: string, supplierCode: string, sku: string, package: string, minimumOrderQuantity: number, incrementalOrderQuantity: number, slug: Array<ProductListItemFragment_Product_slug_LocalizedString>, name: Array<ProductListItemFragment_Product_name_LocalizedString>, analyticsName: Array<ProductListItemFragment_Product_analyticsName_LocalizedString>, analyticsBrandAttribute: ProductListItemFragment_Product_analyticsBrandAttribute_AttributeValueResponse, analyticsCategoryPath: Array<ProductListItemFragment_Product_analyticsCategoryPath_Category> }
  & ProductImagesFragment
);

export type LoginMutation_login_Login_session_GCIPUser = { __typename: 'GCIPUser', uid: string, isAnonymous?: boolean | null, email?: string | null, accessToken: string, refreshToken: string, expirationTime?: string | null };

export type LoginMutation_login_Login = { __typename: 'Login', session?: LoginMutation_login_Login_session_GCIPUser | null };

export type LoginMutation_Mutation = { login: LoginMutation_login_Login };


export type LoginMutationVariables = Exact<{
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
}>;


export type LoginMutation = LoginMutation_Mutation;

export type RefreshTokenMutation_exchangeRefreshToken_RefreshTokenResponse = { __typename: 'RefreshTokenResponse', access_token: string, refresh_token: string, expires_in: number };

export type RefreshTokenMutation_Mutation = { exchangeRefreshToken: RefreshTokenMutation_exchangeRefreshToken_RefreshTokenResponse };


export type RefreshTokenMutationVariables = Exact<{
  refreshToken: Scalars['String']['input'];
}>;


export type RefreshTokenMutation = RefreshTokenMutation_Mutation;

export type ContactUpdateMutation_contactUpdate_Contact = { __typename: 'Contact', id: number };

export type ContactUpdateMutation_Mutation = { contactUpdate: ContactUpdateMutation_contactUpdate_Contact };


export type ContactUpdateMutationVariables = Exact<{
  input: UpdateContactInput;
}>;


export type ContactUpdateMutation = ContactUpdateMutation_Mutation;

export type ContactCartIdQuery_contact_Contact_attributeValues_AttributeValueResponse_items_AttributeValue_attributeDescription_AttributeDescription = { __typename: 'AttributeDescription', name: string };

export type ContactCartIdQuery_contact_Contact_attributeValues_AttributeValueResponse_items_AttributeValue_textValue_LocalizedStringArray = { __typename: 'LocalizedStringArray', values?: Array<string> | null };

export type ContactCartIdQuery_contact_Contact_attributeValues_AttributeValueResponse_items_AttributeValue = { __typename: 'AttributeValue', attributeId: number, attributeDescription: ContactCartIdQuery_contact_Contact_attributeValues_AttributeValueResponse_items_AttributeValue_attributeDescription_AttributeDescription, textValue?: Array<ContactCartIdQuery_contact_Contact_attributeValues_AttributeValueResponse_items_AttributeValue_textValue_LocalizedStringArray> | null };

export type ContactCartIdQuery_contact_Contact_attributeValues_AttributeValueResponse = { __typename: 'AttributeValueResponse', items: Array<ContactCartIdQuery_contact_Contact_attributeValues_AttributeValueResponse_items_AttributeValue> };

export type ContactCartIdQuery_contact_Contact = { __typename: 'Contact', attributeValues: ContactCartIdQuery_contact_Contact_attributeValues_AttributeValueResponse };

export type ContactCartIdQuery_Query = { contact: ContactCartIdQuery_contact_Contact };


export type ContactCartIdQueryVariables = Exact<{
  contactId: Scalars['Float']['input'];
}>;


export type ContactCartIdQuery = ContactCartIdQuery_Query;

export type ContactQuery_contact_Contact_company_Company_addresses_Address = { __typename: 'Address', id: number, country: string };

export type ContactQuery_contact_Contact_company_Company = { __typename: 'Company', name: string, addresses: Array<ContactQuery_contact_Contact_company_Company_addresses_Address> };

export type ContactQuery_contact_Contact_attributeValues_AttributeValueResponse_items_AttributeValue_attributeDescription_AttributeDescription = { __typename: 'AttributeDescription', name: string };

export type ContactQuery_contact_Contact_attributeValues_AttributeValueResponse_items_AttributeValue_textValue_LocalizedStringArray = { __typename: 'LocalizedStringArray', language: string, values?: Array<string> | null };

export type ContactQuery_contact_Contact_attributeValues_AttributeValueResponse_items_AttributeValue = { __typename: 'AttributeValue', attributeId: number, intValue?: Array<number> | null, attributeDescription: ContactQuery_contact_Contact_attributeValues_AttributeValueResponse_items_AttributeValue_attributeDescription_AttributeDescription, textValue?: Array<ContactQuery_contact_Contact_attributeValues_AttributeValueResponse_items_AttributeValue_textValue_LocalizedStringArray> | null };

export type ContactQuery_contact_Contact_attributeValues_AttributeValueResponse = { __typename: 'AttributeValueResponse', items: Array<ContactQuery_contact_Contact_attributeValues_AttributeValueResponse_items_AttributeValue> };

export type ContactQuery_contact_Contact = { __typename: 'Contact', contactId: number, firstName: string, lastName: string, email: string, primaryLanguage?: string | null, parentCompanyId: number, company?: ContactQuery_contact_Contact_company_Company | null, attributeValues: ContactQuery_contact_Contact_attributeValues_AttributeValueResponse };

export type ContactQuery_Query = { contact: ContactQuery_contact_Contact };


export type ContactQueryVariables = Exact<{
  contactId: Scalars['Float']['input'];
}>;


export type ContactQuery = ContactQuery_Query;

export type PasswordResetLinkMutation_Mutation = { passwordResetLink: string };


export type PasswordResetLinkMutationVariables = Exact<{
  email: Scalars['String']['input'];
  lang: Scalars['String']['input'];
  redirectUrl: Scalars['String']['input'];
}>;


export type PasswordResetLinkMutation = PasswordResetLinkMutation_Mutation;

export type AddCartItemMutation_cartAddItem_CartResponse_cart_Cart = (
  { __typename: 'Cart' }
  & Custom_CartFragment
);

export type AddCartItemMutation_cartAddItem_CartResponse = { __typename: 'CartResponse', cart: AddCartItemMutation_cartAddItem_CartResponse_cart_Cart };

export type AddCartItemMutation_Mutation = { cartAddItem: AddCartItemMutation_cartAddItem_CartResponse };


export type AddCartItemMutationVariables = Exact<{
  input: CartAddItemInput;
  locale: Scalars['String']['input'];
  analyticsLocale: Scalars['String']['input'];
}>;


export type AddCartItemMutation = AddCartItemMutation_Mutation;

export type CreateCartMutation_cartStart_Cart = { __typename: 'Cart', cartId: string };

export type CreateCartMutation_Mutation = { cartStart: CreateCartMutation_cartStart_Cart };


export type CreateCartMutationVariables = Exact<{
  userId: Scalars['Int']['input'];
}>;


export type CreateCartMutation = CreateCartMutation_Mutation;

export type DeleteCartItemMutation_cartDeleteItem_CartResponse_cart_Cart = (
  { __typename: 'Cart' }
  & Custom_CartFragment
);

export type DeleteCartItemMutation_cartDeleteItem_CartResponse = { __typename: 'CartResponse', cart: DeleteCartItemMutation_cartDeleteItem_CartResponse_cart_Cart };

export type DeleteCartItemMutation_Mutation = { cartDeleteItem: DeleteCartItemMutation_cartDeleteItem_CartResponse };


export type DeleteCartItemMutationVariables = Exact<{
  cartId: Scalars['String']['input'];
  itemId: Scalars['Int']['input'];
  locale: Scalars['String']['input'];
  analyticsLocale: Scalars['String']['input'];
}>;


export type DeleteCartItemMutation = DeleteCartItemMutation_Mutation;

export type DeleteCartMutation_cartDelete_CartDeleteResponse = { __typename: 'CartDeleteResponse', success: boolean, message: string };

export type DeleteCartMutation_Mutation = { cartDelete: DeleteCartMutation_cartDelete_CartDeleteResponse };


export type DeleteCartMutationVariables = Exact<{
  cartId: Scalars['String']['input'];
}>;


export type DeleteCartMutation = DeleteCartMutation_Mutation;

export type GetCartLinesBasicQuery_cart_Cart_items_CartMainItem_product_Product = { __typename: 'Product', sku: string };

export type GetCartLinesBasicQuery_cart_Cart_items_CartMainItem = { __typename: 'CartMainItem', id: number, notes: string, product?: GetCartLinesBasicQuery_cart_Cart_items_CartMainItem_product_Product | null };

export type GetCartLinesBasicQuery_cart_Cart = { __typename: 'Cart', items?: Array<GetCartLinesBasicQuery_cart_Cart_items_CartMainItem> | null };

export type GetCartLinesBasicQuery_Query = { cart: GetCartLinesBasicQuery_cart_Cart };


export type GetCartLinesBasicQueryVariables = Exact<{
  cartId: Scalars['String']['input'];
}>;


export type GetCartLinesBasicQuery = GetCartLinesBasicQuery_Query;

export type GetCartQuery_cart_Cart = (
  { __typename: 'Cart' }
  & Custom_CartFragment
);

export type GetCartQuery_Query = { cart: GetCartQuery_cart_Cart };


export type GetCartQueryVariables = Exact<{
  cartId: Scalars['String']['input'];
  locale: Scalars['String']['input'];
  analyticsLocale: Scalars['String']['input'];
}>;


export type GetCartQuery = GetCartQuery_Query;

export type GetOrderStatusQuery_order_Order = { __typename: 'Order', id: number, status: string };

export type GetOrderStatusQuery_Query = { order: GetOrderStatusQuery_order_Order };


export type GetOrderStatusQueryVariables = Exact<{
  orderId?: InputMaybe<Scalars['Int']['input']>;
  orderUUID?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetOrderStatusQuery = GetOrderStatusQuery_Query;

export type GetPaymentStatusQuery_payment_Payment = { __typename: 'Payment', id: string, paymentId?: string | null, status: PaymentStatuses, amount: number };

export type GetPaymentStatusQuery_Query = { payment?: GetPaymentStatusQuery_payment_Payment | null };


export type GetPaymentStatusQueryVariables = Exact<{
  orderId?: InputMaybe<Scalars['Float']['input']>;
  paymentId?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetPaymentStatusQuery = GetPaymentStatusQuery_Query;

export type UpdateCartItemVoidMutation_cartUpdateItem_CartResponse_cart_Cart = { __typename: 'Cart', cartId: string };

export type UpdateCartItemVoidMutation_cartUpdateItem_CartResponse = { __typename: 'CartResponse', cart: UpdateCartItemVoidMutation_cartUpdateItem_CartResponse_cart_Cart };

export type UpdateCartItemVoidMutation_Mutation = { cartUpdateItem: UpdateCartItemVoidMutation_cartUpdateItem_CartResponse };


export type UpdateCartItemVoidMutationVariables = Exact<{
  input: CartUpdateItemInput;
}>;


export type UpdateCartItemVoidMutation = UpdateCartItemVoidMutation_Mutation;

export type UpdateCartItemMutation_cartUpdateItem_CartResponse_cart_Cart = (
  { __typename: 'Cart' }
  & Custom_CartFragment
);

export type UpdateCartItemMutation_cartUpdateItem_CartResponse = { __typename: 'CartResponse', cart: UpdateCartItemMutation_cartUpdateItem_CartResponse_cart_Cart };

export type UpdateCartItemMutation_Mutation = { cartUpdateItem: UpdateCartItemMutation_cartUpdateItem_CartResponse };


export type UpdateCartItemMutationVariables = Exact<{
  input: CartUpdateItemInput;
  locale: Scalars['String']['input'];
  analyticsLocale: Scalars['String']['input'];
}>;


export type UpdateCartItemMutation = UpdateCartItemMutation_Mutation;

export type RootCategoriesQuery_categories_CategoryResponse_items_Category_products_ProductsResponse = { __typename: 'ProductsResponse', itemsFound: number };

export type RootCategoriesQuery_categories_CategoryResponse_items_Category_name_LocalizedString = { __typename: 'LocalizedString', language: string, value?: string | null };

export type RootCategoriesQuery_categories_CategoryResponse_items_Category_description_LocalizedString = { __typename: 'LocalizedString', language: string, value?: string | null };

export type RootCategoriesQuery_categories_CategoryResponse_items_Category_shortDescription_LocalizedString = { __typename: 'LocalizedString', language: string, value?: string | null };

export type RootCategoriesQuery_categories_CategoryResponse_items_Category_slug_LocalizedString = { __typename: 'LocalizedString', language: string, value?: string | null };

export type RootCategoriesQuery_categories_CategoryResponse_items_Category = { __typename: 'Category', categoryId: number, defaultLanguage: string, products: RootCategoriesQuery_categories_CategoryResponse_items_Category_products_ProductsResponse, name: Array<RootCategoriesQuery_categories_CategoryResponse_items_Category_name_LocalizedString>, description: Array<RootCategoriesQuery_categories_CategoryResponse_items_Category_description_LocalizedString>, shortDescription: Array<RootCategoriesQuery_categories_CategoryResponse_items_Category_shortDescription_LocalizedString>, slug: Array<RootCategoriesQuery_categories_CategoryResponse_items_Category_slug_LocalizedString> };

export type RootCategoriesQuery_categories_CategoryResponse = { __typename: 'CategoryResponse', itemsFound: number, items: Array<RootCategoriesQuery_categories_CategoryResponse_items_Category> };

export type RootCategoriesQuery_Query = { categories: RootCategoriesQuery_categories_CategoryResponse };


export type RootCategoriesQueryVariables = Exact<{
  rootCategoryId?: InputMaybe<Array<Scalars['Int']['input']>>;
}>;


export type RootCategoriesQuery = RootCategoriesQuery_Query;

export type PaymentCreateMutation_paymentCreate_Payment = { __typename: 'Payment', id: string };

export type PaymentCreateMutation_Mutation = { paymentCreate: PaymentCreateMutation_paymentCreate_Payment };


export type PaymentCreateMutationVariables = Exact<{
  input: CreatePaymentInput;
}>;


export type PaymentCreateMutation = PaymentCreateMutation_Mutation;

export type ProcessCartMutation_cartProcess_CartProcessResponse_response_CartResponseData = { __typename: 'CartResponseData', data: Record<string, unknown>, messages: Array<string> };

export type ProcessCartMutation_cartProcess_CartProcessResponse_order_Order = { __typename: 'Order', id: number, uuid: string };

export type ProcessCartMutation_cartProcess_CartProcessResponse = { __typename: 'CartProcessResponse', cartOrderId: number, response: ProcessCartMutation_cartProcess_CartProcessResponse_response_CartResponseData, order: ProcessCartMutation_cartProcess_CartProcessResponse_order_Order };

export type ProcessCartMutation_Mutation = { cartProcess: ProcessCartMutation_cartProcess_CartProcessResponse };


export type ProcessCartMutationVariables = Exact<{
  input: CartProcessInput;
}>;


export type ProcessCartMutation = ProcessCartMutation_Mutation;

export type UpdateCartAddressMutation_cartUpdateAddress_CartResponse_cart_Cart = { __typename: 'Cart', cartId: string };

export type UpdateCartAddressMutation_cartUpdateAddress_CartResponse = { __typename: 'CartResponse', cart: UpdateCartAddressMutation_cartUpdateAddress_CartResponse_cart_Cart };

export type UpdateCartAddressMutation_Mutation = { cartUpdateAddress: UpdateCartAddressMutation_cartUpdateAddress_CartResponse };


export type UpdateCartAddressMutationVariables = Exact<{
  input: CartUpdateAddressInput;
}>;


export type UpdateCartAddressMutation = UpdateCartAddressMutation_Mutation;

export type UpdateCartMutation_cartUpdate_CartResponse_cart_Cart = { __typename: 'Cart', cartId: string };

export type UpdateCartMutation_cartUpdate_CartResponse = { __typename: 'CartResponse', cart: UpdateCartMutation_cartUpdate_CartResponse_cart_Cart };

export type UpdateCartMutation_Mutation = { cartUpdate: UpdateCartMutation_cartUpdate_CartResponse };


export type UpdateCartMutationVariables = Exact<{
  input: CartUpdateInput;
}>;


export type UpdateCartMutation = UpdateCartMutation_Mutation;

export type GetCompanyAddressesQuery_addressesByCompanyId_Address = { __typename: 'Address', id: number, code?: string | null, lastName?: string | null, firstName?: string | null, street: string, number?: string | null, numberExtension?: string | null, postalCode: string, city: string, country: string, phone?: string | null, email?: string | null, icp?: YesNo | null };

export type GetCompanyAddressesQuery_Query = { addressesByCompanyId: Array<GetCompanyAddressesQuery_addressesByCompanyId_Address> };


export type GetCompanyAddressesQueryVariables = Exact<{
  companyId: Scalars['Float']['input'];
  type?: InputMaybe<AddressType>;
}>;


export type GetCompanyAddressesQuery = GetCompanyAddressesQuery_Query;

export type FavoriteListAddItemsMutation_favoriteListAddItems_FavoriteList = { __typename: 'FavoriteList', id: string };

export type FavoriteListAddItemsMutation_Mutation = { favoriteListAddItems: FavoriteListAddItemsMutation_favoriteListAddItems_FavoriteList };


export type FavoriteListAddItemsMutationVariables = Exact<{
  id: Scalars['String']['input'];
  input: FavoriteListsItemsInput;
}>;


export type FavoriteListAddItemsMutation = FavoriteListAddItemsMutation_Mutation;

export type FavoriteListCreateMutation_favoriteListCreate_FavoriteList = { __typename: 'FavoriteList', id: string };

export type FavoriteListCreateMutation_Mutation = { favoriteListCreate: FavoriteListCreateMutation_favoriteListCreate_FavoriteList };


export type FavoriteListCreateMutationVariables = Exact<{
  input: FavoriteListsCreateInput;
}>;


export type FavoriteListCreateMutation = FavoriteListCreateMutation_Mutation;

export type FavoriteListRemoveItemsMutation_favoriteListRemoveItems_FavoriteList = { __typename: 'FavoriteList', id: string };

export type FavoriteListRemoveItemsMutation_Mutation = { favoriteListRemoveItems: FavoriteListRemoveItemsMutation_favoriteListRemoveItems_FavoriteList };


export type FavoriteListRemoveItemsMutationVariables = Exact<{
  id: Scalars['String']['input'];
  input: FavoriteListsItemsInput;
}>;


export type FavoriteListRemoveItemsMutation = FavoriteListRemoveItemsMutation_Mutation;

export type FavoriteListDeleteMutation_Mutation = { favoriteListDelete: boolean };


export type FavoriteListDeleteMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type FavoriteListDeleteMutation = FavoriteListDeleteMutation_Mutation;

export type FavoriteListProductsQuery_favoriteList_FavoriteList_products_ProductsResponse_items_Cluster = { __typename: 'Cluster' };

export type FavoriteListProductsQuery_favoriteList_FavoriteList_products_ProductsResponse_items_Product = (
  { __typename: 'Product' }
  & ProductListItemFragment
);

export type FavoriteListProductsQuery_favoriteList_FavoriteList_products_ProductsResponse_items = FavoriteListProductsQuery_favoriteList_FavoriteList_products_ProductsResponse_items_Cluster | FavoriteListProductsQuery_favoriteList_FavoriteList_products_ProductsResponse_items_Product;

export type FavoriteListProductsQuery_favoriteList_FavoriteList_products_ProductsResponse = { __typename: 'ProductsResponse', itemsFound: number, items: Array<FavoriteListProductsQuery_favoriteList_FavoriteList_products_ProductsResponse_items> };

export type FavoriteListProductsQuery_favoriteList_FavoriteList = { __typename: 'FavoriteList', id: string, name: string, companyId?: number | null, contactId?: number | null, customerId?: number | null, isDefault: boolean, slug: string, createdAt: string, updatedAt: string, products?: FavoriteListProductsQuery_favoriteList_FavoriteList_products_ProductsResponse | null };

export type FavoriteListProductsQuery_Query = { favoriteList: FavoriteListProductsQuery_favoriteList_FavoriteList };


export type FavoriteListProductsQueryVariables = Exact<{
  listId: Scalars['String']['input'];
  locale: Scalars['String']['input'];
  analyticsLocale: Scalars['String']['input'];
  userId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type FavoriteListProductsQuery = FavoriteListProductsQuery_Query;

export type FavoriteListOverviewQuery_favoriteLists_FavoriteListsResponse_items_FavoriteList_products_ProductsResponse = { __typename: 'ProductsResponse', itemsFound: number };

export type FavoriteListOverviewQuery_favoriteLists_FavoriteListsResponse_items_FavoriteList_clusters_ProductsResponse = { __typename: 'ProductsResponse', itemsFound: number };

export type FavoriteListOverviewQuery_favoriteLists_FavoriteListsResponse_items_FavoriteList = { __typename: 'FavoriteList', id: string, isDefault: boolean, name: string, companyId?: number | null, contactId?: number | null, customerId?: number | null, slug: string, products?: FavoriteListOverviewQuery_favoriteLists_FavoriteListsResponse_items_FavoriteList_products_ProductsResponse | null, clusters?: FavoriteListOverviewQuery_favoriteLists_FavoriteListsResponse_items_FavoriteList_clusters_ProductsResponse | null };

export type FavoriteListOverviewQuery_favoriteLists_FavoriteListsResponse = { __typename: 'FavoriteListsResponse', items: Array<FavoriteListOverviewQuery_favoriteLists_FavoriteListsResponse_items_FavoriteList> };

export type FavoriteListOverviewQuery_Query = { favoriteLists: FavoriteListOverviewQuery_favoriteLists_FavoriteListsResponse };


export type FavoriteListOverviewQueryVariables = Exact<{
  input: FavoriteListsSearchInput;
}>;


export type FavoriteListOverviewQuery = FavoriteListOverviewQuery_Query;

export type FavoriteListUpdateNameMutation_favoriteListUpdate_FavoriteList = { __typename: 'FavoriteList', id: string };

export type FavoriteListUpdateNameMutation_Mutation = { favoriteListUpdate: FavoriteListUpdateNameMutation_favoriteListUpdate_FavoriteList };


export type FavoriteListUpdateNameMutationVariables = Exact<{
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
}>;


export type FavoriteListUpdateNameMutation = FavoriteListUpdateNameMutation_Mutation;

export type ProductCountQuery_products_ProductsResponse = { __typename: 'ProductsResponse', itemsFound: number };

export type ProductCountQuery_Query = { products: ProductCountQuery_products_ProductsResponse };


export type ProductCountQueryVariables = Exact<{ [key: string]: never; }>;


export type ProductCountQuery = ProductCountQuery_Query;

export type OrderQuery_order_Order_items_OrderItem_product_Product = { __typename: 'Product', package: string };

export type OrderQuery_order_Order_items_OrderItem = { __typename: 'OrderItem', id: number, parentOrderItemId?: number | null, productId?: number | null, sku: string, name?: string | null, quantity: number, package?: string | null, price: number, priceTotal: number, product?: OrderQuery_order_Order_items_OrderItem_product_Product | null };

export type OrderQuery_order_Order = { __typename: 'Order', id: number, status: string, items: Array<OrderQuery_order_Order_items_OrderItem> };

export type OrderQuery_Query = { order: OrderQuery_order_Order };


export type OrderQueryVariables = Exact<{
  orderUUID?: InputMaybe<Scalars['String']['input']>;
}>;


export type OrderQuery = OrderQuery_Query;

export type OrdersQuery_orders_OrderResponse_items_Order_total_OrderTotals = { __typename: 'OrderTotals', gross: number, net: number };

export type OrdersQuery_orders_OrderResponse_items_Order = { __typename: 'Order', id: number, uuid: string, externalId?: string | null, date: string, reference?: string | null, status: string, total: OrdersQuery_orders_OrderResponse_items_Order_total_OrderTotals };

export type OrdersQuery_orders_OrderResponse = { __typename: 'OrderResponse', items: Array<OrdersQuery_orders_OrderResponse_items_Order> };

export type OrdersQuery_Query = { orders: OrdersQuery_orders_OrderResponse };


export type OrdersQueryVariables = Exact<{
  input: OrderSearchArguments;
}>;


export type OrdersQuery = OrdersQuery_Query;

export type AttributeDescriptionsQuery_attributeDescription_AttributeDescriptionResponse_items_AttributeDescription_description_LocalizedString = { __typename: 'LocalizedString', language: string, value?: string | null };

export type AttributeDescriptionsQuery_attributeDescription_AttributeDescriptionResponse_items_AttributeDescription = { __typename: 'AttributeDescription', searchId: string, description: Array<AttributeDescriptionsQuery_attributeDescription_AttributeDescriptionResponse_items_AttributeDescription_description_LocalizedString> };

export type AttributeDescriptionsQuery_attributeDescription_AttributeDescriptionResponse = { __typename: 'AttributeDescriptionResponse', items: Array<AttributeDescriptionsQuery_attributeDescription_AttributeDescriptionResponse_items_AttributeDescription> };

export type AttributeDescriptionsQuery_Query = { attributeDescription: AttributeDescriptionsQuery_attributeDescription_AttributeDescriptionResponse };


export type AttributeDescriptionsQueryVariables = Exact<{ [key: string]: never; }>;


export type AttributeDescriptionsQuery = AttributeDescriptionsQuery_Query;

export type CheckProductAccessQuery_products_ProductsResponse = { __typename: 'ProductsResponse', itemsFound: number };

export type CheckProductAccessQuery_Query = { products: CheckProductAccessQuery_products_ProductsResponse };


export type CheckProductAccessQueryVariables = Exact<{
  userId: Scalars['Int']['input'];
  productId: Scalars['Int']['input'];
  status?: InputMaybe<Array<ProductStatus>>;
}>;


export type CheckProductAccessQuery = CheckProductAccessQuery_Query;

export type GetProductQuery_product_Product = (
  { __typename: 'Product' }
  & ProductDetailFragment
);

export type GetProductQuery_Query = { product: GetProductQuery_product_Product };


export type GetProductQueryVariables = Exact<{
  productId: Scalars['Int']['input'];
  locale: Scalars['String']['input'];
  analyticsLocale: Scalars['String']['input'];
}>;


export type GetProductQuery = GetProductQuery_Query;

export type ProductGetIdBySkuQuery_product_Product = { __typename: 'Product', productId: number };

export type ProductGetIdBySkuQuery_Query = { product: ProductGetIdBySkuQuery_product_Product };


export type ProductGetIdBySkuQueryVariables = Exact<{
  sku: Scalars['String']['input'];
}>;


export type ProductGetIdBySkuQuery = ProductGetIdBySkuQuery_Query;

export type SearchProductsQuery_products_ProductsResponse_items_Cluster = { __typename: 'Cluster' };

export type SearchProductsQuery_products_ProductsResponse_items_Product = (
  { __typename: 'Product' }
  & ProductListItemFragment
);

export type SearchProductsQuery_products_ProductsResponse_items = SearchProductsQuery_products_ProductsResponse_items_Cluster | SearchProductsQuery_products_ProductsResponse_items_Product;

export type SearchProductsQuery_products_ProductsResponse_filters_AttributeFilter_textFilter_AttributeTextFilter = { __typename: 'AttributeTextFilter', value: string, isSelected: boolean, count: number, countTotal?: number | null, countActive?: number | null };

export type SearchProductsQuery_products_ProductsResponse_filters_AttributeFilter_integerRangeFilter_AttributeIntegerRangeFilter = { __typename: 'AttributeIntegerRangeFilter', min: number, max: number };

export type SearchProductsQuery_products_ProductsResponse_filters_AttributeFilter_decimalRangeFilter_AttributeDecimalRangeFilter = { __typename: 'AttributeDecimalRangeFilter', min: number, max: number };

export type SearchProductsQuery_products_ProductsResponse_filters_AttributeFilter = { __typename: 'AttributeFilter', id: string, searchId: string, description: string, type: AttributeType, textFilter?: Array<SearchProductsQuery_products_ProductsResponse_filters_AttributeFilter_textFilter_AttributeTextFilter> | null, integerRangeFilter?: SearchProductsQuery_products_ProductsResponse_filters_AttributeFilter_integerRangeFilter_AttributeIntegerRangeFilter | null, decimalRangeFilter?: SearchProductsQuery_products_ProductsResponse_filters_AttributeFilter_decimalRangeFilter_AttributeDecimalRangeFilter | null };

export type SearchProductsQuery_products_ProductsResponse = { __typename: 'ProductsResponse', page: number, pages: number, start: number, end: number, offset: number, minPrice: number, maxPrice: number, itemsFound: number, items: Array<SearchProductsQuery_products_ProductsResponse_items>, filters?: Array<SearchProductsQuery_products_ProductsResponse_filters_AttributeFilter> | null };

export type SearchProductsQuery_Query = { products: SearchProductsQuery_products_ProductsResponse };


export type SearchProductsQueryVariables = Exact<{
  userId: Scalars['Int']['input'];
  locale: Scalars['String']['input'];
  analyticsLocale: Scalars['String']['input'];
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  term?: InputMaybe<Scalars['String']['input']>;
  sku?: InputMaybe<Array<Scalars['String']['input']>>;
  productIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  textFilters?: InputMaybe<Array<TextFilterInput>>;
  rangeFilters?: InputMaybe<Array<RangeFilterInput>>;
  priceFilter?: InputMaybe<PriceFilterInput>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  status?: InputMaybe<Array<ProductStatus>>;
  sort?: InputMaybe<Array<SortInput>>;
}>;


export type SearchProductsQuery = SearchProductsQuery_Query;

export type SelectionProductsQuery_favoriteList_FavoriteList_products_ProductsResponse_items_Cluster = { __typename: 'Cluster' };

export type SelectionProductsQuery_favoriteList_FavoriteList_products_ProductsResponse_items_Product = { __typename: 'Product', productId: number };

export type SelectionProductsQuery_favoriteList_FavoriteList_products_ProductsResponse_items = SelectionProductsQuery_favoriteList_FavoriteList_products_ProductsResponse_items_Cluster | SelectionProductsQuery_favoriteList_FavoriteList_products_ProductsResponse_items_Product;

export type SelectionProductsQuery_favoriteList_FavoriteList_products_ProductsResponse = { __typename: 'ProductsResponse', items: Array<SelectionProductsQuery_favoriteList_FavoriteList_products_ProductsResponse_items> };

export type SelectionProductsQuery_favoriteList_FavoriteList = { __typename: 'FavoriteList', id: string, name: string, companyId?: number | null, products?: SelectionProductsQuery_favoriteList_FavoriteList_products_ProductsResponse | null };

export type SelectionProductsQuery_Query = { favoriteList: SelectionProductsQuery_favoriteList_FavoriteList };


export type SelectionProductsQueryVariables = Exact<{
  listId: Scalars['String']['input'];
  userId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SelectionProductsQuery = SelectionProductsQuery_Query;

export type SearchSuggestionQuery_products_ProductsResponse_items_Cluster = { __typename: 'Cluster' };

export type SearchSuggestionQuery_products_ProductsResponse_items_Product = (
  { __typename: 'Product' }
  & ProductListItemFragment
);

export type SearchSuggestionQuery_products_ProductsResponse_items = SearchSuggestionQuery_products_ProductsResponse_items_Cluster | SearchSuggestionQuery_products_ProductsResponse_items_Product;

export type SearchSuggestionQuery_products_ProductsResponse = { __typename: 'ProductsResponse', items: Array<SearchSuggestionQuery_products_ProductsResponse_items> };

export type SearchSuggestionQuery_Query = { products: SearchSuggestionQuery_products_ProductsResponse };


export type SearchSuggestionQueryVariables = Exact<{
  userId: Scalars['Int']['input'];
  locale: Scalars['String']['input'];
  analyticsLocale: Scalars['String']['input'];
  term?: InputMaybe<Scalars['String']['input']>;
  searchFields?: InputMaybe<Array<SearchFieldsInput>>;
  status?: InputMaybe<Array<ProductStatus>>;
  sort?: InputMaybe<Array<SortInput>>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
}>;


export type SearchSuggestionQuery = SearchSuggestionQuery_Query;

export type AuthenticationAccountDatesQuery_authentication_GCIPUser_metadata_GCIPMetadata = { __typename: 'GCIPMetadata', creationTime?: string | null, lastSignInTime?: string | null, lastRefreshTime?: string | null };

export type AuthenticationAccountDatesQuery_authentication_GCIPUser = { __typename: 'GCIPUser', metadata?: AuthenticationAccountDatesQuery_authentication_GCIPUser_metadata_GCIPMetadata | null };

export type AuthenticationAccountDatesQuery_Query = { authentication: AuthenticationAccountDatesQuery_authentication_GCIPUser };


export type AuthenticationAccountDatesQueryVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type AuthenticationAccountDatesQuery = AuthenticationAccountDatesQuery_Query;

export type OrderSetStatusMutation_orderSetStatus_Order = { __typename: 'Order', id: number };

export type OrderSetStatusMutation_Mutation = { orderSetStatus: OrderSetStatusMutation_orderSetStatus_Order };


export type OrderSetStatusMutationVariables = Exact<{
  input: OrderSetStatusInput;
}>;


export type OrderSetStatusMutation = OrderSetStatusMutation_Mutation;

export type PaymentUpdateMutation_paymentUpdate_Payment = { __typename: 'Payment', id: string };

export type PaymentUpdateMutation_Mutation = { paymentUpdate: PaymentUpdateMutation_paymentUpdate_Payment };


export type PaymentUpdateMutationVariables = Exact<{
  search: SearchByInput;
  input: UpdatePaymentInput;
}>;


export type PaymentUpdateMutation = PaymentUpdateMutation_Mutation;

export type GetProductUrlDataBySkuQuery_product_Product_slug_LocalizedString = { __typename: 'LocalizedString', language: string, value?: string | null };

export type GetProductUrlDataBySkuQuery_product_Product = { __typename: 'Product', productId: number, slug: Array<GetProductUrlDataBySkuQuery_product_Product_slug_LocalizedString> };

export type GetProductUrlDataBySkuQuery_Query = { product: GetProductUrlDataBySkuQuery_product_Product };


export type GetProductUrlDataBySkuQueryVariables = Exact<{
  sku: Scalars['String']['input'];
  locale: Scalars['String']['input'];
}>;


export type GetProductUrlDataBySkuQuery = GetProductUrlDataBySkuQuery_Query;

export const ProductImagesFragmentDoc = gql`
    fragment ProductImages on Product {
  media {
    images {
      items {
        alt(language: $locale) {
          language
          value
        }
        images {
          language
          originalUrl
          mimeType
        }
      }
    }
  }
}
    `;
export const ProductListItemFragmentDoc = gql`
    fragment ProductListItem on Product {
  __typename
  productId
  categoryId
  taxCode
  status
  priceDisplay
  supplierCode
  sku
  slug(language: $locale) {
    language
    value
  }
  name(language: $locale) {
    language
    value
  }
  package
  minimumOrderQuantity: minimumQuantity
  incrementalOrderQuantity: unit
  ...ProductImages
  analyticsName: name(language: $analyticsLocale) {
    value
  }
  analyticsBrandAttribute: attributeValues(filter: {offset: 1, name: "BRAND"}) {
    items {
      attributeId
      textValue(language: $analyticsLocale) {
        values
      }
    }
  }
  analyticsCategoryPath: categoryPath {
    categoryId
    analyticsName: name(language: $analyticsLocale) {
      value
    }
  }
}
    ${ProductImagesFragmentDoc}`;
export const Custom_CartFragmentDoc = gql`
    fragment Custom_Cart on Cart {
  cartId
  userId
  channelId
  notes
  reference
  orderStatus
  actionCode
  total {
    totalGross
    totalNet
  }
  postageData {
    shippingMethod
    requestDate
    postage
    postageNet
  }
  taxLevels {
    taxCode
    price
  }
  deliveryAddress {
    code
    lastName
    firstName
    street
    number
    postalCode
    city
    country
    phone
    email
  }
  items {
    id
    productId
    taxCode
    quantity
    price
    priceNet
    totalPrice
    totalPriceNet
    totalSum
    totalSumNet
    sum
    sumNet
    notes
    product {
      ...ProductListItem
    }
    childItems {
      id
      productId
      taxCode
      quantity
      price
      priceNet
      totalPrice
      totalPriceNet
      product {
        id
        sku
        package
      }
    }
  }
}
    ${ProductListItemFragmentDoc}`;
export const ProductAttributesFragmentDoc = gql`
    fragment ProductAttributes on Product {
  attributeValues(filter: {isHidden: false, offset: 100}) {
    itemsFound
    items {
      attributeId
      textValue(language: $locale) {
        language
        values
      }
      enumValue
      intValue
      decimalValue
      dateValue
      attributeDescription {
        name
        id
        searchId
        description(language: $locale) {
          language
          value
        }
        type
        typeParam
        group
      }
    }
  }
}
    `;
export const ProductDetailFragmentDoc = gql`
    fragment ProductDetail on Product {
  ...ProductListItem
  ...ProductAttributes
  shortDescription(language: $locale) {
    language
    value
  }
}
    ${ProductListItemFragmentDoc}
${ProductAttributesFragmentDoc}`;
export const LoginDocument = gql`
    mutation Login($email: String!, $password: String!) {
  login(input: {email: $email, password: $password}) {
    session {
      uid
      isAnonymous
      email
      accessToken
      refreshToken
      expirationTime
    }
  }
}
    `;
export const RefreshTokenDocument = gql`
    mutation refreshToken($refreshToken: String!) {
  exchangeRefreshToken(input: {refreshToken: $refreshToken}) {
    access_token
    refresh_token
    expires_in
  }
}
    `;
export const ContactUpdateDocument = gql`
    mutation contactUpdate($input: UpdateContactInput!) {
  contactUpdate(input: $input) {
    id
  }
}
    `;
export const ContactCartIdDocument = gql`
    query contactCartId($contactId: Float!) {
  contact(contactId: $contactId) {
    __typename
    attributeValues(filter: {name: ["APP_CART_ID"]}) {
      items {
        __typename
        attributeId
        attributeDescription {
          name
        }
        textValue(language: "en") {
          values
        }
      }
    }
  }
}
    `;
export const ContactDocument = gql`
    query contact($contactId: Float!) {
  contact(contactId: $contactId) {
    __typename
    contactId
    firstName
    lastName
    email
    primaryLanguage
    parentCompanyId
    company {
      name
      addresses(type: invoice) {
        id
        country
      }
    }
    attributeValues(
      filter: {name: ["SALESPERSON_CODE", "NAV_CUSTOMER_CODE", "NAV_ICP", "ORDER_CUTOFF_HOUR", "FREE_OF_EXCISE", "DEFAULT_DELIVERY_METHOD", "REQUIRE_ONLINE_PAYMENT", "APP_CART_ID", "IGNORE_HIDE_ITEM_ON_WEBSHOP"]}
    ) {
      items {
        __typename
        attributeId
        attributeDescription {
          name
        }
        textValue {
          language
          values
        }
        intValue
      }
    }
  }
}
    `;
export const PasswordResetLinkDocument = gql`
    mutation passwordResetLink($email: String!, $lang: String!, $redirectUrl: String!) {
  passwordResetLink(
    input: {email: $email, language: $lang, redirectUrl: $redirectUrl}
  )
}
    `;
export const AddCartItemDocument = gql`
    mutation addCartItem($input: CartAddItemInput!, $locale: String!, $analyticsLocale: String!) {
  cartAddItem(input: $input) {
    cart {
      ...Custom_Cart
    }
  }
}
    ${Custom_CartFragmentDoc}`;
export const CreateCartDocument = gql`
    mutation createCart($userId: Int!) {
  cartStart(userId: $userId) {
    cartId
  }
}
    `;
export const DeleteCartItemDocument = gql`
    mutation deleteCartItem($cartId: String!, $itemId: Int!, $locale: String!, $analyticsLocale: String!) {
  cartDeleteItem(input: {cartId: $cartId, itemId: $itemId}) {
    cart {
      ...Custom_Cart
    }
  }
}
    ${Custom_CartFragmentDoc}`;
export const DeleteCartDocument = gql`
    mutation deleteCart($cartId: String!) {
  cartDelete(cartId: $cartId) {
    success
    message
  }
}
    `;
export const GetCartLinesBasicDocument = gql`
    query getCartLinesBasic($cartId: String!) {
  cart(cartId: $cartId) {
    items {
      id
      notes
      product {
        sku
      }
    }
  }
}
    `;
export const GetCartDocument = gql`
    query getCart($cartId: String!, $locale: String!, $analyticsLocale: String!) {
  cart(cartId: $cartId) {
    ...Custom_Cart
  }
}
    ${Custom_CartFragmentDoc}`;
export const GetOrderStatusDocument = gql`
    query getOrderStatus($orderId: Int, $orderUUID: String) {
  order(orderId: $orderId, orderUUID: $orderUUID) {
    id
    status
  }
}
    `;
export const GetPaymentStatusDocument = gql`
    query getPaymentStatus($orderId: Float, $paymentId: String) {
  payment(searchBy: {paymentId: $paymentId, orderId: $orderId}) {
    id
    paymentId
    status
    amount
  }
}
    `;
export const UpdateCartItemVoidDocument = gql`
    mutation updateCartItemVoid($input: CartUpdateItemInput!) {
  cartUpdateItem(input: $input) {
    cart {
      cartId
    }
  }
}
    `;
export const UpdateCartItemDocument = gql`
    mutation updateCartItem($input: CartUpdateItemInput!, $locale: String!, $analyticsLocale: String!) {
  cartUpdateItem(input: $input) {
    cart {
      ...Custom_Cart
    }
  }
}
    ${Custom_CartFragmentDoc}`;
export const RootCategoriesDocument = gql`
    query rootCategories($rootCategoryId: [Int!]) {
  categories(filter: {parentCategoryId: $rootCategoryId}) {
    itemsFound
    items {
      products {
        itemsFound
      }
      categoryId
      defaultLanguage
      name {
        language
        value
      }
      description {
        language
        value
      }
      shortDescription {
        language
        value
      }
      slug {
        language
        value
      }
    }
  }
}
    `;
export const PaymentCreateDocument = gql`
    mutation paymentCreate($input: CreatePaymentInput!) {
  paymentCreate(input: $input) {
    id
  }
}
    `;
export const ProcessCartDocument = gql`
    mutation processCart($input: CartProcessInput!) {
  cartProcess(input: $input) {
    cartOrderId
    response {
      data
      messages
    }
    order {
      id
      uuid
    }
  }
}
    `;
export const UpdateCartAddressDocument = gql`
    mutation updateCartAddress($input: CartUpdateAddressInput!) {
  cartUpdateAddress(input: $input) {
    cart {
      cartId
    }
  }
}
    `;
export const UpdateCartDocument = gql`
    mutation updateCart($input: CartUpdateInput!) {
  cartUpdate(input: $input) {
    cart {
      cartId
    }
  }
}
    `;
export const GetCompanyAddressesDocument = gql`
    query getCompanyAddresses($companyId: Float!, $type: AddressType) {
  addressesByCompanyId(companyId: $companyId, type: $type) {
    id
    code
    lastName
    firstName
    street
    number
    numberExtension
    postalCode
    city
    country
    phone
    email
    icp
  }
}
    `;
export const FavoriteListAddItemsDocument = gql`
    mutation favoriteListAddItems($id: String!, $input: FavoriteListsItemsInput!) {
  favoriteListAddItems(id: $id, input: $input) {
    id
  }
}
    `;
export const FavoriteListCreateDocument = gql`
    mutation favoriteListCreate($input: FavoriteListsCreateInput!) {
  favoriteListCreate(input: $input) {
    id
  }
}
    `;
export const FavoriteListRemoveItemsDocument = gql`
    mutation favoriteListRemoveItems($id: String!, $input: FavoriteListsItemsInput!) {
  favoriteListRemoveItems(id: $id, input: $input) {
    id
  }
}
    `;
export const FavoriteListDeleteDocument = gql`
    mutation favoriteListDelete($id: String!) {
  favoriteListDelete(id: $id)
}
    `;
export const FavoriteListProductsDocument = gql`
    query favoriteListProducts($listId: String!, $locale: String!, $analyticsLocale: String!, $userId: Int) {
  favoriteList(id: $listId) {
    id
    name
    companyId
    contactId
    customerId
    isDefault
    slug
    createdAt
    updatedAt
    products(userId: $userId, offset: 10000) {
      itemsFound
      items {
        ...ProductListItem
      }
    }
  }
}
    ${ProductListItemFragmentDoc}`;
export const FavoriteListOverviewDocument = gql`
    query favoriteListOverview($input: FavoriteListsSearchInput!) {
  favoriteLists(input: $input) {
    items {
      id
      isDefault
      name
      companyId
      contactId
      customerId
      slug
      products {
        itemsFound
      }
      clusters {
        itemsFound
      }
    }
  }
}
    `;
export const FavoriteListUpdateNameDocument = gql`
    mutation favoriteListUpdateName($id: String!, $name: String!) {
  favoriteListUpdate(id: $id, input: {name: $name}) {
    id
  }
}
    `;
export const ProductCountDocument = gql`
    query productCount {
  products {
    itemsFound
  }
}
    `;
export const OrderDocument = gql`
    query order($orderUUID: String) {
  order(orderUUID: $orderUUID) {
    id
    status
    items {
      id
      parentOrderItemId
      productId
      sku
      name
      quantity
      package
      price
      priceTotal
      product {
        package
      }
    }
  }
}
    `;
export const OrdersDocument = gql`
    query orders($input: OrderSearchArguments!) {
  orders(input: $input) {
    items {
      id
      uuid
      externalId
      date
      reference
      status
      total {
        gross
        net
      }
    }
  }
}
    `;
export const AttributeDescriptionsDocument = gql`
    query attributeDescriptions {
  attributeDescription(input: {class: "product", isPublic: true, offset: 100}) {
    items {
      searchId
      description {
        language
        value
      }
    }
  }
}
    `;
export const CheckProductAccessDocument = gql`
    query checkProductAccess($userId: Int!, $productId: Int!, $status: [ProductStatus!]) {
  products(userId: $userId, classId: [$productId], status: $status) {
    itemsFound
  }
}
    `;
export const GetProductDocument = gql`
    query getProduct($productId: Int!, $locale: String!, $analyticsLocale: String!) {
  product(productId: $productId, language: $locale) {
    ...ProductDetail
  }
}
    ${ProductDetailFragmentDoc}`;
export const ProductGetIdBySkuDocument = gql`
    query productGetIdBySku($sku: String!) {
  product(sku: $sku) {
    productId
  }
}
    `;
export const SearchProductsDocument = gql`
    query searchProducts($userId: Int!, $locale: String!, $analyticsLocale: String!, $categoryId: Int, $term: String, $sku: [String!], $productIds: [Int!], $textFilters: [TextFilterInput!], $rangeFilters: [RangeFilterInput!], $priceFilter: PriceFilterInput, $page: Int, $pageSize: Int, $status: [ProductStatus!], $sort: [SortInput!]) {
  products(
    userId: $userId
    language: $locale
    categoryId: $categoryId
    term: $term
    sku: $sku
    classId: $productIds
    textFilters: $textFilters
    rangeFilters: $rangeFilters
    price: $priceFilter
    page: $page
    offset: $pageSize
    status: $status
    sort: $sort
  ) {
    page
    pages
    start
    end
    offset
    minPrice
    maxPrice
    itemsFound
    items {
      ...ProductListItem
    }
    filters {
      id
      searchId
      description
      type
      textFilter {
        value
        isSelected
        count
        countTotal
        countActive
      }
      integerRangeFilter {
        min
        max
      }
      decimalRangeFilter {
        min
        max
      }
    }
  }
}
    ${ProductListItemFragmentDoc}`;
export const SelectionProductsDocument = gql`
    query selectionProducts($listId: String!, $userId: Int) {
  favoriteList(id: $listId) {
    id
    name
    companyId
    products(userId: $userId, offset: 10000) {
      items {
        __typename
        ... on IProduct {
          productId
        }
      }
    }
  }
}
    `;
export const SearchSuggestionDocument = gql`
    query searchSuggestion($userId: Int!, $locale: String!, $analyticsLocale: String!, $term: String, $searchFields: [SearchFieldsInput!], $status: [ProductStatus!], $sort: [SortInput!], $pageSize: Int) {
  products(
    userId: $userId
    language: $locale
    term: $term
    searchFields: $searchFields
    status: $status
    offset: $pageSize
    sort: $sort
  ) {
    items {
      ...ProductListItem
    }
  }
}
    ${ProductListItemFragmentDoc}`;
export const AuthenticationAccountDatesDocument = gql`
    query authenticationAccountDates($email: String!) {
  authentication(email: $email) {
    metadata {
      creationTime
      lastSignInTime
      lastRefreshTime
    }
  }
}
    `;
export const OrderSetStatusDocument = gql`
    mutation orderSetStatus($input: OrderSetStatusInput!) {
  orderSetStatus(input: $input) {
    id
  }
}
    `;
export const PaymentUpdateDocument = gql`
    mutation paymentUpdate($search: SearchByInput!, $input: UpdatePaymentInput!) {
  paymentUpdate(searchBy: $search, input: $input) {
    id
  }
}
    `;
export const GetProductUrlDataBySkuDocument = gql`
    query getProductUrlDataBySku($sku: String!, $locale: String!) {
  product(sku: $sku, language: $locale) {
    productId
    slug(language: $locale) {
      language
      value
    }
  }
}
    `;

export type SdkFunctionWrapper = <T>(action: (requestHeaders?:Record<string, string>) => Promise<T>, operationName: string, operationType?: string, variables?: any) => Promise<T>;


const defaultWrapper: SdkFunctionWrapper = (action, _operationName, _operationType, _variables) => action();

export function getSdk(client: GraphQLClient, withWrapper: SdkFunctionWrapper = defaultWrapper) {
  return {
    Login(variables: LoginMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<LoginMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<LoginMutation>(LoginDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'Login', 'mutation', variables);
    },
    refreshToken(variables: RefreshTokenMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RefreshTokenMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<RefreshTokenMutation>(RefreshTokenDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'refreshToken', 'mutation', variables);
    },
    contactUpdate(variables: ContactUpdateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ContactUpdateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ContactUpdateMutation>(ContactUpdateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'contactUpdate', 'mutation', variables);
    },
    contactCartId(variables: ContactCartIdQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ContactCartIdQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ContactCartIdQuery>(ContactCartIdDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'contactCartId', 'query', variables);
    },
    contact(variables: ContactQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ContactQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ContactQuery>(ContactDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'contact', 'query', variables);
    },
    passwordResetLink(variables: PasswordResetLinkMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<PasswordResetLinkMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<PasswordResetLinkMutation>(PasswordResetLinkDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'passwordResetLink', 'mutation', variables);
    },
    addCartItem(variables: AddCartItemMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AddCartItemMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<AddCartItemMutation>(AddCartItemDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'addCartItem', 'mutation', variables);
    },
    createCart(variables: CreateCartMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CreateCartMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<CreateCartMutation>(CreateCartDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'createCart', 'mutation', variables);
    },
    deleteCartItem(variables: DeleteCartItemMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DeleteCartItemMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteCartItemMutation>(DeleteCartItemDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteCartItem', 'mutation', variables);
    },
    deleteCart(variables: DeleteCartMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<DeleteCartMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<DeleteCartMutation>(DeleteCartDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'deleteCart', 'mutation', variables);
    },
    getCartLinesBasic(variables: GetCartLinesBasicQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetCartLinesBasicQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetCartLinesBasicQuery>(GetCartLinesBasicDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getCartLinesBasic', 'query', variables);
    },
    getCart(variables: GetCartQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetCartQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetCartQuery>(GetCartDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getCart', 'query', variables);
    },
    getOrderStatus(variables?: GetOrderStatusQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetOrderStatusQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetOrderStatusQuery>(GetOrderStatusDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getOrderStatus', 'query', variables);
    },
    getPaymentStatus(variables?: GetPaymentStatusQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetPaymentStatusQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetPaymentStatusQuery>(GetPaymentStatusDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getPaymentStatus', 'query', variables);
    },
    updateCartItemVoid(variables: UpdateCartItemVoidMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateCartItemVoidMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateCartItemVoidMutation>(UpdateCartItemVoidDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateCartItemVoid', 'mutation', variables);
    },
    updateCartItem(variables: UpdateCartItemMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateCartItemMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateCartItemMutation>(UpdateCartItemDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateCartItem', 'mutation', variables);
    },
    rootCategories(variables?: RootCategoriesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<RootCategoriesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<RootCategoriesQuery>(RootCategoriesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'rootCategories', 'query', variables);
    },
    paymentCreate(variables: PaymentCreateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<PaymentCreateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<PaymentCreateMutation>(PaymentCreateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'paymentCreate', 'mutation', variables);
    },
    processCart(variables: ProcessCartMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ProcessCartMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<ProcessCartMutation>(ProcessCartDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'processCart', 'mutation', variables);
    },
    updateCartAddress(variables: UpdateCartAddressMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateCartAddressMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateCartAddressMutation>(UpdateCartAddressDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateCartAddress', 'mutation', variables);
    },
    updateCart(variables: UpdateCartMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<UpdateCartMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<UpdateCartMutation>(UpdateCartDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'updateCart', 'mutation', variables);
    },
    getCompanyAddresses(variables: GetCompanyAddressesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetCompanyAddressesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetCompanyAddressesQuery>(GetCompanyAddressesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getCompanyAddresses', 'query', variables);
    },
    favoriteListAddItems(variables: FavoriteListAddItemsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<FavoriteListAddItemsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<FavoriteListAddItemsMutation>(FavoriteListAddItemsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'favoriteListAddItems', 'mutation', variables);
    },
    favoriteListCreate(variables: FavoriteListCreateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<FavoriteListCreateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<FavoriteListCreateMutation>(FavoriteListCreateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'favoriteListCreate', 'mutation', variables);
    },
    favoriteListRemoveItems(variables: FavoriteListRemoveItemsMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<FavoriteListRemoveItemsMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<FavoriteListRemoveItemsMutation>(FavoriteListRemoveItemsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'favoriteListRemoveItems', 'mutation', variables);
    },
    favoriteListDelete(variables: FavoriteListDeleteMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<FavoriteListDeleteMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<FavoriteListDeleteMutation>(FavoriteListDeleteDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'favoriteListDelete', 'mutation', variables);
    },
    favoriteListProducts(variables: FavoriteListProductsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<FavoriteListProductsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FavoriteListProductsQuery>(FavoriteListProductsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'favoriteListProducts', 'query', variables);
    },
    favoriteListOverview(variables: FavoriteListOverviewQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<FavoriteListOverviewQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<FavoriteListOverviewQuery>(FavoriteListOverviewDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'favoriteListOverview', 'query', variables);
    },
    favoriteListUpdateName(variables: FavoriteListUpdateNameMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<FavoriteListUpdateNameMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<FavoriteListUpdateNameMutation>(FavoriteListUpdateNameDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'favoriteListUpdateName', 'mutation', variables);
    },
    productCount(variables?: ProductCountQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ProductCountQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ProductCountQuery>(ProductCountDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'productCount', 'query', variables);
    },
    order(variables?: OrderQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OrderQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<OrderQuery>(OrderDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'order', 'query', variables);
    },
    orders(variables: OrdersQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OrdersQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<OrdersQuery>(OrdersDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'orders', 'query', variables);
    },
    attributeDescriptions(variables?: AttributeDescriptionsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AttributeDescriptionsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AttributeDescriptionsQuery>(AttributeDescriptionsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'attributeDescriptions', 'query', variables);
    },
    checkProductAccess(variables: CheckProductAccessQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<CheckProductAccessQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<CheckProductAccessQuery>(CheckProductAccessDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'checkProductAccess', 'query', variables);
    },
    getProduct(variables: GetProductQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetProductQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetProductQuery>(GetProductDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getProduct', 'query', variables);
    },
    productGetIdBySku(variables: ProductGetIdBySkuQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<ProductGetIdBySkuQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<ProductGetIdBySkuQuery>(ProductGetIdBySkuDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'productGetIdBySku', 'query', variables);
    },
    searchProducts(variables: SearchProductsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SearchProductsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SearchProductsQuery>(SearchProductsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'searchProducts', 'query', variables);
    },
    selectionProducts(variables: SelectionProductsQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SelectionProductsQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SelectionProductsQuery>(SelectionProductsDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'selectionProducts', 'query', variables);
    },
    searchSuggestion(variables: SearchSuggestionQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<SearchSuggestionQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<SearchSuggestionQuery>(SearchSuggestionDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'searchSuggestion', 'query', variables);
    },
    authenticationAccountDates(variables: AuthenticationAccountDatesQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<AuthenticationAccountDatesQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<AuthenticationAccountDatesQuery>(AuthenticationAccountDatesDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'authenticationAccountDates', 'query', variables);
    },
    orderSetStatus(variables: OrderSetStatusMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<OrderSetStatusMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<OrderSetStatusMutation>(OrderSetStatusDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'orderSetStatus', 'mutation', variables);
    },
    paymentUpdate(variables: PaymentUpdateMutationVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<PaymentUpdateMutation> {
      return withWrapper((wrappedRequestHeaders) => client.request<PaymentUpdateMutation>(PaymentUpdateDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'paymentUpdate', 'mutation', variables);
    },
    getProductUrlDataBySku(variables: GetProductUrlDataBySkuQueryVariables, requestHeaders?: GraphQLClientRequestHeaders): Promise<GetProductUrlDataBySkuQuery> {
      return withWrapper((wrappedRequestHeaders) => client.request<GetProductUrlDataBySkuQuery>(GetProductUrlDataBySkuDocument, variables, {...requestHeaders, ...wrappedRequestHeaders}), 'getProductUrlDataBySku', 'query', variables);
    }
  };
}
export type Sdk = ReturnType<typeof getSdk>;